(function() {
  "use strict";
  function getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
  }
  var jsxRuntime = { exports: {} };
  var reactJsxRuntime_production_min = {};
  var react = { exports: {} };
  var react_production_min = {};
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var l$1 = Symbol.for("react.element"), n$1 = Symbol.for("react.portal"), p$2 = Symbol.for("react.fragment"), q$1 = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t$1 = Symbol.for("react.provider"), u = Symbol.for("react.context"), v$1 = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z$1 = Symbol.iterator;
  function A$1(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z$1 && a[z$1] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }
  var B$1 = { isMounted: function() {
    return false;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, C$1 = Object.assign, D$1 = {};
  function E$1(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D$1;
    this.updater = e || B$1;
  }
  E$1.prototype.isReactComponent = {};
  E$1.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
  };
  E$1.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
  };
  function F() {
  }
  F.prototype = E$1.prototype;
  function G$1(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D$1;
    this.updater = e || B$1;
  }
  var H$1 = G$1.prototype = new F();
  H$1.constructor = G$1;
  C$1(H$1, E$1.prototype);
  H$1.isPureReactComponent = true;
  var I$1 = Array.isArray, J = Object.prototype.hasOwnProperty, K$1 = { current: null }, L$1 = { key: true, ref: true, __self: true, __source: true };
  function M$1(a, b, e) {
    var d, c = {}, k2 = null, h = null;
    if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k2 = "" + b.key), b) J.call(b, d) && !L$1.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
      for (var f2 = Array(g), m2 = 0; m2 < g; m2++) f2[m2] = arguments[m2 + 2];
      c.children = f2;
    }
    if (a && a.defaultProps) for (d in g = a.defaultProps, g) void 0 === c[d] && (c[d] = g[d]);
    return { $$typeof: l$1, type: a, key: k2, ref: h, props: c, _owner: K$1.current };
  }
  function N$1(a, b) {
    return { $$typeof: l$1, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
  }
  function O$1(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l$1;
  }
  function escape(a) {
    var b = { "=": "=0", ":": "=2" };
    return "$" + a.replace(/[=:]/g, function(a2) {
      return b[a2];
    });
  }
  var P$1 = /\/+/g;
  function Q$1(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
  }
  function R$1(a, b, e, d, c) {
    var k2 = typeof a;
    if ("undefined" === k2 || "boolean" === k2) a = null;
    var h = false;
    if (null === a) h = true;
    else switch (k2) {
      case "string":
      case "number":
        h = true;
        break;
      case "object":
        switch (a.$$typeof) {
          case l$1:
          case n$1:
            h = true;
        }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q$1(h, 0) : d, I$1(c) ? (e = "", null != a && (e = a.replace(P$1, "$&/") + "/"), R$1(c, b, e, "", function(a2) {
      return a2;
    })) : null != c && (O$1(c) && (c = N$1(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P$1, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I$1(a)) for (var g = 0; g < a.length; g++) {
      k2 = a[g];
      var f2 = d + Q$1(k2, g);
      h += R$1(k2, b, e, f2, c);
    }
    else if (f2 = A$1(a), "function" === typeof f2) for (a = f2.call(a), g = 0; !(k2 = a.next()).done; ) k2 = k2.value, f2 = d + Q$1(k2, g++), h += R$1(k2, b, e, f2, c);
    else if ("object" === k2) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
  }
  function S$1(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R$1(a, d, "", "", function(a2) {
      return b.call(e, a2, c++);
    });
    return d;
  }
  function T$1(a) {
    if (-1 === a._status) {
      var b = a._result;
      b = b();
      b.then(function(b2) {
        if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
      }, function(b2) {
        if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
      });
      -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
  }
  var U$1 = { current: null }, V$1 = { transition: null }, W$1 = { ReactCurrentDispatcher: U$1, ReactCurrentBatchConfig: V$1, ReactCurrentOwner: K$1 };
  function X$1() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  react_production_min.Children = { map: S$1, forEach: function(a, b, e) {
    S$1(a, function() {
      b.apply(this, arguments);
    }, e);
  }, count: function(a) {
    var b = 0;
    S$1(a, function() {
      b++;
    });
    return b;
  }, toArray: function(a) {
    return S$1(a, function(a2) {
      return a2;
    }) || [];
  }, only: function(a) {
    if (!O$1(a)) throw Error("React.Children.only expected to receive a single React element child.");
    return a;
  } };
  react_production_min.Component = E$1;
  react_production_min.Fragment = p$2;
  react_production_min.Profiler = r;
  react_production_min.PureComponent = G$1;
  react_production_min.StrictMode = q$1;
  react_production_min.Suspense = w;
  react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W$1;
  react_production_min.act = X$1;
  react_production_min.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C$1({}, a.props), c = a.key, k2 = a.ref, h = a._owner;
    if (null != b) {
      void 0 !== b.ref && (k2 = b.ref, h = K$1.current);
      void 0 !== b.key && (c = "" + b.key);
      if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
      for (f2 in b) J.call(b, f2) && !L$1.hasOwnProperty(f2) && (d[f2] = void 0 === b[f2] && void 0 !== g ? g[f2] : b[f2]);
    }
    var f2 = arguments.length - 2;
    if (1 === f2) d.children = e;
    else if (1 < f2) {
      g = Array(f2);
      for (var m2 = 0; m2 < f2; m2++) g[m2] = arguments[m2 + 2];
      d.children = g;
    }
    return { $$typeof: l$1, type: a.type, key: c, ref: k2, props: d, _owner: h };
  };
  react_production_min.createContext = function(a) {
    a = { $$typeof: u, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
    a.Provider = { $$typeof: t$1, _context: a };
    return a.Consumer = a;
  };
  react_production_min.createElement = M$1;
  react_production_min.createFactory = function(a) {
    var b = M$1.bind(null, a);
    b.type = a;
    return b;
  };
  react_production_min.createRef = function() {
    return { current: null };
  };
  react_production_min.forwardRef = function(a) {
    return { $$typeof: v$1, render: a };
  };
  react_production_min.isValidElement = O$1;
  react_production_min.lazy = function(a) {
    return { $$typeof: y, _payload: { _status: -1, _result: a }, _init: T$1 };
  };
  react_production_min.memo = function(a, b) {
    return { $$typeof: x, type: a, compare: void 0 === b ? null : b };
  };
  react_production_min.startTransition = function(a) {
    var b = V$1.transition;
    V$1.transition = {};
    try {
      a();
    } finally {
      V$1.transition = b;
    }
  };
  react_production_min.unstable_act = X$1;
  react_production_min.useCallback = function(a, b) {
    return U$1.current.useCallback(a, b);
  };
  react_production_min.useContext = function(a) {
    return U$1.current.useContext(a);
  };
  react_production_min.useDebugValue = function() {
  };
  react_production_min.useDeferredValue = function(a) {
    return U$1.current.useDeferredValue(a);
  };
  react_production_min.useEffect = function(a, b) {
    return U$1.current.useEffect(a, b);
  };
  react_production_min.useId = function() {
    return U$1.current.useId();
  };
  react_production_min.useImperativeHandle = function(a, b, e) {
    return U$1.current.useImperativeHandle(a, b, e);
  };
  react_production_min.useInsertionEffect = function(a, b) {
    return U$1.current.useInsertionEffect(a, b);
  };
  react_production_min.useLayoutEffect = function(a, b) {
    return U$1.current.useLayoutEffect(a, b);
  };
  react_production_min.useMemo = function(a, b) {
    return U$1.current.useMemo(a, b);
  };
  react_production_min.useReducer = function(a, b, e) {
    return U$1.current.useReducer(a, b, e);
  };
  react_production_min.useRef = function(a) {
    return U$1.current.useRef(a);
  };
  react_production_min.useState = function(a) {
    return U$1.current.useState(a);
  };
  react_production_min.useSyncExternalStore = function(a, b, e) {
    return U$1.current.useSyncExternalStore(a, b, e);
  };
  react_production_min.useTransition = function() {
    return U$1.current.useTransition();
  };
  react_production_min.version = "18.3.1";
  {
    react.exports = react_production_min;
  }
  var reactExports = react.exports;
  const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var f = reactExports, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m$1.call(a, b) && !p$1.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  {
    jsxRuntime.exports = reactJsxRuntime_production_min;
  }
  var jsxRuntimeExports = jsxRuntime.exports;
  var client = {};
  var reactDom = { exports: {} };
  var reactDom_production_min = {};
  var scheduler = { exports: {} };
  var scheduler_production_min = {};
  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  (function(exports) {
    function f2(a, b) {
      var c = a.length;
      a.push(b);
      a: for (; 0 < c; ) {
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
      }
    }
    function h(a) {
      return 0 === a.length ? null : a[0];
    }
    function k2(a) {
      if (0 === a.length) return null;
      var b = a[0], c = a.pop();
      if (c !== b) {
        a[0] = c;
        a: for (var d = 0, e = a.length, w2 = e >>> 1; d < w2; ) {
          var m2 = 2 * (d + 1) - 1, C2 = a[m2], n2 = m2 + 1, x2 = a[n2];
          if (0 > g(C2, c)) n2 < e && 0 > g(x2, C2) ? (a[d] = x2, a[n2] = c, d = n2) : (a[d] = C2, a[m2] = c, d = m2);
          else if (n2 < e && 0 > g(x2, c)) a[d] = x2, a[n2] = c, d = n2;
          else break a;
        }
      }
      return b;
    }
    function g(a, b) {
      var c = a.sortIndex - b.sortIndex;
      return 0 !== c ? c : a.id - b.id;
    }
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l2 = performance;
      exports.unstable_now = function() {
        return l2.now();
      };
    } else {
      var p2 = Date, q2 = p2.now();
      exports.unstable_now = function() {
        return p2.now() - q2;
      };
    }
    var r2 = [], t2 = [], u2 = 1, v2 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
    "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G2(a) {
      for (var b = h(t2); null !== b; ) {
        if (null === b.callback) k2(t2);
        else if (b.startTime <= a) k2(t2), b.sortIndex = b.expirationTime, f2(r2, b);
        else break;
        b = h(t2);
      }
    }
    function H2(a) {
      B2 = false;
      G2(a);
      if (!A2) if (null !== h(r2)) A2 = true, I2(J2);
      else {
        var b = h(t2);
        null !== b && K2(H2, b.startTime - a);
      }
    }
    function J2(a, b) {
      A2 = false;
      B2 && (B2 = false, E2(L2), L2 = -1);
      z2 = true;
      var c = y2;
      try {
        G2(b);
        for (v2 = h(r2); null !== v2 && (!(v2.expirationTime > b) || a && !M2()); ) {
          var d = v2.callback;
          if ("function" === typeof d) {
            v2.callback = null;
            y2 = v2.priorityLevel;
            var e = d(v2.expirationTime <= b);
            b = exports.unstable_now();
            "function" === typeof e ? v2.callback = e : v2 === h(r2) && k2(r2);
            G2(b);
          } else k2(r2);
          v2 = h(r2);
        }
        if (null !== v2) var w2 = true;
        else {
          var m2 = h(t2);
          null !== m2 && K2(H2, m2.startTime - b);
          w2 = false;
        }
        return w2;
      } finally {
        v2 = null, y2 = c, z2 = false;
      }
    }
    var N2 = false, O2 = null, L2 = -1, P2 = 5, Q2 = -1;
    function M2() {
      return exports.unstable_now() - Q2 < P2 ? false : true;
    }
    function R2() {
      if (null !== O2) {
        var a = exports.unstable_now();
        Q2 = a;
        var b = true;
        try {
          b = O2(true, a);
        } finally {
          b ? S2() : (N2 = false, O2 = null);
        }
      } else N2 = false;
    }
    var S2;
    if ("function" === typeof F2) S2 = function() {
      F2(R2);
    };
    else if ("undefined" !== typeof MessageChannel) {
      var T2 = new MessageChannel(), U2 = T2.port2;
      T2.port1.onmessage = R2;
      S2 = function() {
        U2.postMessage(null);
      };
    } else S2 = function() {
      D2(R2, 0);
    };
    function I2(a) {
      O2 = a;
      N2 || (N2 = true, S2());
    }
    function K2(a, b) {
      L2 = D2(function() {
        a(exports.unstable_now());
      }, b);
    }
    exports.unstable_IdlePriority = 5;
    exports.unstable_ImmediatePriority = 1;
    exports.unstable_LowPriority = 4;
    exports.unstable_NormalPriority = 3;
    exports.unstable_Profiling = null;
    exports.unstable_UserBlockingPriority = 2;
    exports.unstable_cancelCallback = function(a) {
      a.callback = null;
    };
    exports.unstable_continueExecution = function() {
      A2 || z2 || (A2 = true, I2(J2));
    };
    exports.unstable_forceFrameRate = function(a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P2 = 0 < a ? Math.floor(1e3 / a) : 5;
    };
    exports.unstable_getCurrentPriorityLevel = function() {
      return y2;
    };
    exports.unstable_getFirstCallbackNode = function() {
      return h(r2);
    };
    exports.unstable_next = function(a) {
      switch (y2) {
        case 1:
        case 2:
        case 3:
          var b = 3;
          break;
        default:
          b = y2;
      }
      var c = y2;
      y2 = b;
      try {
        return a();
      } finally {
        y2 = c;
      }
    };
    exports.unstable_pauseExecution = function() {
    };
    exports.unstable_requestPaint = function() {
    };
    exports.unstable_runWithPriority = function(a, b) {
      switch (a) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a = 3;
      }
      var c = y2;
      y2 = a;
      try {
        return b();
      } finally {
        y2 = c;
      }
    };
    exports.unstable_scheduleCallback = function(a, b, c) {
      var d = exports.unstable_now();
      "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
      switch (a) {
        case 1:
          var e = -1;
          break;
        case 2:
          e = 250;
          break;
        case 5:
          e = 1073741823;
          break;
        case 4:
          e = 1e4;
          break;
        default:
          e = 5e3;
      }
      e = c + e;
      a = { id: u2++, callback: b, priorityLevel: a, startTime: c, expirationTime: e, sortIndex: -1 };
      c > d ? (a.sortIndex = c, f2(t2, a), null === h(r2) && a === h(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H2, c - d))) : (a.sortIndex = e, f2(r2, a), A2 || z2 || (A2 = true, I2(J2)));
      return a;
    };
    exports.unstable_shouldYield = M2;
    exports.unstable_wrapCallback = function(a) {
      var b = y2;
      return function() {
        var c = y2;
        y2 = b;
        try {
          return a.apply(this, arguments);
        } finally {
          y2 = c;
        }
      };
    };
  })(scheduler_production_min);
  {
    scheduler.exports = scheduler_production_min;
  }
  var schedulerExports = scheduler.exports;
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var aa = reactExports, ca = schedulerExports;
  function p(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var da = /* @__PURE__ */ new Set(), ea = {};
  function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
  }
  function ha(a, b) {
    ea[a] = b;
    for (a = 0; a < b.length; a++) da.add(b[a]);
  }
  var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
  function oa(a) {
    if (ja.call(ma, a)) return true;
    if (ja.call(la, a)) return false;
    if (ka.test(a)) return ma[a] = true;
    la[a] = true;
    return false;
  }
  function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return false;
    switch (typeof b) {
      case "function":
      case "symbol":
        return true;
      case "boolean":
        if (d) return false;
        if (null !== c) return !c.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;
      default:
        return false;
    }
  }
  function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return true;
    if (d) return false;
    if (null !== c) switch (c.type) {
      case 3:
        return !b;
      case 4:
        return false === b;
      case 5:
        return isNaN(b);
      case 6:
        return isNaN(b) || 1 > b;
    }
    return false;
  }
  function v(a, b, c, d, e, f2, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f2;
    this.removeEmptyString = g;
  }
  var z = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, false, a, null, false, false);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, false, a[1], null, false, false);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
    z[a] = new v(a, 2, false, a.toLowerCase(), null, false, false);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
    z[a] = new v(a, 2, false, a, null, false, false);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, false, a.toLowerCase(), null, false, false);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function(a) {
    z[a] = new v(a, 3, true, a, null, false, false);
  });
  ["capture", "download"].forEach(function(a) {
    z[a] = new v(a, 4, false, a, null, false, false);
  });
  ["cols", "rows", "size", "span"].forEach(function(a) {
    z[a] = new v(a, 6, false, a, null, false, false);
  });
  ["rowSpan", "start"].forEach(function(a) {
    z[a] = new v(a, 5, false, a.toLowerCase(), null, false, false);
  });
  var ra = /[\-:]([a-z])/g;
  function sa(a) {
    return a[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(
      ra,
      sa
    );
    z[b] = new v(b, 1, false, a, null, false, false);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
  });
  ["tabIndex", "crossOrigin"].forEach(function(a) {
    z[a] = new v(a, 1, false, a.toLowerCase(), null, false, false);
  });
  z.xlinkHref = new v("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
  ["src", "href", "action", "formAction"].forEach(function(a) {
    z[a] = new v(a, 1, false, a.toLowerCase(), null, true, true);
  });
  function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? false : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
  }
  var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
  var Ia = Symbol.for("react.offscreen");
  var Ja = Symbol.iterator;
  function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }
  var A = Object.assign, La;
  function Ma(a) {
    if (void 0 === La) try {
      throw Error();
    } catch (c) {
      var b = c.stack.trim().match(/\n( *(at )?)/);
      La = b && b[1] || "";
    }
    return "\n" + La + a;
  }
  var Na = false;
  function Oa(a, b) {
    if (!a || Na) return "";
    Na = true;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (b) if (b = function() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", { set: function() {
        throw Error();
      } }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (l2) {
          var d = l2;
        }
        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (l2) {
          d = l2;
        }
        a.call(b.prototype);
      }
      else {
        try {
          throw Error();
        } catch (l2) {
          d = l2;
        }
        a();
      }
    } catch (l2) {
      if (l2 && d && "string" === typeof l2.stack) {
        for (var e = l2.stack.split("\n"), f2 = d.stack.split("\n"), g = e.length - 1, h = f2.length - 1; 1 <= g && 0 <= h && e[g] !== f2[h]; ) h--;
        for (; 1 <= g && 0 <= h; g--, h--) if (e[g] !== f2[h]) {
          if (1 !== g || 1 !== h) {
            do
              if (g--, h--, 0 > h || e[g] !== f2[h]) {
                var k2 = "\n" + e[g].replace(" at new ", " at ");
                a.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a.displayName));
                return k2;
              }
            while (1 <= g && 0 <= h);
          }
          break;
        }
      }
    } finally {
      Na = false, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
  }
  function Pa(a) {
    switch (a.tag) {
      case 5:
        return Ma(a.type);
      case 16:
        return Ma("Lazy");
      case 13:
        return Ma("Suspense");
      case 19:
        return Ma("SuspenseList");
      case 0:
      case 2:
      case 15:
        return a = Oa(a.type, false), a;
      case 11:
        return a = Oa(a.type.render, false), a;
      case 1:
        return a = Oa(a.type, true), a;
      default:
        return "";
    }
  }
  function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch (a) {
      case ya:
        return "Fragment";
      case wa:
        return "Portal";
      case Aa:
        return "Profiler";
      case za:
        return "StrictMode";
      case Ea:
        return "Suspense";
      case Fa:
        return "SuspenseList";
    }
    if ("object" === typeof a) switch (a.$$typeof) {
      case Ca:
        return (a.displayName || "Context") + ".Consumer";
      case Ba:
        return (a._context.displayName || "Context") + ".Provider";
      case Da:
        var b = a.render;
        a = a.displayName;
        a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        return a;
      case Ga:
        return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
      case Ha:
        b = a._payload;
        a = a._init;
        try {
          return Qa(a(b));
        } catch (c) {
        }
    }
    return null;
  }
  function Ra(a) {
    var b = a.type;
    switch (a.tag) {
      case 24:
        return "Cache";
      case 9:
        return (b.displayName || "Context") + ".Consumer";
      case 10:
        return (b._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return b;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Qa(b);
      case 8:
        return b === za ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if ("function" === typeof b) return b.displayName || b.name || null;
        if ("string" === typeof b) return b;
    }
    return null;
  }
  function Sa(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return a;
      case "object":
        return a;
      default:
        return "";
    }
  }
  function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
  }
  function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
      var e = c.get, f2 = c.set;
      Object.defineProperty(a, b, { configurable: true, get: function() {
        return e.call(this);
      }, set: function(a2) {
        d = "" + a2;
        f2.call(this, a2);
      } });
      Object.defineProperty(a, b, { enumerable: c.enumerable });
      return { getValue: function() {
        return d;
      }, setValue: function(a2) {
        d = "" + a2;
      }, stopTracking: function() {
        a._valueTracker = null;
        delete a[b];
      } };
    }
  }
  function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
  }
  function Wa(a) {
    if (!a) return false;
    var b = a._valueTracker;
    if (!b) return true;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), true) : false;
  }
  function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
      return a.activeElement || a.body;
    } catch (b) {
      return a.body;
    }
  }
  function Ya(a, b) {
    var c = b.checked;
    return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
  }
  function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
  }
  function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, false);
  }
  function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
    else if ("submit" === d || "reset" === d) {
      a.removeAttribute("value");
      return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
  }
  function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
      var d = b.type;
      if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
      b = "" + a._wrapperState.initialValue;
      c || b === a.value || (a.value = b);
      a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
  }
  function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
  }
  var eb = Array.isArray;
  function fb(a, b, c, d) {
    a = a.options;
    if (b) {
      b = {};
      for (var e = 0; e < c.length; e++) b["$" + c[e]] = true;
      for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = true);
    } else {
      c = "" + Sa(c);
      b = null;
      for (e = 0; e < a.length; e++) {
        if (a[e].value === c) {
          a[e].selected = true;
          d && (a[e].defaultSelected = true);
          return;
        }
        null !== b || a[e].disabled || (b = a[e]);
      }
      null !== b && (b.selected = true);
    }
  }
  function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
  }
  function hb(a, b) {
    var c = b.value;
    if (null == c) {
      c = b.children;
      b = b.defaultValue;
      if (null != c) {
        if (null != b) throw Error(p(92));
        if (eb(c)) {
          if (1 < c.length) throw Error(p(93));
          c = c[0];
        }
        b = c;
      }
      null == b && (b = "");
      c = b;
    }
    a._wrapperState = { initialValue: Sa(c) };
  }
  function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
  }
  function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
  }
  function kb(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
  }
  var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function() {
        return a(b, c, d, e);
      });
    } : a;
  }(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
      mb = mb || document.createElement("div");
      mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
      for (b = mb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
      for (; b.firstChild; ) a.appendChild(b.firstChild);
    }
  });
  function ob(a, b) {
    if (b) {
      var c = a.firstChild;
      if (c && c === a.lastChild && 3 === c.nodeType) {
        c.nodeValue = b;
        return;
      }
    }
    a.textContent = b;
  }
  var pb = {
    animationIterationCount: true,
    aspectRatio: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridArea: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  }, qb = ["Webkit", "ms", "Moz", "O"];
  Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      pb[b] = pb[a];
    });
  });
  function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
  }
  function sb(a, b) {
    a = a.style;
    for (var c in b) if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
  var tb = A({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
  function ub(a, b) {
    if (b) {
      if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
      if (null != b.dangerouslySetInnerHTML) {
        if (null != b.children) throw Error(p(60));
        if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
      }
      if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
  }
  function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var wb = null;
  function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
  }
  var yb = null, zb = null, Ab = null;
  function Bb(a) {
    if (a = Cb(a)) {
      if ("function" !== typeof yb) throw Error(p(280));
      var b = a.stateNode;
      b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
  }
  function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
  }
  function Fb() {
    if (zb) {
      var a = zb, b = Ab;
      Ab = zb = null;
      Bb(a);
      if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
    }
  }
  function Gb(a, b) {
    return a(b);
  }
  function Hb() {
  }
  var Ib = false;
  function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = true;
    try {
      return Gb(a, b, c);
    } finally {
      if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
    }
  }
  function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;
      default:
        a = false;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
  }
  var Lb = false;
  if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", { get: function() {
      Lb = true;
    } });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
  } catch (a) {
    Lb = false;
  }
  function Nb(a, b, c, d, e, f2, g, h, k2) {
    var l2 = Array.prototype.slice.call(arguments, 3);
    try {
      b.apply(c, l2);
    } catch (m2) {
      this.onError(m2);
    }
  }
  var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a) {
    Ob = true;
    Pb = a;
  } };
  function Tb(a, b, c, d, e, f2, g, h, k2) {
    Ob = false;
    Pb = null;
    Nb.apply(Sb, arguments);
  }
  function Ub(a, b, c, d, e, f2, g, h, k2) {
    Tb.apply(this, arguments);
    if (Ob) {
      if (Ob) {
        var l2 = Pb;
        Ob = false;
        Pb = null;
      } else throw Error(p(198));
      Qb || (Qb = true, Rb = l2);
    }
  }
  function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for (; b.return; ) b = b.return;
    else {
      a = b;
      do
        b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
      while (a);
    }
    return 3 === b.tag ? c : null;
  }
  function Wb(a) {
    if (13 === a.tag) {
      var b = a.memoizedState;
      null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
      if (null !== b) return b.dehydrated;
    }
    return null;
  }
  function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
  }
  function Yb(a) {
    var b = a.alternate;
    if (!b) {
      b = Vb(a);
      if (null === b) throw Error(p(188));
      return b !== a ? null : a;
    }
    for (var c = a, d = b; ; ) {
      var e = c.return;
      if (null === e) break;
      var f2 = e.alternate;
      if (null === f2) {
        d = e.return;
        if (null !== d) {
          c = d;
          continue;
        }
        break;
      }
      if (e.child === f2.child) {
        for (f2 = e.child; f2; ) {
          if (f2 === c) return Xb(e), a;
          if (f2 === d) return Xb(e), b;
          f2 = f2.sibling;
        }
        throw Error(p(188));
      }
      if (c.return !== d.return) c = e, d = f2;
      else {
        for (var g = false, h = e.child; h; ) {
          if (h === c) {
            g = true;
            c = e;
            d = f2;
            break;
          }
          if (h === d) {
            g = true;
            d = e;
            c = f2;
            break;
          }
          h = h.sibling;
        }
        if (!g) {
          for (h = f2.child; h; ) {
            if (h === c) {
              g = true;
              c = f2;
              d = e;
              break;
            }
            if (h === d) {
              g = true;
              d = f2;
              c = e;
              break;
            }
            h = h.sibling;
          }
          if (!g) throw Error(p(189));
        }
      }
      if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
  }
  function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
  }
  function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for (a = a.child; null !== a; ) {
      var b = $b(a);
      if (null !== b) return b;
      a = a.sibling;
    }
    return null;
  }
  var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
  function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
      lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {
    }
  }
  var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
  function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
  }
  var rc = 64, sc = 4194304;
  function tc(a) {
    switch (a & -a) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return a & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return a;
    }
  }
  function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f2 = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
      var h = g & ~e;
      0 !== h ? d = tc(h) : (f2 &= g, 0 !== f2 && (d = tc(f2)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f2 && (d = tc(f2));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f2 = b & -b, e >= f2 || 16 === e && 0 !== (f2 & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
  }
  function vc(a, b) {
    switch (a) {
      case 1:
      case 2:
      case 4:
        return b + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return b + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function wc(a, b) {
    for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f2 = a.pendingLanes; 0 < f2; ) {
      var g = 31 - oc(f2), h = 1 << g, k2 = e[g];
      if (-1 === k2) {
        if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
      } else k2 <= b && (a.expiredLanes |= h);
      f2 &= ~h;
    }
  }
  function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
  }
  function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
  }
  function zc(a) {
    for (var b = [], c = 0; 31 > c; c++) b.push(a);
    return b;
  }
  function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
  }
  function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for (a = a.expirationTimes; 0 < c; ) {
      var e = 31 - oc(c), f2 = 1 << e;
      b[e] = 0;
      d[e] = -1;
      a[e] = -1;
      c &= ~f2;
    }
  }
  function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for (a = a.entanglements; c; ) {
      var d = 31 - oc(c), e = 1 << d;
      e & b | a[d] & b && (a[d] |= b);
      c &= ~e;
    }
  }
  var C = 0;
  function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
  }
  var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Sc(a, b) {
    switch (a) {
      case "focusin":
      case "focusout":
        Lc = null;
        break;
      case "dragenter":
      case "dragleave":
        Mc = null;
        break;
      case "mouseover":
      case "mouseout":
        Nc = null;
        break;
      case "pointerover":
      case "pointerout":
        Oc.delete(b.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Pc.delete(b.pointerId);
    }
  }
  function Tc(a, b, c, d, e, f2) {
    if (null === a || a.nativeEvent !== f2) return a = { blockedOn: b, domEventName: c, eventSystemFlags: d, nativeEvent: f2, targetContainers: [e] }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
  }
  function Uc(a, b, c, d, e) {
    switch (b) {
      case "focusin":
        return Lc = Tc(Lc, a, b, c, d, e), true;
      case "dragenter":
        return Mc = Tc(Mc, a, b, c, d, e), true;
      case "mouseover":
        return Nc = Tc(Nc, a, b, c, d, e), true;
      case "pointerover":
        var f2 = e.pointerId;
        Oc.set(f2, Tc(Oc.get(f2) || null, a, b, c, d, e));
        return true;
      case "gotpointercapture":
        return f2 = e.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a, b, c, d, e)), true;
    }
    return false;
  }
  function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
      var c = Vb(b);
      if (null !== c) {
        if (b = c.tag, 13 === b) {
          if (b = Wb(c), null !== b) {
            a.blockedOn = b;
            Ic(a.priority, function() {
              Gc(c);
            });
            return;
          }
        } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
          a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
          return;
        }
      }
    }
    a.blockedOn = null;
  }
  function Xc(a) {
    if (null !== a.blockedOn) return false;
    for (var b = a.targetContainers; 0 < b.length; ) {
      var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
      if (null === c) {
        c = a.nativeEvent;
        var d = new c.constructor(c.type, c);
        wb = d;
        c.target.dispatchEvent(d);
        wb = null;
      } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, false;
      b.shift();
    }
    return true;
  }
  function Zc(a, b, c) {
    Xc(a) && c.delete(b);
  }
  function $c() {
    Jc = false;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
  }
  function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
  }
  function bd(a) {
    function b(b2) {
      return ad(b2, a);
    }
    if (0 < Kc.length) {
      ad(Kc[0], a);
      for (var c = 1; c < Kc.length; c++) {
        var d = Kc[c];
        d.blockedOn === a && (d.blockedOn = null);
      }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for (c = 0; c < Qc.length; c++) d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for (; 0 < Qc.length && (c = Qc[0], null === c.blockedOn); ) Vc(c), null === c.blockedOn && Qc.shift();
  }
  var cd = ua.ReactCurrentBatchConfig, dd = true;
  function ed(a, b, c, d) {
    var e = C, f2 = cd.transition;
    cd.transition = null;
    try {
      C = 1, fd(a, b, c, d);
    } finally {
      C = e, cd.transition = f2;
    }
  }
  function gd(a, b, c, d) {
    var e = C, f2 = cd.transition;
    cd.transition = null;
    try {
      C = 4, fd(a, b, c, d);
    } finally {
      C = e, cd.transition = f2;
    }
  }
  function fd(a, b, c, d) {
    if (dd) {
      var e = Yc(a, b, c, d);
      if (null === e) hd(a, b, d, id, c), Sc(a, d);
      else if (Uc(e, a, b, c, d)) d.stopPropagation();
      else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
        for (; null !== e; ) {
          var f2 = Cb(e);
          null !== f2 && Ec(f2);
          f2 = Yc(a, b, c, d);
          null === f2 && hd(a, b, d, id, c);
          if (f2 === e) break;
          e = f2;
        }
        null !== e && d.stopPropagation();
      } else hd(a, b, d, null, c);
    }
  }
  var id = null;
  function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) if (b = Vb(a), null === b) a = null;
    else if (c = b.tag, 13 === c) {
      a = Wb(b);
      if (null !== a) return a;
      a = null;
    } else if (3 === c) {
      if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
      a = null;
    } else b !== a && (a = null);
    id = a;
    return null;
  }
  function jd(a) {
    switch (a) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (ec()) {
          case fc:
            return 1;
          case gc:
            return 4;
          case hc:
          case ic:
            return 16;
          case jc:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var kd = null, ld = null, md = null;
  function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f2 = e.length;
    for (a = 0; a < c && b[a] === e[a]; a++) ;
    var g = c - a;
    for (d = 1; d <= g && b[c - d] === e[f2 - d]; d++) ;
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
  }
  function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }
  function pd() {
    return true;
  }
  function qd() {
    return false;
  }
  function rd(a) {
    function b(b2, d, e, f2, g) {
      this._reactName = b2;
      this._targetInst = e;
      this.type = d;
      this.nativeEvent = f2;
      this.target = g;
      this.currentTarget = null;
      for (var c in a) a.hasOwnProperty(c) && (b2 = a[c], this[c] = b2 ? b2(f2) : f2[c]);
      this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
      this.isPropagationStopped = qd;
      return this;
    }
    A(b.prototype, { preventDefault: function() {
      this.defaultPrevented = true;
      var a2 = this.nativeEvent;
      a2 && (a2.preventDefault ? a2.preventDefault() : "unknown" !== typeof a2.returnValue && (a2.returnValue = false), this.isDefaultPrevented = pd);
    }, stopPropagation: function() {
      var a2 = this.nativeEvent;
      a2 && (a2.stopPropagation ? a2.stopPropagation() : "unknown" !== typeof a2.cancelBubble && (a2.cancelBubble = true), this.isPropagationStopped = pd);
    }, persist: function() {
    }, isPersistent: pd });
    return b;
  }
  var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = A({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  }, movementX: function(a) {
    if ("movementX" in a) return a.movementX;
    a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
    return wd;
  }, movementY: function(a) {
    return "movementY" in a ? a.movementY : xd;
  } }), Bd = rd(Ad), Cd = A({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A({}, sd, { clipboardData: function(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }), Jd = rd(Id), Kd = A({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : false;
  }
  function zd() {
    return Pd;
  }
  var Qd = A({}, ud, { key: function(a) {
    if (a.key) {
      var b = Md[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }
    return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a) {
    return "keypress" === a.type ? od(a) : 0;
  }, keyCode: function(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function(a) {
    return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }), Rd = rd(Qd), Sd = A({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
  ia && "documentMode" in document && (be = document.documentMode);
  var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
  function ge(a, b) {
    switch (a) {
      case "keyup":
        return -1 !== $d.indexOf(b.keyCode);
      case "keydown":
        return 229 !== b.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
  }
  var ie = false;
  function je(a, b) {
    switch (a) {
      case "compositionend":
        return he(b);
      case "keypress":
        if (32 !== b.which) return null;
        fe = true;
        return ee;
      case "textInput":
        return a = b.data, a === ee && fe ? null : a;
      default:
        return null;
    }
  }
  function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = false, a) : null;
    switch (a) {
      case "paste":
        return null;
      case "keypress":
        if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
          if (b.char && 1 < b.char.length) return b.char;
          if (b.which) return String.fromCharCode(b.which);
        }
        return null;
      case "compositionend":
        return de && "ko" !== b.locale ? null : b.data;
      default:
        return null;
    }
  }
  var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
  function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? true : false;
  }
  function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({ event: c, listeners: b }));
  }
  var pe = null, qe = null;
  function re(a) {
    se(a, 0);
  }
  function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
  }
  function ve(a, b) {
    if ("change" === a) return b;
  }
  var we = false;
  if (ia) {
    var xe;
    if (ia) {
      var ye = "oninput" in document;
      if (!ye) {
        var ze = document.createElement("div");
        ze.setAttribute("oninput", "return;");
        ye = "function" === typeof ze.oninput;
      }
      xe = ye;
    } else xe = false;
    we = xe && (!document.documentMode || 9 < document.documentMode);
  }
  function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
  }
  function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
      var b = [];
      ne(b, qe, a, xb(a));
      Jb(re, b);
    }
  }
  function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
  }
  function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
  }
  function Ee(a, b) {
    if ("click" === a) return te(b);
  }
  function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
  }
  function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var He = "function" === typeof Object.is ? Object.is : Ge;
  function Ie(a, b) {
    if (He(a, b)) return true;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return false;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return false;
    for (d = 0; d < c.length; d++) {
      var e = c[d];
      if (!ja.call(b, e) || !He(a[e], b[e])) return false;
    }
    return true;
  }
  function Je(a) {
    for (; a && a.firstChild; ) a = a.firstChild;
    return a;
  }
  function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for (var d; c; ) {
      if (3 === c.nodeType) {
        d = a + c.textContent.length;
        if (a <= b && d >= b) return { node: c, offset: b - a };
        a = d;
      }
      a: {
        for (; c; ) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break a;
          }
          c = c.parentNode;
        }
        c = void 0;
      }
      c = Je(c);
    }
  }
  function Le(a, b) {
    return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
  }
  function Me() {
    for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
      try {
        var c = "string" === typeof b.contentWindow.location.href;
      } catch (d) {
        c = false;
      }
      if (c) a = b.contentWindow;
      else break;
      b = Xa(a.document);
    }
    return b;
  }
  function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
  }
  function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
      if (null !== d && Ne(c)) {
        if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
        else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
          a = a.getSelection();
          var e = c.textContent.length, f2 = Math.min(d.start, e);
          d = void 0 === d.end ? f2 : Math.min(d.end, e);
          !a.extend && f2 > d && (e = d, d = f2, f2 = e);
          e = Ke(c, f2);
          var g = Ke(
            c,
            d
          );
          e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f2 > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
        }
      }
      b = [];
      for (a = c; a = a.parentNode; ) 1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
      "function" === typeof c.focus && c.focus();
      for (c = 0; c < b.length; c++) a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
  }
  var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
  function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({ event: b, listeners: d }), b.target = Qe)));
  }
  function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
  }
  var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
  ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
  function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for (c in b) if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
  }
  var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ff(a, b) {
    df.set(a, b);
    fa(b, [a]);
  }
  for (var gf = 0; gf < ef.length; gf++) {
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
  }
  ff($e, "onAnimationEnd");
  ff(af, "onAnimationIteration");
  ff(bf, "onAnimationStart");
  ff("dblclick", "onDoubleClick");
  ff("focusin", "onFocus");
  ff("focusout", "onBlur");
  ff(cf, "onTransitionEnd");
  ha("onMouseEnter", ["mouseout", "mouseover"]);
  ha("onMouseLeave", ["mouseout", "mouseover"]);
  ha("onPointerEnter", ["pointerout", "pointerover"]);
  ha("onPointerLeave", ["pointerout", "pointerover"]);
  fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
  fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
  fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
  fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
  }
  function se(a, b) {
    b = 0 !== (b & 4);
    for (var c = 0; c < a.length; c++) {
      var d = a[c], e = d.event;
      d = d.listeners;
      a: {
        var f2 = void 0;
        if (b) for (var g = d.length - 1; 0 <= g; g--) {
          var h = d[g], k2 = h.instance, l2 = h.currentTarget;
          h = h.listener;
          if (k2 !== f2 && e.isPropagationStopped()) break a;
          nf(e, h, l2);
          f2 = k2;
        }
        else for (g = 0; g < d.length; g++) {
          h = d[g];
          k2 = h.instance;
          l2 = h.currentTarget;
          h = h.listener;
          if (k2 !== f2 && e.isPropagationStopped()) break a;
          nf(e, h, l2);
          f2 = k2;
        }
      }
    }
    if (Qb) throw a = Rb, Qb = false, Rb = null, a;
  }
  function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = /* @__PURE__ */ new Set());
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, false), c.add(d));
  }
  function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
  }
  var rf = "_reactListening" + Math.random().toString(36).slice(2);
  function sf(a) {
    if (!a[rf]) {
      a[rf] = true;
      da.forEach(function(b2) {
        "selectionchange" !== b2 && (mf.has(b2) || qf(b2, false, a), qf(b2, true, a));
      });
      var b = 9 === a.nodeType ? a : a.ownerDocument;
      null === b || b[rf] || (b[rf] = true, qf("selectionchange", false, b));
    }
  }
  function pf(a, b, c, d) {
    switch (jd(b)) {
      case 1:
        var e = ed;
        break;
      case 4:
        e = gd;
        break;
      default:
        e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = true);
    d ? void 0 !== e ? a.addEventListener(b, c, { capture: true, passive: e }) : a.addEventListener(b, c, true) : void 0 !== e ? a.addEventListener(b, c, { passive: e }) : a.addEventListener(b, c, false);
  }
  function hd(a, b, c, d, e) {
    var f2 = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (; ; ) {
      if (null === d) return;
      var g = d.tag;
      if (3 === g || 4 === g) {
        var h = d.stateNode.containerInfo;
        if (h === e || 8 === h.nodeType && h.parentNode === e) break;
        if (4 === g) for (g = d.return; null !== g; ) {
          var k2 = g.tag;
          if (3 === k2 || 4 === k2) {
            if (k2 = g.stateNode.containerInfo, k2 === e || 8 === k2.nodeType && k2.parentNode === e) return;
          }
          g = g.return;
        }
        for (; null !== h; ) {
          g = Wc(h);
          if (null === g) return;
          k2 = g.tag;
          if (5 === k2 || 6 === k2) {
            d = f2 = g;
            continue a;
          }
          h = h.parentNode;
        }
      }
      d = d.return;
    }
    Jb(function() {
      var d2 = f2, e2 = xb(c), g2 = [];
      a: {
        var h2 = df.get(a);
        if (void 0 !== h2) {
          var k3 = td, n2 = a;
          switch (a) {
            case "keypress":
              if (0 === od(c)) break a;
            case "keydown":
            case "keyup":
              k3 = Rd;
              break;
            case "focusin":
              n2 = "focus";
              k3 = Fd;
              break;
            case "focusout":
              n2 = "blur";
              k3 = Fd;
              break;
            case "beforeblur":
            case "afterblur":
              k3 = Fd;
              break;
            case "click":
              if (2 === c.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              k3 = Bd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              k3 = Dd;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              k3 = Vd;
              break;
            case $e:
            case af:
            case bf:
              k3 = Hd;
              break;
            case cf:
              k3 = Xd;
              break;
            case "scroll":
              k3 = vd;
              break;
            case "wheel":
              k3 = Zd;
              break;
            case "copy":
            case "cut":
            case "paste":
              k3 = Jd;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              k3 = Td;
          }
          var t2 = 0 !== (b & 4), J2 = !t2 && "scroll" === a, x2 = t2 ? null !== h2 ? h2 + "Capture" : null : h2;
          t2 = [];
          for (var w2 = d2, u2; null !== w2; ) {
            u2 = w2;
            var F2 = u2.stateNode;
            5 === u2.tag && null !== F2 && (u2 = F2, null !== x2 && (F2 = Kb(w2, x2), null != F2 && t2.push(tf(w2, F2, u2))));
            if (J2) break;
            w2 = w2.return;
          }
          0 < t2.length && (h2 = new k3(h2, n2, null, c, e2), g2.push({ event: h2, listeners: t2 }));
        }
      }
      if (0 === (b & 7)) {
        a: {
          h2 = "mouseover" === a || "pointerover" === a;
          k3 = "mouseout" === a || "pointerout" === a;
          if (h2 && c !== wb && (n2 = c.relatedTarget || c.fromElement) && (Wc(n2) || n2[uf])) break a;
          if (k3 || h2) {
            h2 = e2.window === e2 ? e2 : (h2 = e2.ownerDocument) ? h2.defaultView || h2.parentWindow : window;
            if (k3) {
              if (n2 = c.relatedTarget || c.toElement, k3 = d2, n2 = n2 ? Wc(n2) : null, null !== n2 && (J2 = Vb(n2), n2 !== J2 || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
            } else k3 = null, n2 = d2;
            if (k3 !== n2) {
              t2 = Bd;
              F2 = "onMouseLeave";
              x2 = "onMouseEnter";
              w2 = "mouse";
              if ("pointerout" === a || "pointerover" === a) t2 = Td, F2 = "onPointerLeave", x2 = "onPointerEnter", w2 = "pointer";
              J2 = null == k3 ? h2 : ue(k3);
              u2 = null == n2 ? h2 : ue(n2);
              h2 = new t2(F2, w2 + "leave", k3, c, e2);
              h2.target = J2;
              h2.relatedTarget = u2;
              F2 = null;
              Wc(e2) === d2 && (t2 = new t2(x2, w2 + "enter", n2, c, e2), t2.target = u2, t2.relatedTarget = J2, F2 = t2);
              J2 = F2;
              if (k3 && n2) b: {
                t2 = k3;
                x2 = n2;
                w2 = 0;
                for (u2 = t2; u2; u2 = vf(u2)) w2++;
                u2 = 0;
                for (F2 = x2; F2; F2 = vf(F2)) u2++;
                for (; 0 < w2 - u2; ) t2 = vf(t2), w2--;
                for (; 0 < u2 - w2; ) x2 = vf(x2), u2--;
                for (; w2--; ) {
                  if (t2 === x2 || null !== x2 && t2 === x2.alternate) break b;
                  t2 = vf(t2);
                  x2 = vf(x2);
                }
                t2 = null;
              }
              else t2 = null;
              null !== k3 && wf(g2, h2, k3, t2, false);
              null !== n2 && null !== J2 && wf(g2, J2, n2, t2, true);
            }
          }
        }
        a: {
          h2 = d2 ? ue(d2) : window;
          k3 = h2.nodeName && h2.nodeName.toLowerCase();
          if ("select" === k3 || "input" === k3 && "file" === h2.type) var na = ve;
          else if (me(h2)) if (we) na = Fe;
          else {
            na = De;
            var xa = Ce;
          }
          else (k3 = h2.nodeName) && "input" === k3.toLowerCase() && ("checkbox" === h2.type || "radio" === h2.type) && (na = Ee);
          if (na && (na = na(a, d2))) {
            ne(g2, na, c, e2);
            break a;
          }
          xa && xa(a, h2, d2);
          "focusout" === a && (xa = h2._wrapperState) && xa.controlled && "number" === h2.type && cb(h2, "number", h2.value);
        }
        xa = d2 ? ue(d2) : window;
        switch (a) {
          case "focusin":
            if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d2, Se = null;
            break;
          case "focusout":
            Se = Re = Qe = null;
            break;
          case "mousedown":
            Te = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Te = false;
            Ue(g2, c, e2);
            break;
          case "selectionchange":
            if (Pe) break;
          case "keydown":
          case "keyup":
            Ue(g2, c, e2);
        }
        var $a;
        if (ae) b: {
          switch (a) {
            case "compositionstart":
              var ba = "onCompositionStart";
              break b;
            case "compositionend":
              ba = "onCompositionEnd";
              break b;
            case "compositionupdate":
              ba = "onCompositionUpdate";
              break b;
          }
          ba = void 0;
        }
        else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
        ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e2, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d2, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e2), g2.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
        if ($a = ce ? je(a, c) : ke(a, c)) d2 = oe(d2, "onBeforeInput"), 0 < d2.length && (e2 = new Ld("onBeforeInput", "beforeinput", null, c, e2), g2.push({ event: e2, listeners: d2 }), e2.data = $a);
      }
      se(g2, b);
    });
  }
  function tf(a, b, c) {
    return { instance: a, listener: b, currentTarget: c };
  }
  function oe(a, b) {
    for (var c = b + "Capture", d = []; null !== a; ) {
      var e = a, f2 = e.stateNode;
      5 === e.tag && null !== f2 && (e = f2, f2 = Kb(a, c), null != f2 && d.unshift(tf(a, f2, e)), f2 = Kb(a, b), null != f2 && d.push(tf(a, f2, e)));
      a = a.return;
    }
    return d;
  }
  function vf(a) {
    if (null === a) return null;
    do
      a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
  }
  function wf(a, b, c, d, e) {
    for (var f2 = b._reactName, g = []; null !== c && c !== d; ) {
      var h = c, k2 = h.alternate, l2 = h.stateNode;
      if (null !== k2 && k2 === d) break;
      5 === h.tag && null !== l2 && (h = l2, e ? (k2 = Kb(c, f2), null != k2 && g.unshift(tf(c, k2, h))) : e || (k2 = Kb(c, f2), null != k2 && g.push(tf(c, k2, h))));
      c = c.return;
    }
    0 !== g.length && a.push({ event: b, listeners: g });
  }
  var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
  function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
  }
  function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
  }
  function Bf() {
  }
  var Cf = null, Df = null;
  function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
  }
  var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
  } : Ff;
  function If(a) {
    setTimeout(function() {
      throw a;
    });
  }
  function Kf(a, b) {
    var c = b, d = 0;
    do {
      var e = c.nextSibling;
      a.removeChild(c);
      if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
        if (0 === d) {
          a.removeChild(e);
          bd(b);
          return;
        }
        d--;
      } else "$" !== c && "$?" !== c && "$!" !== c || d++;
      c = e;
    } while (c);
    bd(b);
  }
  function Lf(a) {
    for (; null != a; a = a.nextSibling) {
      var b = a.nodeType;
      if (1 === b || 3 === b) break;
      if (8 === b) {
        b = a.data;
        if ("$" === b || "$!" === b || "$?" === b) break;
        if ("/$" === b) return null;
      }
    }
    return a;
  }
  function Mf(a) {
    a = a.previousSibling;
    for (var b = 0; a; ) {
      if (8 === a.nodeType) {
        var c = a.data;
        if ("$" === c || "$!" === c || "$?" === c) {
          if (0 === b) return a;
          b--;
        } else "/$" === c && b++;
      }
      a = a.previousSibling;
    }
    return null;
  }
  var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
  function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for (var c = a.parentNode; c; ) {
      if (b = c[uf] || c[Of]) {
        c = b.alternate;
        if (null !== b.child || null !== c && null !== c.child) for (a = Mf(a); null !== a; ) {
          if (c = a[Of]) return c;
          a = Mf(a);
        }
        return b;
      }
      a = c;
      c = a.parentNode;
    }
    return null;
  }
  function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
  }
  function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
  }
  function Db(a) {
    return a[Pf] || null;
  }
  var Sf = [], Tf = -1;
  function Uf(a) {
    return { current: a };
  }
  function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
  }
  function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
  }
  var Vf = {}, H = Uf(Vf), Wf = Uf(false), Xf = Vf;
  function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f2;
    for (f2 in c) e[f2] = b[f2];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }
  function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
  }
  function $f() {
    E(Wf);
    E(H);
  }
  function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
  }
  function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for (var e in d) if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
  }
  function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return true;
  }
  function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
  }
  var eg = null, fg = false, gg = false;
  function hg(a) {
    null === eg ? eg = [a] : eg.push(a);
  }
  function ig(a) {
    fg = true;
    hg(a);
  }
  function jg() {
    if (!gg && null !== eg) {
      gg = true;
      var a = 0, b = C;
      try {
        var c = eg;
        for (C = 1; a < c.length; a++) {
          var d = c[a];
          do
            d = d(true);
          while (null !== d);
        }
        eg = null;
        fg = false;
      } catch (e) {
        throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
      } finally {
        C = b, gg = false;
      }
    }
    return null;
  }
  var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
  function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
  }
  function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f2 = 32 - oc(b) + e;
    if (30 < f2) {
      var g = e - e % 5;
      f2 = (d & (1 << g) - 1).toString(32);
      d >>= g;
      e -= g;
      rg = 1 << 32 - oc(b) + e | c << e | d;
      sg = f2 + a;
    } else rg = 1 << f2 | c << e | d, sg = a;
  }
  function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
  }
  function wg(a) {
    for (; a === mg; ) mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for (; a === qg; ) qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
  }
  var xg = null, yg = null, I = false, zg = null;
  function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
  }
  function Cg(a, b) {
    switch (a.tag) {
      case 5:
        var c = a.type;
        b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
        return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), true) : false;
      case 6:
        return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, true) : false;
      case 13:
        return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? { id: rg, overflow: sg } : null, a.memoizedState = { dehydrated: b, treeContext: c, retryLane: 1073741824 }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, true) : false;
      default:
        return false;
    }
  }
  function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
  }
  function Eg(a) {
    if (I) {
      var b = yg;
      if (b) {
        var c = b;
        if (!Cg(a, b)) {
          if (Dg(a)) throw Error(p(418));
          b = Lf(c.nextSibling);
          var d = xg;
          b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = false, xg = a);
        }
      } else {
        if (Dg(a)) throw Error(p(418));
        a.flags = a.flags & -4097 | 2;
        I = false;
        xg = a;
      }
    }
  }
  function Fg(a) {
    for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
    xg = a;
  }
  function Gg(a) {
    if (a !== xg) return false;
    if (!I) return Fg(a), I = true, false;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
      if (Dg(a)) throw Hg(), Error(p(418));
      for (; b; ) Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
      a = a.memoizedState;
      a = null !== a ? a.dehydrated : null;
      if (!a) throw Error(p(317));
      a: {
        a = a.nextSibling;
        for (b = 0; a; ) {
          if (8 === a.nodeType) {
            var c = a.data;
            if ("/$" === c) {
              if (0 === b) {
                yg = Lf(a.nextSibling);
                break a;
              }
              b--;
            } else "$" !== c && "$!" !== c && "$?" !== c || b++;
          }
          a = a.nextSibling;
        }
        yg = null;
      }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return true;
  }
  function Hg() {
    for (var a = yg; a; ) a = Lf(a.nextSibling);
  }
  function Ig() {
    yg = xg = null;
    I = false;
  }
  function Jg(a) {
    null === zg ? zg = [a] : zg.push(a);
  }
  var Kg = ua.ReactCurrentBatchConfig;
  function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
      if (c._owner) {
        c = c._owner;
        if (c) {
          if (1 !== c.tag) throw Error(p(309));
          var d = c.stateNode;
        }
        if (!d) throw Error(p(147, a));
        var e = d, f2 = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f2) return b.ref;
        b = function(a2) {
          var b2 = e.refs;
          null === a2 ? delete b2[f2] : b2[f2] = a2;
        };
        b._stringRef = f2;
        return b;
      }
      if ("string" !== typeof a) throw Error(p(284));
      if (!c._owner) throw Error(p(290, a));
    }
    return a;
  }
  function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
  }
  function Ng(a) {
    var b = a._init;
    return b(a._payload);
  }
  function Og(a) {
    function b(b2, c2) {
      if (a) {
        var d2 = b2.deletions;
        null === d2 ? (b2.deletions = [c2], b2.flags |= 16) : d2.push(c2);
      }
    }
    function c(c2, d2) {
      if (!a) return null;
      for (; null !== d2; ) b(c2, d2), d2 = d2.sibling;
      return null;
    }
    function d(a2, b2) {
      for (a2 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
      return a2;
    }
    function e(a2, b2) {
      a2 = Pg(a2, b2);
      a2.index = 0;
      a2.sibling = null;
      return a2;
    }
    function f2(b2, c2, d2) {
      b2.index = d2;
      if (!a) return b2.flags |= 1048576, c2;
      d2 = b2.alternate;
      if (null !== d2) return d2 = d2.index, d2 < c2 ? (b2.flags |= 2, c2) : d2;
      b2.flags |= 2;
      return c2;
    }
    function g(b2) {
      a && null === b2.alternate && (b2.flags |= 2);
      return b2;
    }
    function h(a2, b2, c2, d2) {
      if (null === b2 || 6 !== b2.tag) return b2 = Qg(c2, a2.mode, d2), b2.return = a2, b2;
      b2 = e(b2, c2);
      b2.return = a2;
      return b2;
    }
    function k2(a2, b2, c2, d2) {
      var f3 = c2.type;
      if (f3 === ya) return m2(a2, b2, c2.props.children, d2, c2.key);
      if (null !== b2 && (b2.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng(f3) === b2.type)) return d2 = e(b2, c2.props), d2.ref = Lg(a2, b2, c2), d2.return = a2, d2;
      d2 = Rg(c2.type, c2.key, c2.props, null, a2.mode, d2);
      d2.ref = Lg(a2, b2, c2);
      d2.return = a2;
      return d2;
    }
    function l2(a2, b2, c2, d2) {
      if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation) return b2 = Sg(c2, a2.mode, d2), b2.return = a2, b2;
      b2 = e(b2, c2.children || []);
      b2.return = a2;
      return b2;
    }
    function m2(a2, b2, c2, d2, f3) {
      if (null === b2 || 7 !== b2.tag) return b2 = Tg(c2, a2.mode, d2, f3), b2.return = a2, b2;
      b2 = e(b2, c2);
      b2.return = a2;
      return b2;
    }
    function q2(a2, b2, c2) {
      if ("string" === typeof b2 && "" !== b2 || "number" === typeof b2) return b2 = Qg("" + b2, a2.mode, c2), b2.return = a2, b2;
      if ("object" === typeof b2 && null !== b2) {
        switch (b2.$$typeof) {
          case va:
            return c2 = Rg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Lg(a2, null, b2), c2.return = a2, c2;
          case wa:
            return b2 = Sg(b2, a2.mode, c2), b2.return = a2, b2;
          case Ha:
            var d2 = b2._init;
            return q2(a2, d2(b2._payload), c2);
        }
        if (eb(b2) || Ka(b2)) return b2 = Tg(b2, a2.mode, c2, null), b2.return = a2, b2;
        Mg(a2, b2);
      }
      return null;
    }
    function r2(a2, b2, c2, d2) {
      var e2 = null !== b2 ? b2.key : null;
      if ("string" === typeof c2 && "" !== c2 || "number" === typeof c2) return null !== e2 ? null : h(a2, b2, "" + c2, d2);
      if ("object" === typeof c2 && null !== c2) {
        switch (c2.$$typeof) {
          case va:
            return c2.key === e2 ? k2(a2, b2, c2, d2) : null;
          case wa:
            return c2.key === e2 ? l2(a2, b2, c2, d2) : null;
          case Ha:
            return e2 = c2._init, r2(
              a2,
              b2,
              e2(c2._payload),
              d2
            );
        }
        if (eb(c2) || Ka(c2)) return null !== e2 ? null : m2(a2, b2, c2, d2, null);
        Mg(a2, c2);
      }
      return null;
    }
    function y2(a2, b2, c2, d2, e2) {
      if ("string" === typeof d2 && "" !== d2 || "number" === typeof d2) return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e2);
      if ("object" === typeof d2 && null !== d2) {
        switch (d2.$$typeof) {
          case va:
            return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, k2(b2, a2, d2, e2);
          case wa:
            return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l2(b2, a2, d2, e2);
          case Ha:
            var f3 = d2._init;
            return y2(a2, b2, c2, f3(d2._payload), e2);
        }
        if (eb(d2) || Ka(d2)) return a2 = a2.get(c2) || null, m2(b2, a2, d2, e2, null);
        Mg(b2, d2);
      }
      return null;
    }
    function n2(e2, g2, h2, k3) {
      for (var l3 = null, m3 = null, u2 = g2, w2 = g2 = 0, x2 = null; null !== u2 && w2 < h2.length; w2++) {
        u2.index > w2 ? (x2 = u2, u2 = null) : x2 = u2.sibling;
        var n3 = r2(e2, u2, h2[w2], k3);
        if (null === n3) {
          null === u2 && (u2 = x2);
          break;
        }
        a && u2 && null === n3.alternate && b(e2, u2);
        g2 = f2(n3, g2, w2);
        null === m3 ? l3 = n3 : m3.sibling = n3;
        m3 = n3;
        u2 = x2;
      }
      if (w2 === h2.length) return c(e2, u2), I && tg(e2, w2), l3;
      if (null === u2) {
        for (; w2 < h2.length; w2++) u2 = q2(e2, h2[w2], k3), null !== u2 && (g2 = f2(u2, g2, w2), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
        I && tg(e2, w2);
        return l3;
      }
      for (u2 = d(e2, u2); w2 < h2.length; w2++) x2 = y2(u2, e2, w2, h2[w2], k3), null !== x2 && (a && null !== x2.alternate && u2.delete(null === x2.key ? w2 : x2.key), g2 = f2(x2, g2, w2), null === m3 ? l3 = x2 : m3.sibling = x2, m3 = x2);
      a && u2.forEach(function(a2) {
        return b(e2, a2);
      });
      I && tg(e2, w2);
      return l3;
    }
    function t2(e2, g2, h2, k3) {
      var l3 = Ka(h2);
      if ("function" !== typeof l3) throw Error(p(150));
      h2 = l3.call(h2);
      if (null == h2) throw Error(p(151));
      for (var u2 = l3 = null, m3 = g2, w2 = g2 = 0, x2 = null, n3 = h2.next(); null !== m3 && !n3.done; w2++, n3 = h2.next()) {
        m3.index > w2 ? (x2 = m3, m3 = null) : x2 = m3.sibling;
        var t3 = r2(e2, m3, n3.value, k3);
        if (null === t3) {
          null === m3 && (m3 = x2);
          break;
        }
        a && m3 && null === t3.alternate && b(e2, m3);
        g2 = f2(t3, g2, w2);
        null === u2 ? l3 = t3 : u2.sibling = t3;
        u2 = t3;
        m3 = x2;
      }
      if (n3.done) return c(
        e2,
        m3
      ), I && tg(e2, w2), l3;
      if (null === m3) {
        for (; !n3.done; w2++, n3 = h2.next()) n3 = q2(e2, n3.value, k3), null !== n3 && (g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
        I && tg(e2, w2);
        return l3;
      }
      for (m3 = d(e2, m3); !n3.done; w2++, n3 = h2.next()) n3 = y2(m3, e2, w2, n3.value, k3), null !== n3 && (a && null !== n3.alternate && m3.delete(null === n3.key ? w2 : n3.key), g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
      a && m3.forEach(function(a2) {
        return b(e2, a2);
      });
      I && tg(e2, w2);
      return l3;
    }
    function J2(a2, d2, f3, h2) {
      "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
      if ("object" === typeof f3 && null !== f3) {
        switch (f3.$$typeof) {
          case va:
            a: {
              for (var k3 = f3.key, l3 = d2; null !== l3; ) {
                if (l3.key === k3) {
                  k3 = f3.type;
                  if (k3 === ya) {
                    if (7 === l3.tag) {
                      c(a2, l3.sibling);
                      d2 = e(l3, f3.props.children);
                      d2.return = a2;
                      a2 = d2;
                      break a;
                    }
                  } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === Ha && Ng(k3) === l3.type) {
                    c(a2, l3.sibling);
                    d2 = e(l3, f3.props);
                    d2.ref = Lg(a2, l3, f3);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
                  c(a2, l3);
                  break;
                } else b(a2, l3);
                l3 = l3.sibling;
              }
              f3.type === ya ? (d2 = Tg(f3.props.children, a2.mode, h2, f3.key), d2.return = a2, a2 = d2) : (h2 = Rg(f3.type, f3.key, f3.props, null, a2.mode, h2), h2.ref = Lg(a2, d2, f3), h2.return = a2, a2 = h2);
            }
            return g(a2);
          case wa:
            a: {
              for (l3 = f3.key; null !== d2; ) {
                if (d2.key === l3) if (4 === d2.tag && d2.stateNode.containerInfo === f3.containerInfo && d2.stateNode.implementation === f3.implementation) {
                  c(a2, d2.sibling);
                  d2 = e(d2, f3.children || []);
                  d2.return = a2;
                  a2 = d2;
                  break a;
                } else {
                  c(a2, d2);
                  break;
                }
                else b(a2, d2);
                d2 = d2.sibling;
              }
              d2 = Sg(f3, a2.mode, h2);
              d2.return = a2;
              a2 = d2;
            }
            return g(a2);
          case Ha:
            return l3 = f3._init, J2(a2, d2, l3(f3._payload), h2);
        }
        if (eb(f3)) return n2(a2, d2, f3, h2);
        if (Ka(f3)) return t2(a2, d2, f3, h2);
        Mg(a2, f3);
      }
      return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e(d2, f3), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Qg(f3, a2.mode, h2), d2.return = a2, a2 = d2), g(a2)) : c(a2, d2);
    }
    return J2;
  }
  var Ug = Og(true), Vg = Og(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
  function $g() {
    Zg = Yg = Xg = null;
  }
  function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
  }
  function bh(a, b, c) {
    for (; null !== a; ) {
      var d = a.alternate;
      (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
      if (a === c) break;
      a = a.return;
    }
  }
  function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = true), a.firstContext = null);
  }
  function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) if (a = { context: a, memoizedValue: b, next: null }, null === Yg) {
      if (null === Xg) throw Error(p(308));
      Yg = a;
      Xg.dependencies = { lanes: 0, firstContext: a };
    } else Yg = Yg.next = a;
    return b;
  }
  var fh = null;
  function gh(a) {
    null === fh ? fh = [a] : fh.push(a);
  }
  function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
  }
  function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for (a = a.return; null !== a; ) a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
  }
  var jh = false;
  function kh(a) {
    a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
  }
  function mh(a, b) {
    return { eventTime: a, lane: b, tag: 0, payload: null, callback: null, next: null };
  }
  function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
      var e = d.pending;
      null === e ? b.next = b : (b.next = e.next, e.next = b);
      d.pending = b;
      return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
  }
  function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
      var d = b.lanes;
      d &= a.pendingLanes;
      c |= d;
      b.lanes = c;
      Cc(a, c);
    }
  }
  function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
      var e = null, f2 = null;
      c = c.firstBaseUpdate;
      if (null !== c) {
        do {
          var g = { eventTime: c.eventTime, lane: c.lane, tag: c.tag, payload: c.payload, callback: c.callback, next: null };
          null === f2 ? e = f2 = g : f2 = f2.next = g;
          c = c.next;
        } while (null !== c);
        null === f2 ? e = f2 = b : f2 = f2.next = b;
      } else e = f2 = b;
      c = { baseState: d.baseState, firstBaseUpdate: e, lastBaseUpdate: f2, shared: d.shared, effects: d.effects };
      a.updateQueue = c;
      return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
  }
  function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = false;
    var f2 = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
      e.shared.pending = null;
      var k2 = h, l2 = k2.next;
      k2.next = null;
      null === g ? f2 = l2 : g.next = l2;
      g = k2;
      var m2 = a.alternate;
      null !== m2 && (m2 = m2.updateQueue, h = m2.lastBaseUpdate, h !== g && (null === h ? m2.firstBaseUpdate = l2 : h.next = l2, m2.lastBaseUpdate = k2));
    }
    if (null !== f2) {
      var q2 = e.baseState;
      g = 0;
      m2 = l2 = k2 = null;
      h = f2;
      do {
        var r2 = h.lane, y2 = h.eventTime;
        if ((d & r2) === r2) {
          null !== m2 && (m2 = m2.next = {
            eventTime: y2,
            lane: 0,
            tag: h.tag,
            payload: h.payload,
            callback: h.callback,
            next: null
          });
          a: {
            var n2 = a, t2 = h;
            r2 = b;
            y2 = c;
            switch (t2.tag) {
              case 1:
                n2 = t2.payload;
                if ("function" === typeof n2) {
                  q2 = n2.call(y2, q2, r2);
                  break a;
                }
                q2 = n2;
                break a;
              case 3:
                n2.flags = n2.flags & -65537 | 128;
              case 0:
                n2 = t2.payload;
                r2 = "function" === typeof n2 ? n2.call(y2, q2, r2) : n2;
                if (null === r2 || void 0 === r2) break a;
                q2 = A({}, q2, r2);
                break a;
              case 2:
                jh = true;
            }
          }
          null !== h.callback && 0 !== h.lane && (a.flags |= 64, r2 = e.effects, null === r2 ? e.effects = [h] : r2.push(h));
        } else y2 = { eventTime: y2, lane: r2, tag: h.tag, payload: h.payload, callback: h.callback, next: null }, null === m2 ? (l2 = m2 = y2, k2 = q2) : m2 = m2.next = y2, g |= r2;
        h = h.next;
        if (null === h) if (h = e.shared.pending, null === h) break;
        else r2 = h, h = r2.next, r2.next = null, e.lastBaseUpdate = r2, e.shared.pending = null;
      } while (1);
      null === m2 && (k2 = q2);
      e.baseState = k2;
      e.firstBaseUpdate = l2;
      e.lastBaseUpdate = m2;
      b = e.shared.interleaved;
      if (null !== b) {
        e = b;
        do
          g |= e.lane, e = e.next;
        while (e !== b);
      } else null === f2 && (e.shared.lanes = 0);
      rh |= g;
      a.lanes = g;
      a.memoizedState = q2;
    }
  }
  function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for (b = 0; b < a.length; b++) {
      var d = a[b], e = d.callback;
      if (null !== e) {
        d.callback = null;
        d = c;
        if ("function" !== typeof e) throw Error(p(191, e));
        e.call(d);
      }
    }
  }
  var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
  function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
  }
  function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch (a) {
      case 9:
      case 11:
        b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
        break;
      default:
        a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
  }
  function zh() {
    E(uh);
    E(vh);
    E(wh);
  }
  function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
  }
  function Bh(a) {
    vh.current === a && (E(uh), E(vh));
  }
  var L = Uf(0);
  function Ch(a) {
    for (var b = a; null !== b; ) {
      if (13 === b.tag) {
        var c = b.memoizedState;
        if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
      } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
        if (0 !== (b.flags & 128)) return b;
      } else if (null !== b.child) {
        b.child.return = b;
        b = b.child;
        continue;
      }
      if (b === a) break;
      for (; null === b.sibling; ) {
        if (null === b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
    return null;
  }
  var Dh = [];
  function Eh() {
    for (var a = 0; a < Dh.length; a++) Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
  }
  var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
  function P() {
    throw Error(p(321));
  }
  function Mh(a, b) {
    if (null === b) return false;
    for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return false;
    return true;
  }
  function Nh(a, b, c, d, e, f2) {
    Hh = f2;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
      f2 = 0;
      do {
        Jh = false;
        Kh = 0;
        if (25 <= f2) throw Error(p(301));
        f2 += 1;
        O = N = null;
        b.updateQueue = null;
        Fh.current = Qh;
        a = c(d, e);
      } while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = false;
    if (b) throw Error(p(300));
    return a;
  }
  function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
  }
  function Th() {
    var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
  }
  function Uh() {
    if (null === N) {
      var a = M.alternate;
      a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
      if (null === a) throw Error(p(310));
      N = a;
      a = { memoizedState: N.memoizedState, baseState: N.baseState, baseQueue: N.baseQueue, queue: N.queue, next: null };
      null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
  }
  function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
  }
  function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f2 = c.pending;
    if (null !== f2) {
      if (null !== e) {
        var g = e.next;
        e.next = f2.next;
        f2.next = g;
      }
      d.baseQueue = e = f2;
      c.pending = null;
    }
    if (null !== e) {
      f2 = e.next;
      d = d.baseState;
      var h = g = null, k2 = null, l2 = f2;
      do {
        var m2 = l2.lane;
        if ((Hh & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d = l2.hasEagerState ? l2.eagerState : a(d, l2.action);
        else {
          var q2 = {
            lane: m2,
            action: l2.action,
            hasEagerState: l2.hasEagerState,
            eagerState: l2.eagerState,
            next: null
          };
          null === k2 ? (h = k2 = q2, g = d) : k2 = k2.next = q2;
          M.lanes |= m2;
          rh |= m2;
        }
        l2 = l2.next;
      } while (null !== l2 && l2 !== f2);
      null === k2 ? g = d : k2.next = h;
      He(d, b.memoizedState) || (dh = true);
      b.memoizedState = d;
      b.baseState = g;
      b.baseQueue = k2;
      c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
      e = a;
      do
        f2 = e.lane, M.lanes |= f2, rh |= f2, e = e.next;
      while (e !== a);
    } else null === e && (c.lanes = 0);
    return [b.memoizedState, c.dispatch];
  }
  function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f2 = b.memoizedState;
    if (null !== e) {
      c.pending = null;
      var g = e = e.next;
      do
        f2 = a(f2, g.action), g = g.next;
      while (g !== e);
      He(f2, b.memoizedState) || (dh = true);
      b.memoizedState = f2;
      null === b.baseQueue && (b.baseState = f2);
      c.lastRenderedState = f2;
    }
    return [f2, d];
  }
  function Yh() {
  }
  function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f2 = !He(d.memoizedState, e);
    f2 && (d.memoizedState = e, dh = true);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [a]);
    if (d.getSnapshot !== b || f2 || null !== O && O.memoizedState.tag & 1) {
      c.flags |= 2048;
      bi(9, ci.bind(null, c, d, e, b), void 0, null);
      if (null === Q) throw Error(p(349));
      0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
  }
  function di(a, b, c) {
    a.flags |= 16384;
    a = { getSnapshot: b, value: c };
    b = M.updateQueue;
    null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
  }
  function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
  }
  function ai(a, b, c) {
    return c(function() {
      ei(b) && fi(a);
    });
  }
  function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var c = b();
      return !He(a, c);
    } catch (d) {
      return true;
    }
  }
  function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
  }
  function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [b.memoizedState, a];
  }
  function bi(a, b, c, d) {
    a = { tag: a, create: b, destroy: c, deps: d, next: null };
    b = M.updateQueue;
    null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
  }
  function ji() {
    return Uh().memoizedState;
  }
  function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
  }
  function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f2 = void 0;
    if (null !== N) {
      var g = N.memoizedState;
      f2 = g.destroy;
      if (null !== d && Mh(d, g.deps)) {
        e.memoizedState = bi(b, c, f2, d);
        return;
      }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f2, d);
  }
  function mi(a, b) {
    return ki(8390656, 8, a, b);
  }
  function $h(a, b) {
    return li(2048, 8, a, b);
  }
  function ni(a, b) {
    return li(4, 2, a, b);
  }
  function oi(a, b) {
    return li(4, 4, a, b);
  }
  function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
      b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
      b.current = null;
    };
  }
  function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
  }
  function ri() {
  }
  function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [a, b];
    return a;
  }
  function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [a, b];
    return a;
  }
  function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = false, dh = true), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = true);
    return b;
  }
  function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(true);
    var d = Gh.transition;
    Gh.transition = {};
    try {
      a(false), b();
    } finally {
      C = c, Gh.transition = d;
    }
  }
  function wi() {
    return Uh().memoizedState;
  }
  function xi(a, b, c) {
    var d = yi(a);
    c = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
      var e = R();
      gi(c, a, d, e);
      Bi(c, b, d);
    }
  }
  function ii(a, b, c) {
    var d = yi(a), e = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
    if (zi(a)) Ai(b, e);
    else {
      var f2 = a.alternate;
      if (0 === a.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b.lastRenderedReducer, null !== f2)) try {
        var g = b.lastRenderedState, h = f2(g, c);
        e.hasEagerState = true;
        e.eagerState = h;
        if (He(h, g)) {
          var k2 = b.interleaved;
          null === k2 ? (e.next = e, gh(b)) : (e.next = k2.next, k2.next = e);
          b.interleaved = e;
          return;
        }
      } catch (l2) {
      } finally {
      }
      c = hh(a, b, e, d);
      null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
  }
  function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
  }
  function Ai(a, b) {
    Jh = Ih = true;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
  function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
      var d = b.lanes;
      d &= a.pendingLanes;
      c |= d;
      b.lanes = c;
      Cc(a, c);
    }
  }
  var Rh = { readContext: eh, useCallback: P, useContext: P, useEffect: P, useImperativeHandle: P, useInsertionEffect: P, useLayoutEffect: P, useMemo: P, useReducer: P, useRef: P, useState: P, useDebugValue: P, useDeferredValue: P, useTransition: P, useMutableSource: P, useSyncExternalStore: P, useId: P, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a, b) {
    Th().memoizedState = [a, void 0 === b ? null : b];
    return a;
  }, useContext: eh, useEffect: mi, useImperativeHandle: function(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return ki(
      4194308,
      4,
      pi.bind(null, b, a),
      c
    );
  }, useLayoutEffect: function(a, b) {
    return ki(4194308, 4, a, b);
  }, useInsertionEffect: function(a, b) {
    return ki(4, 2, a, b);
  }, useMemo: function(a, b) {
    var c = Th();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  }, useReducer: function(a, b, c) {
    var d = Th();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
    d.queue = a;
    a = a.dispatch = xi.bind(null, M, a);
    return [d.memoizedState, a];
  }, useRef: function(a) {
    var b = Th();
    a = { current: a };
    return b.memoizedState = a;
  }, useState: hi, useDebugValue: ri, useDeferredValue: function(a) {
    return Th().memoizedState = a;
  }, useTransition: function() {
    var a = hi(false), b = a[0];
    a = vi.bind(null, a[1]);
    Th().memoizedState = a;
    return [b, a];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(a, b, c) {
    var d = M, e = Th();
    if (I) {
      if (void 0 === c) throw Error(p(407));
      c = c();
    } else {
      c = b();
      if (null === Q) throw Error(p(349));
      0 !== (Hh & 30) || di(d, b, c);
    }
    e.memoizedState = c;
    var f2 = { value: c, getSnapshot: b };
    e.queue = f2;
    mi(ai.bind(
      null,
      d,
      f2,
      a
    ), [a]);
    d.flags |= 2048;
    bi(9, ci.bind(null, d, f2, c, b), void 0, null);
    return c;
  }, useId: function() {
    var a = Th(), b = Q.identifierPrefix;
    if (I) {
      var c = sg;
      var d = rg;
      c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
      b = ":" + b + "R" + c;
      c = Kh++;
      0 < c && (b += "H" + c.toString(32));
      b += ":";
    } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
    return a.memoizedState = b;
  }, unstable_isNewReconciler: false }, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
      return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
      var b = Uh();
      return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
      var a = Wh(Vh)[0], b = Uh().memoizedState;
      return [a, b];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: false
  }, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
    return Xh(Vh);
  }, useDebugValue: ri, useDeferredValue: function(a) {
    var b = Uh();
    return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
  }, useTransition: function() {
    var a = Xh(Vh)[0], b = Uh().memoizedState;
    return [a, b];
  }, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
  function Ci(a, b) {
    if (a && a.defaultProps) {
      b = A({}, b);
      a = a.defaultProps;
      for (var c in a) void 0 === b[c] && (b[c] = a[c]);
      return b;
    }
    return b;
  }
  function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
  }
  var Ei = { isMounted: function(a) {
    return (a = a._reactInternals) ? Vb(a) === a : false;
  }, enqueueSetState: function(a, b, c) {
    a = a._reactInternals;
    var d = R(), e = yi(a), f2 = mh(d, e);
    f2.payload = b;
    void 0 !== c && null !== c && (f2.callback = c);
    b = nh(a, f2, e);
    null !== b && (gi(b, a, e, d), oh(b, a, e));
  }, enqueueReplaceState: function(a, b, c) {
    a = a._reactInternals;
    var d = R(), e = yi(a), f2 = mh(d, e);
    f2.tag = 1;
    f2.payload = b;
    void 0 !== c && null !== c && (f2.callback = c);
    b = nh(a, f2, e);
    null !== b && (gi(b, a, e, d), oh(b, a, e));
  }, enqueueForceUpdate: function(a, b) {
    a = a._reactInternals;
    var c = R(), d = yi(a), e = mh(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    b = nh(a, e, d);
    null !== b && (gi(b, a, d, c), oh(b, a, d));
  } };
  function Fi(a, b, c, d, e, f2, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f2, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f2) : true;
  }
  function Gi(a, b, c) {
    var d = false, e = Vf;
    var f2 = b.contextType;
    "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f2 = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f2);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f2);
    return b;
  }
  function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
  }
  function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f2 = b.contextType;
    "object" === typeof f2 && null !== f2 ? e.context = eh(f2) : (f2 = Zf(b) ? Xf : H.current, e.context = Yf(a, f2));
    e.state = a.memoizedState;
    f2 = b.getDerivedStateFromProps;
    "function" === typeof f2 && (Di(a, b, f2, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
  }
  function Ji(a, b) {
    try {
      var c = "", d = b;
      do
        c += Pa(d), d = d.return;
      while (d);
      var e = c;
    } catch (f2) {
      e = "\nError generating stack: " + f2.message + "\n" + f2.stack;
    }
    return { value: a, source: b, stack: e, digest: null };
  }
  function Ki(a, b, c) {
    return { value: a, source: null, stack: null != c ? c : null, digest: null != b ? b : null };
  }
  function Li(a, b) {
    try {
      console.error(b.value);
    } catch (c) {
      setTimeout(function() {
        throw c;
      });
    }
  }
  var Mi = "function" === typeof WeakMap ? WeakMap : Map;
  function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = { element: null };
    var d = b.value;
    c.callback = function() {
      Oi || (Oi = true, Pi = d);
      Li(a, b);
    };
    return c;
  }
  function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
      var e = b.value;
      c.payload = function() {
        return d(e);
      };
      c.callback = function() {
        Li(a, b);
      };
    }
    var f2 = a.stateNode;
    null !== f2 && "function" === typeof f2.componentDidCatch && (c.callback = function() {
      Li(a, b);
      "function" !== typeof d && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
      var c2 = b.stack;
      this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
    });
    return c;
  }
  function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
      d = a.pingCache = new Mi();
      var e = /* @__PURE__ */ new Set();
      d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = /* @__PURE__ */ new Set(), d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
  }
  function Ui(a) {
    do {
      var b;
      if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? true : false : true;
      if (b) return a;
      a = a.return;
    } while (null !== a);
    return null;
  }
  function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
  }
  var Wi = ua.ReactCurrentOwner, dh = false;
  function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
  }
  function Yi(a, b, c, d, e) {
    c = c.render;
    var f2 = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f2, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
  }
  function $i(a, b, c, d, e) {
    if (null === a) {
      var f2 = c.type;
      if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f2, bj(a, b, f2, d, e);
      a = Rg(c.type, null, d, b, b.mode, e);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }
    f2 = a.child;
    if (0 === (a.lanes & e)) {
      var g = f2.memoizedProps;
      c = c.compare;
      c = null !== c ? c : Ie;
      if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f2, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  function bj(a, b, c, d, e) {
    if (null !== a) {
      var f2 = a.memoizedProps;
      if (Ie(f2, d) && a.ref === b.ref) if (dh = false, b.pendingProps = d = f2, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = true);
      else return b.lanes = a.lanes, Zi(a, b, e);
    }
    return cj(a, b, c, d, e);
  }
  function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f2 = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) if (0 === (b.mode & 1)) b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G(ej, fj), fj |= c;
    else {
      if (0 === (c & 1073741824)) return a = null !== f2 ? f2.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a, cachePool: null, transitions: null }, b.updateQueue = null, G(ej, fj), fj |= a, null;
      b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
      d = null !== f2 ? f2.baseLanes : c;
      G(ej, fj);
      fj |= d;
    }
    else null !== f2 ? (d = f2.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
  }
  function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
  }
  function cj(a, b, c, d, e) {
    var f2 = Zf(c) ? Xf : H.current;
    f2 = Yf(b, f2);
    ch(b, e);
    c = Nh(a, b, c, d, f2, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
  }
  function hj(a, b, c, d, e) {
    if (Zf(c)) {
      var f2 = true;
      cg(b);
    } else f2 = false;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = true;
    else if (null === a) {
      var g = b.stateNode, h = b.memoizedProps;
      g.props = h;
      var k2 = g.context, l2 = c.contextType;
      "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c) ? Xf : H.current, l2 = Yf(b, l2));
      var m2 = c.getDerivedStateFromProps, q2 = "function" === typeof m2 || "function" === typeof g.getSnapshotBeforeUpdate;
      q2 || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k2 !== l2) && Hi(b, g, d, l2);
      jh = false;
      var r2 = b.memoizedState;
      g.state = r2;
      qh(b, d, g, e);
      k2 = b.memoizedState;
      h !== d || r2 !== k2 || Wf.current || jh ? ("function" === typeof m2 && (Di(b, c, m2, d), k2 = b.memoizedState), (h = jh || Fi(b, c, h, d, r2, k2, l2)) ? (q2 || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k2), g.props = d, g.state = k2, g.context = l2, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = false);
    } else {
      g = b.stateNode;
      lh(a, b);
      h = b.memoizedProps;
      l2 = b.type === b.elementType ? h : Ci(b.type, h);
      g.props = l2;
      q2 = b.pendingProps;
      r2 = g.context;
      k2 = c.contextType;
      "object" === typeof k2 && null !== k2 ? k2 = eh(k2) : (k2 = Zf(c) ? Xf : H.current, k2 = Yf(b, k2));
      var y2 = c.getDerivedStateFromProps;
      (m2 = "function" === typeof y2 || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q2 || r2 !== k2) && Hi(b, g, d, k2);
      jh = false;
      r2 = b.memoizedState;
      g.state = r2;
      qh(b, d, g, e);
      var n2 = b.memoizedState;
      h !== q2 || r2 !== n2 || Wf.current || jh ? ("function" === typeof y2 && (Di(b, c, y2, d), n2 = b.memoizedState), (l2 = jh || Fi(b, c, l2, d, r2, n2, k2) || false) ? (m2 || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n2, k2), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n2, k2)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n2), g.props = d, g.state = n2, g.context = k2, d = l2) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), d = false);
    }
    return jj(a, b, c, d, f2, e);
  }
  function jj(a, b, c, d, e, f2) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, false), Zi(a, b, f2);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f2), b.child = Ug(b, null, h, f2)) : Xi(a, b, h, f2);
    b.memoizedState = d.state;
    e && dg(b, c, true);
    return b.child;
  }
  function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, false);
    yh(a, b.containerInfo);
  }
  function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
  }
  var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
  function nj(a) {
    return { baseLanes: a, cachePool: null, transitions: null };
  }
  function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f2 = false, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? false : 0 !== (e & 2));
    if (h) f2 = true, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
      Eg(b);
      a = b.memoizedState;
      if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
      g = d.children;
      a = d.fallback;
      return f2 ? (d = b.mode, f2 = b.child, g = { mode: "hidden", children: g }, 0 === (d & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g) : f2 = pj(g, d, 0, null), a = Tg(a, d, c, null), f2.return = b, a.return = b, f2.sibling = a, b.child = f2, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f2) {
      f2 = d.fallback;
      g = b.mode;
      e = a.child;
      h = e.sibling;
      var k2 = { mode: "hidden", children: d.children };
      0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k2, b.deletions = null) : (d = Pg(e, k2), d.subtreeFlags = e.subtreeFlags & 14680064);
      null !== h ? f2 = Pg(h, f2) : (f2 = Tg(f2, g, c, null), f2.flags |= 2);
      f2.return = b;
      d.return = b;
      d.sibling = f2;
      b.child = d;
      d = f2;
      f2 = b.child;
      g = a.child.memoizedState;
      g = null === g ? nj(c) : { baseLanes: g.baseLanes | c, cachePool: null, transitions: g.transitions };
      f2.memoizedState = g;
      f2.childLanes = a.childLanes & ~c;
      b.memoizedState = mj;
      return d;
    }
    f2 = a.child;
    a = f2.sibling;
    d = Pg(f2, { mode: "visible", children: d.children });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [a], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
  }
  function qj(a, b) {
    b = pj({ mode: "visible", children: b }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
  }
  function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
  }
  function rj(a, b, c, d, e, f2, g) {
    if (c) {
      if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
      if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
      f2 = d.fallback;
      e = b.mode;
      d = pj({ mode: "visible", children: d.children }, e, 0, null);
      f2 = Tg(f2, e, g, null);
      f2.flags |= 2;
      d.return = b;
      f2.return = b;
      d.sibling = f2;
      b.child = d;
      0 !== (b.mode & 1) && Ug(b, a.child, null, g);
      b.child.memoizedState = nj(g);
      b.memoizedState = mj;
      return f2;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
      d = e.nextSibling && e.nextSibling.dataset;
      if (d) var h = d.dgst;
      d = h;
      f2 = Error(p(419));
      d = Ki(f2, d, void 0);
      return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
      d = Q;
      if (null !== d) {
        switch (g & -g) {
          case 4:
            e = 2;
            break;
          case 16:
            e = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            e = 32;
            break;
          case 536870912:
            e = 268435456;
            break;
          default:
            e = 0;
        }
        e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
        0 !== e && e !== f2.retryLane && (f2.retryLane = e, ih(a, e), gi(d, a, e, -1));
      }
      tj();
      d = Ki(Error(p(421)));
      return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f2.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = true;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
  }
  function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
  }
  function wj(a, b, c, d, e) {
    var f2 = a.memoizedState;
    null === f2 ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailMode: e } : (f2.isBackwards = b, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d, f2.tail = c, f2.tailMode = e);
  }
  function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f2 = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
      if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a; ) {
        if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
        else if (19 === a.tag) vj(a, c, b);
        else if (null !== a.child) {
          a.child.return = a;
          a = a.child;
          continue;
        }
        if (a === b) break a;
        for (; null === a.sibling; ) {
          if (null === a.return || a.return === b) break a;
          a = a.return;
        }
        a.sibling.return = a.return;
        a = a.sibling;
      }
      d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch (e) {
      case "forwards":
        c = b.child;
        for (e = null; null !== c; ) a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
        c = e;
        null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        wj(b, false, e, c, f2);
        break;
      case "backwards":
        c = null;
        e = b.child;
        for (b.child = null; null !== e; ) {
          a = e.alternate;
          if (null !== a && null === Ch(a)) {
            b.child = e;
            break;
          }
          a = e.sibling;
          e.sibling = c;
          c = e;
          e = a;
        }
        wj(b, true, c, null, f2);
        break;
      case "together":
        wj(b, false, null, null, void 0);
        break;
      default:
        b.memoizedState = null;
    }
    return b.child;
  }
  function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
  }
  function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
      a = b.child;
      c = Pg(a, a.pendingProps);
      b.child = c;
      for (c.return = b; null !== a.sibling; ) a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
      c.sibling = null;
    }
    return b.child;
  }
  function yj(a, b, c) {
    switch (b.tag) {
      case 3:
        kj(b);
        Ig();
        break;
      case 5:
        Ah(b);
        break;
      case 1:
        Zf(b.type) && cg(b);
        break;
      case 4:
        yh(b, b.stateNode.containerInfo);
        break;
      case 10:
        var d = b.type._context, e = b.memoizedProps.value;
        G(Wg, d._currentValue);
        d._currentValue = e;
        break;
      case 13:
        d = b.memoizedState;
        if (null !== d) {
          if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
          if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
          G(L, L.current & 1);
          a = Zi(a, b, c);
          return null !== a ? a.sibling : null;
        }
        G(L, L.current & 1);
        break;
      case 19:
        d = 0 !== (c & b.childLanes);
        if (0 !== (a.flags & 128)) {
          if (d) return xj(a, b, c);
          b.flags |= 128;
        }
        e = b.memoizedState;
        null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
        G(L, L.current);
        if (d) break;
        else return null;
      case 22:
      case 23:
        return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
  }
  var zj, Aj, Bj, Cj;
  zj = function(a, b) {
    for (var c = b.child; null !== c; ) {
      if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
      else if (4 !== c.tag && null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }
      if (c === b) break;
      for (; null === c.sibling; ) {
        if (null === c.return || c.return === b) return;
        c = c.return;
      }
      c.sibling.return = c.return;
      c = c.sibling;
    }
  };
  Aj = function() {
  };
  Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
      a = b.stateNode;
      xh(uh.current);
      var f2 = null;
      switch (c) {
        case "input":
          e = Ya(a, e);
          d = Ya(a, d);
          f2 = [];
          break;
        case "select":
          e = A({}, e, { value: void 0 });
          d = A({}, d, { value: void 0 });
          f2 = [];
          break;
        case "textarea":
          e = gb(a, e);
          d = gb(a, d);
          f2 = [];
          break;
        default:
          "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
      }
      ub(c, d);
      var g;
      c = null;
      for (l2 in e) if (!d.hasOwnProperty(l2) && e.hasOwnProperty(l2) && null != e[l2]) if ("style" === l2) {
        var h = e[l2];
        for (g in h) h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
      } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
      for (l2 in d) {
        var k2 = d[l2];
        h = null != e ? e[l2] : void 0;
        if (d.hasOwnProperty(l2) && k2 !== h && (null != k2 || null != h)) if ("style" === l2) if (h) {
          for (g in h) !h.hasOwnProperty(g) || k2 && k2.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          for (g in k2) k2.hasOwnProperty(g) && h[g] !== k2[g] && (c || (c = {}), c[g] = k2[g]);
        } else c || (f2 || (f2 = []), f2.push(
          l2,
          c
        )), c = k2;
        else "dangerouslySetInnerHTML" === l2 ? (k2 = k2 ? k2.__html : void 0, h = h ? h.__html : void 0, null != k2 && h !== k2 && (f2 = f2 || []).push(l2, k2)) : "children" === l2 ? "string" !== typeof k2 && "number" !== typeof k2 || (f2 = f2 || []).push(l2, "" + k2) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k2 && "onScroll" === l2 && D("scroll", a), f2 || h === k2 || (f2 = [])) : (f2 = f2 || []).push(l2, k2));
      }
      c && (f2 = f2 || []).push("style", c);
      var l2 = f2;
      if (b.updateQueue = l2) b.flags |= 4;
    }
  };
  Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
  };
  function Dj(a, b) {
    if (!I) switch (a.tailMode) {
      case "hidden":
        b = a.tail;
        for (var c = null; null !== b; ) null !== b.alternate && (c = b), b = b.sibling;
        null === c ? a.tail = null : c.sibling = null;
        break;
      case "collapsed":
        c = a.tail;
        for (var d = null; null !== c; ) null !== c.alternate && (d = c), c = c.sibling;
        null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
  }
  function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for (var e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for (e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
  }
  function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch (b.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return S(b), null;
      case 1:
        return Zf(b.type) && $f(), S(b), null;
      case 3:
        d = b.stateNode;
        zh();
        E(Wf);
        E(H);
        Eh();
        d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
        if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
        Aj(a, b);
        S(b);
        return null;
      case 5:
        Bh(b);
        var e = xh(wh.current);
        c = b.type;
        if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
        else {
          if (!d) {
            if (null === b.stateNode) throw Error(p(166));
            S(b);
            return null;
          }
          a = xh(uh.current);
          if (Gg(b)) {
            d = b.stateNode;
            c = b.type;
            var f2 = b.memoizedProps;
            d[Of] = b;
            d[Pf] = f2;
            a = 0 !== (b.mode & 1);
            switch (c) {
              case "dialog":
                D("cancel", d);
                D("close", d);
                break;
              case "iframe":
              case "object":
              case "embed":
                D("load", d);
                break;
              case "video":
              case "audio":
                for (e = 0; e < lf.length; e++) D(lf[e], d);
                break;
              case "source":
                D("error", d);
                break;
              case "img":
              case "image":
              case "link":
                D(
                  "error",
                  d
                );
                D("load", d);
                break;
              case "details":
                D("toggle", d);
                break;
              case "input":
                Za(d, f2);
                D("invalid", d);
                break;
              case "select":
                d._wrapperState = { wasMultiple: !!f2.multiple };
                D("invalid", d);
                break;
              case "textarea":
                hb(d, f2), D("invalid", d);
            }
            ub(c, f2);
            e = null;
            for (var g in f2) if (f2.hasOwnProperty(g)) {
              var h = f2[g];
              "children" === g ? "string" === typeof h ? d.textContent !== h && (true !== f2.suppressHydrationWarning && Af(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (true !== f2.suppressHydrationWarning && Af(
                d.textContent,
                h,
                a
              ), e = ["children", "" + h]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
            }
            switch (c) {
              case "input":
                Va(d);
                db(d, f2, true);
                break;
              case "textarea":
                Va(d);
                jb(d);
                break;
              case "select":
              case "option":
                break;
              default:
                "function" === typeof f2.onClick && (d.onclick = Bf);
            }
            d = e;
            b.updateQueue = d;
            null !== d && (b.flags |= 4);
          } else {
            g = 9 === e.nodeType ? e : e.ownerDocument;
            "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
            "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, { is: d.is }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = true : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
            a[Of] = b;
            a[Pf] = d;
            zj(a, b, false, false);
            b.stateNode = a;
            a: {
              g = vb(c, d);
              switch (c) {
                case "dialog":
                  D("cancel", a);
                  D("close", a);
                  e = d;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  D("load", a);
                  e = d;
                  break;
                case "video":
                case "audio":
                  for (e = 0; e < lf.length; e++) D(lf[e], a);
                  e = d;
                  break;
                case "source":
                  D("error", a);
                  e = d;
                  break;
                case "img":
                case "image":
                case "link":
                  D(
                    "error",
                    a
                  );
                  D("load", a);
                  e = d;
                  break;
                case "details":
                  D("toggle", a);
                  e = d;
                  break;
                case "input":
                  Za(a, d);
                  e = Ya(a, d);
                  D("invalid", a);
                  break;
                case "option":
                  e = d;
                  break;
                case "select":
                  a._wrapperState = { wasMultiple: !!d.multiple };
                  e = A({}, d, { value: void 0 });
                  D("invalid", a);
                  break;
                case "textarea":
                  hb(a, d);
                  e = gb(a, d);
                  D("invalid", a);
                  break;
                default:
                  e = d;
              }
              ub(c, e);
              h = e;
              for (f2 in h) if (h.hasOwnProperty(f2)) {
                var k2 = h[f2];
                "style" === f2 ? sb(a, k2) : "dangerouslySetInnerHTML" === f2 ? (k2 = k2 ? k2.__html : void 0, null != k2 && nb(a, k2)) : "children" === f2 ? "string" === typeof k2 ? ("textarea" !== c || "" !== k2) && ob(a, k2) : "number" === typeof k2 && ob(a, "" + k2) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k2 && "onScroll" === f2 && D("scroll", a) : null != k2 && ta(a, f2, k2, g));
              }
              switch (c) {
                case "input":
                  Va(a);
                  db(a, d, false);
                  break;
                case "textarea":
                  Va(a);
                  jb(a);
                  break;
                case "option":
                  null != d.value && a.setAttribute("value", "" + Sa(d.value));
                  break;
                case "select":
                  a.multiple = !!d.multiple;
                  f2 = d.value;
                  null != f2 ? fb(a, !!d.multiple, f2, false) : null != d.defaultValue && fb(
                    a,
                    !!d.multiple,
                    d.defaultValue,
                    true
                  );
                  break;
                default:
                  "function" === typeof e.onClick && (a.onclick = Bf);
              }
              switch (c) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d = !!d.autoFocus;
                  break a;
                case "img":
                  d = true;
                  break a;
                default:
                  d = false;
              }
            }
            d && (b.flags |= 4);
          }
          null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
        }
        S(b);
        return null;
      case 6:
        if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
        else {
          if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
          c = xh(wh.current);
          xh(uh.current);
          if (Gg(b)) {
            d = b.stateNode;
            c = b.memoizedProps;
            d[Of] = b;
            if (f2 = d.nodeValue !== c) {
              if (a = xg, null !== a) switch (a.tag) {
                case 3:
                  Af(d.nodeValue, c, 0 !== (a.mode & 1));
                  break;
                case 5:
                  true !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
              }
            }
            f2 && (b.flags |= 4);
          } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
        }
        S(b);
        return null;
      case 13:
        E(L);
        d = b.memoizedState;
        if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
          if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f2 = false;
          else if (f2 = Gg(b), null !== d && null !== d.dehydrated) {
            if (null === a) {
              if (!f2) throw Error(p(318));
              f2 = b.memoizedState;
              f2 = null !== f2 ? f2.dehydrated : null;
              if (!f2) throw Error(p(317));
              f2[Of] = b;
            } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
            S(b);
            f2 = false;
          } else null !== zg && (Fj(zg), zg = null), f2 = true;
          if (!f2) return b.flags & 65536 ? b : null;
        }
        if (0 !== (b.flags & 128)) return b.lanes = c, b;
        d = null !== d;
        d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
        null !== b.updateQueue && (b.flags |= 4);
        S(b);
        return null;
      case 4:
        return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
      case 10:
        return ah(b.type._context), S(b), null;
      case 17:
        return Zf(b.type) && $f(), S(b), null;
      case 19:
        E(L);
        f2 = b.memoizedState;
        if (null === f2) return S(b), null;
        d = 0 !== (b.flags & 128);
        g = f2.rendering;
        if (null === g) if (d) Dj(f2, false);
        else {
          if (0 !== T || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a; ) {
            g = Ch(a);
            if (null !== g) {
              b.flags |= 128;
              Dj(f2, false);
              d = g.updateQueue;
              null !== d && (b.updateQueue = d, b.flags |= 4);
              b.subtreeFlags = 0;
              d = c;
              for (c = b.child; null !== c; ) f2 = c, a = d, f2.flags &= 14680066, g = f2.alternate, null === g ? (f2.childLanes = 0, f2.lanes = a, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g.childLanes, f2.lanes = g.lanes, f2.child = g.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g.memoizedProps, f2.memoizedState = g.memoizedState, f2.updateQueue = g.updateQueue, f2.type = g.type, a = g.dependencies, f2.dependencies = null === a ? null : { lanes: a.lanes, firstContext: a.firstContext }), c = c.sibling;
              G(L, L.current & 1 | 2);
              return b.child;
            }
            a = a.sibling;
          }
          null !== f2.tail && B() > Gj && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
        }
        else {
          if (!d) if (a = Ch(g), null !== a) {
            if (b.flags |= 128, d = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g.alternate && !I) return S(b), null;
          } else 2 * B() - f2.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
          f2.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f2.last, null !== c ? c.sibling = g : b.child = g, f2.last = g);
        }
        if (null !== f2.tail) return b = f2.tail, f2.rendering = b, f2.tail = b.sibling, f2.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
        S(b);
        return null;
      case 22:
      case 23:
        return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(p(156, b.tag));
  }
  function Ij(a, b) {
    wg(b);
    switch (b.tag) {
      case 1:
        return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
      case 3:
        return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
      case 5:
        return Bh(b), null;
      case 13:
        E(L);
        a = b.memoizedState;
        if (null !== a && null !== a.dehydrated) {
          if (null === b.alternate) throw Error(p(340));
          Ig();
        }
        a = b.flags;
        return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
      case 19:
        return E(L), null;
      case 4:
        return zh(), null;
      case 10:
        return ah(b.type._context), null;
      case 22:
      case 23:
        return Hj(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Jj = false, U = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
  function Lj(a, b) {
    var c = a.ref;
    if (null !== c) if ("function" === typeof c) try {
      c(null);
    } catch (d) {
      W(a, b, d);
    }
    else c.current = null;
  }
  function Mj(a, b, c) {
    try {
      c();
    } catch (d) {
      W(a, b, d);
    }
  }
  var Nj = false;
  function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
      if ("selectionStart" in a) var c = { start: a.selectionStart, end: a.selectionEnd };
      else a: {
        c = (c = a.ownerDocument) && c.defaultView || window;
        var d = c.getSelection && c.getSelection();
        if (d && 0 !== d.rangeCount) {
          c = d.anchorNode;
          var e = d.anchorOffset, f2 = d.focusNode;
          d = d.focusOffset;
          try {
            c.nodeType, f2.nodeType;
          } catch (F2) {
            c = null;
            break a;
          }
          var g = 0, h = -1, k2 = -1, l2 = 0, m2 = 0, q2 = a, r2 = null;
          b: for (; ; ) {
            for (var y2; ; ) {
              q2 !== c || 0 !== e && 3 !== q2.nodeType || (h = g + e);
              q2 !== f2 || 0 !== d && 3 !== q2.nodeType || (k2 = g + d);
              3 === q2.nodeType && (g += q2.nodeValue.length);
              if (null === (y2 = q2.firstChild)) break;
              r2 = q2;
              q2 = y2;
            }
            for (; ; ) {
              if (q2 === a) break b;
              r2 === c && ++l2 === e && (h = g);
              r2 === f2 && ++m2 === d && (k2 = g);
              if (null !== (y2 = q2.nextSibling)) break;
              q2 = r2;
              r2 = q2.parentNode;
            }
            q2 = y2;
          }
          c = -1 === h || -1 === k2 ? null : { start: h, end: k2 };
        } else c = null;
      }
      c = c || { start: 0, end: 0 };
    } else c = null;
    Df = { focusedElem: a, selectionRange: c };
    dd = false;
    for (V = b; null !== V; ) if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for (; null !== V; ) {
      b = V;
      try {
        var n2 = b.alternate;
        if (0 !== (b.flags & 1024)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (null !== n2) {
              var t2 = n2.memoizedProps, J2 = n2.memoizedState, x2 = b.stateNode, w2 = x2.getSnapshotBeforeUpdate(b.elementType === b.type ? t2 : Ci(b.type, t2), J2);
              x2.__reactInternalSnapshotBeforeUpdate = w2;
            }
            break;
          case 3:
            var u2 = b.stateNode.containerInfo;
            1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(p(163));
        }
      } catch (F2) {
        W(b, b.return, F2);
      }
      a = b.sibling;
      if (null !== a) {
        a.return = b.return;
        V = a;
        break;
      }
      V = b.return;
    }
    n2 = Nj;
    Nj = false;
    return n2;
  }
  function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
      var e = d = d.next;
      do {
        if ((e.tag & a) === a) {
          var f2 = e.destroy;
          e.destroy = void 0;
          void 0 !== f2 && Mj(b, c, f2);
        }
        e = e.next;
      } while (e !== d);
    }
  }
  function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
      var c = b = b.next;
      do {
        if ((c.tag & a) === a) {
          var d = c.create;
          c.destroy = d();
        }
        c = c.next;
      } while (c !== b);
    }
  }
  function Rj(a) {
    var b = a.ref;
    if (null !== b) {
      var c = a.stateNode;
      switch (a.tag) {
        case 5:
          a = c;
          break;
        default:
          a = c;
      }
      "function" === typeof b ? b(a) : b.current = a;
    }
  }
  function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
  }
  function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }
  function Uj(a) {
    a: for (; ; ) {
      for (; null === a.sibling; ) {
        if (null === a.return || Tj(a.return)) return null;
        a = a.return;
      }
      a.sibling.return = a.return;
      for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag; ) {
        if (a.flags & 2) continue a;
        if (null === a.child || 4 === a.tag) continue a;
        else a.child.return = a, a = a.child;
      }
      if (!(a.flags & 2)) return a.stateNode;
    }
  }
  function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for (Vj(a, b, c), a = a.sibling; null !== a; ) Vj(a, b, c), a = a.sibling;
  }
  function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for (Wj(a, b, c), a = a.sibling; null !== a; ) Wj(a, b, c), a = a.sibling;
  }
  var X = null, Xj = false;
  function Yj(a, b, c) {
    for (c = c.child; null !== c; ) Zj(a, b, c), c = c.sibling;
  }
  function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
      lc.onCommitFiberUnmount(kc, c);
    } catch (h) {
    }
    switch (c.tag) {
      case 5:
        U || Lj(c, b);
      case 6:
        var d = X, e = Xj;
        X = null;
        Yj(a, b, c);
        X = d;
        Xj = e;
        null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
        break;
      case 18:
        null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
        break;
      case 4:
        d = X;
        e = Xj;
        X = c.stateNode.containerInfo;
        Xj = true;
        Yj(a, b, c);
        X = d;
        Xj = e;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
          e = d = d.next;
          do {
            var f2 = e, g = f2.destroy;
            f2 = f2.tag;
            void 0 !== g && (0 !== (f2 & 2) ? Mj(c, b, g) : 0 !== (f2 & 4) && Mj(c, b, g));
            e = e.next;
          } while (e !== d);
        }
        Yj(a, b, c);
        break;
      case 1:
        if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
          d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
        } catch (h) {
          W(c, b, h);
        }
        Yj(a, b, c);
        break;
      case 21:
        Yj(a, b, c);
        break;
      case 22:
        c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
        break;
      default:
        Yj(a, b, c);
    }
  }
  function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
      a.updateQueue = null;
      var c = a.stateNode;
      null === c && (c = a.stateNode = new Kj());
      b.forEach(function(b2) {
        var d = bk.bind(null, a, b2);
        c.has(b2) || (c.add(b2), b2.then(d, d));
      });
    }
  }
  function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for (var d = 0; d < c.length; d++) {
      var e = c[d];
      try {
        var f2 = a, g = b, h = g;
        a: for (; null !== h; ) {
          switch (h.tag) {
            case 5:
              X = h.stateNode;
              Xj = false;
              break a;
            case 3:
              X = h.stateNode.containerInfo;
              Xj = true;
              break a;
            case 4:
              X = h.stateNode.containerInfo;
              Xj = true;
              break a;
          }
          h = h.return;
        }
        if (null === X) throw Error(p(160));
        Zj(f2, g, e);
        X = null;
        Xj = false;
        var k2 = e.alternate;
        null !== k2 && (k2.return = null);
        e.return = null;
      } catch (l2) {
        W(e, b, l2);
      }
    }
    if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a), b = b.sibling;
  }
  function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ck(b, a);
        ek(a);
        if (d & 4) {
          try {
            Pj(3, a, a.return), Qj(3, a);
          } catch (t2) {
            W(a, a.return, t2);
          }
          try {
            Pj(5, a, a.return);
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 1:
        ck(b, a);
        ek(a);
        d & 512 && null !== c && Lj(c, c.return);
        break;
      case 5:
        ck(b, a);
        ek(a);
        d & 512 && null !== c && Lj(c, c.return);
        if (a.flags & 32) {
          var e = a.stateNode;
          try {
            ob(e, "");
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        if (d & 4 && (e = a.stateNode, null != e)) {
          var f2 = a.memoizedProps, g = null !== c ? c.memoizedProps : f2, h = a.type, k2 = a.updateQueue;
          a.updateQueue = null;
          if (null !== k2) try {
            "input" === h && "radio" === f2.type && null != f2.name && ab(e, f2);
            vb(h, g);
            var l2 = vb(h, f2);
            for (g = 0; g < k2.length; g += 2) {
              var m2 = k2[g], q2 = k2[g + 1];
              "style" === m2 ? sb(e, q2) : "dangerouslySetInnerHTML" === m2 ? nb(e, q2) : "children" === m2 ? ob(e, q2) : ta(e, m2, q2, l2);
            }
            switch (h) {
              case "input":
                bb(e, f2);
                break;
              case "textarea":
                ib(e, f2);
                break;
              case "select":
                var r2 = e._wrapperState.wasMultiple;
                e._wrapperState.wasMultiple = !!f2.multiple;
                var y2 = f2.value;
                null != y2 ? fb(e, !!f2.multiple, y2, false) : r2 !== !!f2.multiple && (null != f2.defaultValue ? fb(
                  e,
                  !!f2.multiple,
                  f2.defaultValue,
                  true
                ) : fb(e, !!f2.multiple, f2.multiple ? [] : "", false));
            }
            e[Pf] = f2;
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 6:
        ck(b, a);
        ek(a);
        if (d & 4) {
          if (null === a.stateNode) throw Error(p(162));
          e = a.stateNode;
          f2 = a.memoizedProps;
          try {
            e.nodeValue = f2;
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 3:
        ck(b, a);
        ek(a);
        if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
          bd(b.containerInfo);
        } catch (t2) {
          W(a, a.return, t2);
        }
        break;
      case 4:
        ck(b, a);
        ek(a);
        break;
      case 13:
        ck(b, a);
        ek(a);
        e = a.child;
        e.flags & 8192 && (f2 = null !== e.memoizedState, e.stateNode.isHidden = f2, !f2 || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
        d & 4 && ak(a);
        break;
      case 22:
        m2 = null !== c && null !== c.memoizedState;
        a.mode & 1 ? (U = (l2 = U) || m2, ck(b, a), U = l2) : ck(b, a);
        ek(a);
        if (d & 8192) {
          l2 = null !== a.memoizedState;
          if ((a.stateNode.isHidden = l2) && !m2 && 0 !== (a.mode & 1)) for (V = a, m2 = a.child; null !== m2; ) {
            for (q2 = V = m2; null !== V; ) {
              r2 = V;
              y2 = r2.child;
              switch (r2.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pj(4, r2, r2.return);
                  break;
                case 1:
                  Lj(r2, r2.return);
                  var n2 = r2.stateNode;
                  if ("function" === typeof n2.componentWillUnmount) {
                    d = r2;
                    c = r2.return;
                    try {
                      b = d, n2.props = b.memoizedProps, n2.state = b.memoizedState, n2.componentWillUnmount();
                    } catch (t2) {
                      W(d, c, t2);
                    }
                  }
                  break;
                case 5:
                  Lj(r2, r2.return);
                  break;
                case 22:
                  if (null !== r2.memoizedState) {
                    gk(q2);
                    continue;
                  }
              }
              null !== y2 ? (y2.return = r2, V = y2) : gk(q2);
            }
            m2 = m2.sibling;
          }
          a: for (m2 = null, q2 = a; ; ) {
            if (5 === q2.tag) {
              if (null === m2) {
                m2 = q2;
                try {
                  e = q2.stateNode, l2 ? (f2 = e.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h = q2.stateNode, k2 = q2.memoizedProps.style, g = void 0 !== k2 && null !== k2 && k2.hasOwnProperty("display") ? k2.display : null, h.style.display = rb("display", g));
                } catch (t2) {
                  W(a, a.return, t2);
                }
              }
            } else if (6 === q2.tag) {
              if (null === m2) try {
                q2.stateNode.nodeValue = l2 ? "" : q2.memoizedProps;
              } catch (t2) {
                W(a, a.return, t2);
              }
            } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === a) && null !== q2.child) {
              q2.child.return = q2;
              q2 = q2.child;
              continue;
            }
            if (q2 === a) break a;
            for (; null === q2.sibling; ) {
              if (null === q2.return || q2.return === a) break a;
              m2 === q2 && (m2 = null);
              q2 = q2.return;
            }
            m2 === q2 && (m2 = null);
            q2.sibling.return = q2.return;
            q2 = q2.sibling;
          }
        }
        break;
      case 19:
        ck(b, a);
        ek(a);
        d & 4 && ak(a);
        break;
      case 21:
        break;
      default:
        ck(
          b,
          a
        ), ek(a);
    }
  }
  function ek(a) {
    var b = a.flags;
    if (b & 2) {
      try {
        a: {
          for (var c = a.return; null !== c; ) {
            if (Tj(c)) {
              var d = c;
              break a;
            }
            c = c.return;
          }
          throw Error(p(160));
        }
        switch (d.tag) {
          case 5:
            var e = d.stateNode;
            d.flags & 32 && (ob(e, ""), d.flags &= -33);
            var f2 = Uj(a);
            Wj(a, f2, e);
            break;
          case 3:
          case 4:
            var g = d.stateNode.containerInfo, h = Uj(a);
            Vj(a, h, g);
            break;
          default:
            throw Error(p(161));
        }
      } catch (k2) {
        W(a, a.return, k2);
      }
      a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
  }
  function hk(a, b, c) {
    V = a;
    ik(a);
  }
  function ik(a, b, c) {
    for (var d = 0 !== (a.mode & 1); null !== V; ) {
      var e = V, f2 = e.child;
      if (22 === e.tag && d) {
        var g = null !== e.memoizedState || Jj;
        if (!g) {
          var h = e.alternate, k2 = null !== h && null !== h.memoizedState || U;
          h = Jj;
          var l2 = U;
          Jj = g;
          if ((U = k2) && !l2) for (V = e; null !== V; ) g = V, k2 = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k2 ? (k2.return = g, V = k2) : jk(e);
          for (; null !== f2; ) V = f2, ik(f2), f2 = f2.sibling;
          V = e;
          Jj = h;
          U = l2;
        }
        kk(a);
      } else 0 !== (e.subtreeFlags & 8772) && null !== f2 ? (f2.return = e, V = f2) : kk(a);
    }
  }
  function kk(a) {
    for (; null !== V; ) {
      var b = V;
      if (0 !== (b.flags & 8772)) {
        var c = b.alternate;
        try {
          if (0 !== (b.flags & 8772)) switch (b.tag) {
            case 0:
            case 11:
            case 15:
              U || Qj(5, b);
              break;
            case 1:
              var d = b.stateNode;
              if (b.flags & 4 && !U) if (null === c) d.componentDidMount();
              else {
                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
              }
              var f2 = b.updateQueue;
              null !== f2 && sh(b, f2, d);
              break;
            case 3:
              var g = b.updateQueue;
              if (null !== g) {
                c = null;
                if (null !== b.child) switch (b.child.tag) {
                  case 5:
                    c = b.child.stateNode;
                    break;
                  case 1:
                    c = b.child.stateNode;
                }
                sh(b, g, c);
              }
              break;
            case 5:
              var h = b.stateNode;
              if (null === c && b.flags & 4) {
                c = h;
                var k2 = b.memoizedProps;
                switch (b.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    k2.autoFocus && c.focus();
                    break;
                  case "img":
                    k2.src && (c.src = k2.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (null === b.memoizedState) {
                var l2 = b.alternate;
                if (null !== l2) {
                  var m2 = l2.memoizedState;
                  if (null !== m2) {
                    var q2 = m2.dehydrated;
                    null !== q2 && bd(q2);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(p(163));
          }
          U || b.flags & 512 && Rj(b);
        } catch (r2) {
          W(b, b.return, r2);
        }
      }
      if (b === a) {
        V = null;
        break;
      }
      c = b.sibling;
      if (null !== c) {
        c.return = b.return;
        V = c;
        break;
      }
      V = b.return;
    }
  }
  function gk(a) {
    for (; null !== V; ) {
      var b = V;
      if (b === a) {
        V = null;
        break;
      }
      var c = b.sibling;
      if (null !== c) {
        c.return = b.return;
        V = c;
        break;
      }
      V = b.return;
    }
  }
  function jk(a) {
    for (; null !== V; ) {
      var b = V;
      try {
        switch (b.tag) {
          case 0:
          case 11:
          case 15:
            var c = b.return;
            try {
              Qj(4, b);
            } catch (k2) {
              W(b, c, k2);
            }
            break;
          case 1:
            var d = b.stateNode;
            if ("function" === typeof d.componentDidMount) {
              var e = b.return;
              try {
                d.componentDidMount();
              } catch (k2) {
                W(b, e, k2);
              }
            }
            var f2 = b.return;
            try {
              Rj(b);
            } catch (k2) {
              W(b, f2, k2);
            }
            break;
          case 5:
            var g = b.return;
            try {
              Rj(b);
            } catch (k2) {
              W(b, g, k2);
            }
        }
      } catch (k2) {
        W(b, b.return, k2);
      }
      if (b === a) {
        V = null;
        break;
      }
      var h = b.sibling;
      if (null !== h) {
        h.return = b.return;
        V = h;
        break;
      }
      V = b.return;
    }
  }
  var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
  function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
  }
  function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
  }
  function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
  }
  function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
      null != c && bc(c);
      if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
        0 === (K & 6) && jg();
      }), c = null;
      else {
        switch (Dc(d)) {
          case 1:
            c = fc;
            break;
          case 4:
            c = gc;
            break;
          case 16:
            c = hc;
            break;
          case 536870912:
            c = jc;
            break;
          default:
            c = hc;
        }
        c = Fk(c, Gk.bind(null, a));
      }
      a.callbackPriority = b;
      a.callbackNode = c;
    }
  }
  function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
      b = d;
      var e = K;
      K |= 2;
      var f2 = Jk();
      if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
      do
        try {
          Lk();
          break;
        } catch (h) {
          Mk(a, h);
        }
      while (1);
      $g();
      mk.current = f2;
      K = e;
      null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
      2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
      if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
      if (6 === b) Ck(a, d);
      else {
        e = a.current.alternate;
        if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f2 = xc(a), 0 !== f2 && (d = f2, b = Nk(a, f2))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        a.finishedWork = e;
        a.finishedLanes = d;
        switch (b) {
          case 0:
          case 1:
            throw Error(p(345));
          case 2:
            Pk(a, tk, uk);
            break;
          case 3:
            Ck(a, d);
            if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
              if (0 !== uc(a, 0)) break;
              e = a.suspendedLanes;
              if ((e & d) !== d) {
                R();
                a.pingedLanes |= a.suspendedLanes & e;
                break;
              }
              a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
              break;
            }
            Pk(a, tk, uk);
            break;
          case 4:
            Ck(a, d);
            if ((d & 4194240) === d) break;
            b = a.eventTimes;
            for (e = -1; 0 < d; ) {
              var g = 31 - oc(d);
              f2 = 1 << g;
              g = b[g];
              g > e && (e = g);
              d &= ~f2;
            }
            d = e;
            d = B() - d;
            d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
            if (10 < d) {
              a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
              break;
            }
            Pk(a, tk, uk);
            break;
          case 5:
            Pk(a, tk, uk);
            break;
          default:
            throw Error(p(329));
        }
      }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
  }
  function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
  }
  function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
  }
  function Ok(a) {
    for (var b = a; ; ) {
      if (b.flags & 16384) {
        var c = b.updateQueue;
        if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
          var e = c[d], f2 = e.getSnapshot;
          e = e.value;
          try {
            if (!He(f2(), e)) return false;
          } catch (g) {
            return false;
          }
        }
      }
      c = b.child;
      if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
      else {
        if (b === a) break;
        for (; null === b.sibling; ) {
          if (null === b.return || b.return === a) return true;
          b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
      }
    }
    return true;
  }
  function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for (a = a.expirationTimes; 0 < b; ) {
      var c = 31 - oc(b), d = 1 << c;
      a[c] = -1;
      b &= ~d;
    }
  }
  function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
      var d = xc(a);
      0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
  }
  function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
      return a(b);
    } finally {
      K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
  }
  function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
      if (ok.transition = null, C = 1, a) return a();
    } finally {
      C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
  }
  function Hj() {
    fj = ej.current;
    E(ej);
  }
  function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for (c = Y.return; null !== c; ) {
      var d = c;
      wg(d);
      switch (d.tag) {
        case 1:
          d = d.type.childContextTypes;
          null !== d && void 0 !== d && $f();
          break;
        case 3:
          zh();
          E(Wf);
          E(H);
          Eh();
          break;
        case 5:
          Bh(d);
          break;
        case 4:
          zh();
          break;
        case 13:
          E(L);
          break;
        case 19:
          E(L);
          break;
        case 10:
          ah(d.type._context);
          break;
        case 22:
        case 23:
          Hj();
      }
      c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
      for (b = 0; b < fh.length; b++) if (c = fh[b], d = c.interleaved, null !== d) {
        c.interleaved = null;
        var e = d.next, f2 = c.pending;
        if (null !== f2) {
          var g = f2.next;
          f2.next = e;
          d.next = g;
        }
        c.pending = d;
      }
      fh = null;
    }
    return a;
  }
  function Mk(a, b) {
    do {
      var c = Y;
      try {
        $g();
        Fh.current = Rh;
        if (Ih) {
          for (var d = M.memoizedState; null !== d; ) {
            var e = d.queue;
            null !== e && (e.pending = null);
            d = d.next;
          }
          Ih = false;
        }
        Hh = 0;
        O = N = M = null;
        Jh = false;
        Kh = 0;
        nk.current = null;
        if (null === c || null === c.return) {
          T = 1;
          pk = b;
          Y = null;
          break;
        }
        a: {
          var f2 = a, g = c.return, h = c, k2 = b;
          b = Z;
          h.flags |= 32768;
          if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
            var l2 = k2, m2 = h, q2 = m2.tag;
            if (0 === (m2.mode & 1) && (0 === q2 || 11 === q2 || 15 === q2)) {
              var r2 = m2.alternate;
              r2 ? (m2.updateQueue = r2.updateQueue, m2.memoizedState = r2.memoizedState, m2.lanes = r2.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
            }
            var y2 = Ui(g);
            if (null !== y2) {
              y2.flags &= -257;
              Vi(y2, g, h, f2, b);
              y2.mode & 1 && Si(f2, l2, b);
              b = y2;
              k2 = l2;
              var n2 = b.updateQueue;
              if (null === n2) {
                var t2 = /* @__PURE__ */ new Set();
                t2.add(k2);
                b.updateQueue = t2;
              } else n2.add(k2);
              break a;
            } else {
              if (0 === (b & 1)) {
                Si(f2, l2, b);
                tj();
                break a;
              }
              k2 = Error(p(426));
            }
          } else if (I && h.mode & 1) {
            var J2 = Ui(g);
            if (null !== J2) {
              0 === (J2.flags & 65536) && (J2.flags |= 256);
              Vi(J2, g, h, f2, b);
              Jg(Ji(k2, h));
              break a;
            }
          }
          f2 = k2 = Ji(k2, h);
          4 !== T && (T = 2);
          null === sk ? sk = [f2] : sk.push(f2);
          f2 = g;
          do {
            switch (f2.tag) {
              case 3:
                f2.flags |= 65536;
                b &= -b;
                f2.lanes |= b;
                var x2 = Ni(f2, k2, b);
                ph(f2, x2);
                break a;
              case 1:
                h = k2;
                var w2 = f2.type, u2 = f2.stateNode;
                if (0 === (f2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                  f2.flags |= 65536;
                  b &= -b;
                  f2.lanes |= b;
                  var F2 = Qi(f2, h, b);
                  ph(f2, F2);
                  break a;
                }
            }
            f2 = f2.return;
          } while (null !== f2);
        }
        Sk(c);
      } catch (na) {
        b = na;
        Y === c && null !== c && (Y = c = c.return);
        continue;
      }
      break;
    } while (1);
  }
  function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
  }
  function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
  }
  function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    do
      try {
        Tk();
        break;
      } catch (e) {
        Mk(a, e);
      }
    while (1);
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
  }
  function Tk() {
    for (; null !== Y; ) Uk(Y);
  }
  function Lk() {
    for (; null !== Y && !cc(); ) Uk(Y);
  }
  function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
  }
  function Sk(a) {
    var b = a;
    do {
      var c = b.alternate;
      a = b.return;
      if (0 === (b.flags & 32768)) {
        if (c = Ej(c, b, fj), null !== c) {
          Y = c;
          return;
        }
      } else {
        c = Ij(c, b);
        if (null !== c) {
          c.flags &= 32767;
          Y = c;
          return;
        }
        if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
        else {
          T = 6;
          Y = null;
          return;
        }
      }
      b = b.sibling;
      if (null !== b) {
        Y = b;
        return;
      }
      Y = b = a;
    } while (null !== b);
    0 === T && (T = 5);
  }
  function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
      ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally {
      ok.transition = e, C = d;
    }
    return null;
  }
  function Wk(a, b, c, d) {
    do
      Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f2 = c.lanes | c.childLanes;
    Bc(a, f2);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = true, Fk(hc, function() {
      Hk();
      return null;
    }));
    f2 = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f2) {
      f2 = ok.transition;
      ok.transition = null;
      var g = C;
      C = 1;
      var h = K;
      K |= 4;
      nk.current = null;
      Oj(a, c);
      dk(c, a);
      Oe(Df);
      dd = !!Cf;
      Df = Cf = null;
      a.current = c;
      hk(c);
      dc();
      K = h;
      C = g;
      ok.transition = f2;
    } else a.current = c;
    vk && (vk = false, wk = a, xk = e);
    f2 = a.pendingLanes;
    0 === f2 && (Ri = null);
    mc(c.stateNode);
    Dk(a, B());
    if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) e = b[c], d(e.value, { componentStack: e.stack, digest: e.digest });
    if (Oi) throw Oi = false, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f2 = a.pendingLanes;
    0 !== (f2 & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
  }
  function Hk() {
    if (null !== wk) {
      var a = Dc(xk), b = ok.transition, c = C;
      try {
        ok.transition = null;
        C = 16 > a ? 16 : a;
        if (null === wk) var d = false;
        else {
          a = wk;
          wk = null;
          xk = 0;
          if (0 !== (K & 6)) throw Error(p(331));
          var e = K;
          K |= 4;
          for (V = a.current; null !== V; ) {
            var f2 = V, g = f2.child;
            if (0 !== (V.flags & 16)) {
              var h = f2.deletions;
              if (null !== h) {
                for (var k2 = 0; k2 < h.length; k2++) {
                  var l2 = h[k2];
                  for (V = l2; null !== V; ) {
                    var m2 = V;
                    switch (m2.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pj(8, m2, f2);
                    }
                    var q2 = m2.child;
                    if (null !== q2) q2.return = m2, V = q2;
                    else for (; null !== V; ) {
                      m2 = V;
                      var r2 = m2.sibling, y2 = m2.return;
                      Sj(m2);
                      if (m2 === l2) {
                        V = null;
                        break;
                      }
                      if (null !== r2) {
                        r2.return = y2;
                        V = r2;
                        break;
                      }
                      V = y2;
                    }
                  }
                }
                var n2 = f2.alternate;
                if (null !== n2) {
                  var t2 = n2.child;
                  if (null !== t2) {
                    n2.child = null;
                    do {
                      var J2 = t2.sibling;
                      t2.sibling = null;
                      t2 = J2;
                    } while (null !== t2);
                  }
                }
                V = f2;
              }
            }
            if (0 !== (f2.subtreeFlags & 2064) && null !== g) g.return = f2, V = g;
            else b: for (; null !== V; ) {
              f2 = V;
              if (0 !== (f2.flags & 2048)) switch (f2.tag) {
                case 0:
                case 11:
                case 15:
                  Pj(9, f2, f2.return);
              }
              var x2 = f2.sibling;
              if (null !== x2) {
                x2.return = f2.return;
                V = x2;
                break b;
              }
              V = f2.return;
            }
          }
          var w2 = a.current;
          for (V = w2; null !== V; ) {
            g = V;
            var u2 = g.child;
            if (0 !== (g.subtreeFlags & 2064) && null !== u2) u2.return = g, V = u2;
            else b: for (g = w2; null !== V; ) {
              h = V;
              if (0 !== (h.flags & 2048)) try {
                switch (h.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Qj(9, h);
                }
              } catch (na) {
                W(h, h.return, na);
              }
              if (h === g) {
                V = null;
                break b;
              }
              var F2 = h.sibling;
              if (null !== F2) {
                F2.return = h.return;
                V = F2;
                break b;
              }
              V = h.return;
            }
          }
          K = e;
          jg();
          if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
            lc.onPostCommitFiberRoot(kc, a);
          } catch (na) {
          }
          d = true;
        }
        return d;
      } finally {
        C = c, ok.transition = b;
      }
    }
    return false;
  }
  function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
  }
  function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for (; null !== b; ) {
      if (3 === b.tag) {
        Xk(b, a, c);
        break;
      } else if (1 === b.tag) {
        var d = b.stateNode;
        if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
          a = Ji(c, a);
          a = Qi(b, a, 1);
          b = nh(b, a, 1);
          a = R();
          null !== b && (Ac(b, 1, a), Dk(b, a));
          break;
        }
      }
      b = b.return;
    }
  }
  function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
  }
  function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
  }
  function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
  }
  function bk(a, b) {
    var c = 0;
    switch (a.tag) {
      case 13:
        var d = a.stateNode;
        var e = a.memoizedState;
        null !== e && (c = e.retryLane);
        break;
      case 19:
        d = a.stateNode;
        break;
      default:
        throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
  }
  var Vk;
  Vk = function(a, b, c) {
    if (null !== a) if (a.memoizedProps !== b.pendingProps || Wf.current) dh = true;
    else {
      if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = false, yj(a, b, c);
      dh = 0 !== (a.flags & 131072) ? true : false;
    }
    else dh = false, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch (b.tag) {
      case 2:
        var d = b.type;
        ij(a, b);
        a = b.pendingProps;
        var e = Yf(b, H.current);
        ch(b, c);
        e = Nh(null, b, d, a, e, c);
        var f2 = Sh();
        b.flags |= 1;
        "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f2 = true, cg(b)) : f2 = false, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, true, f2, c)) : (b.tag = 0, I && f2 && vg(b), Xi(null, b, e, c), b = b.child);
        return b;
      case 16:
        d = b.elementType;
        a: {
          ij(a, b);
          a = b.pendingProps;
          e = d._init;
          d = e(d._payload);
          b.type = d;
          e = b.tag = Zk(d);
          a = Ci(d, a);
          switch (e) {
            case 0:
              b = cj(null, b, d, a, c);
              break a;
            case 1:
              b = hj(null, b, d, a, c);
              break a;
            case 11:
              b = Yi(null, b, d, a, c);
              break a;
            case 14:
              b = $i(null, b, d, Ci(d.type, a), c);
              break a;
          }
          throw Error(p(
            306,
            d,
            ""
          ));
        }
        return b;
      case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
      case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
      case 3:
        a: {
          kj(b);
          if (null === a) throw Error(p(387));
          d = b.pendingProps;
          f2 = b.memoizedState;
          e = f2.element;
          lh(a, b);
          qh(b, d, null, c);
          var g = b.memoizedState;
          d = g.element;
          if (f2.isDehydrated) if (f2 = { element: d, isDehydrated: false, cache: g.cache, pendingSuspenseBoundaries: g.pendingSuspenseBoundaries, transitions: g.transitions }, b.updateQueue.baseState = f2, b.memoizedState = f2, b.flags & 256) {
            e = Ji(Error(p(423)), b);
            b = lj(a, b, d, c, e);
            break a;
          } else if (d !== e) {
            e = Ji(Error(p(424)), b);
            b = lj(a, b, d, c, e);
            break a;
          } else for (yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = true, zg = null, c = Vg(b, null, d, c), b.child = c; c; ) c.flags = c.flags & -3 | 4096, c = c.sibling;
          else {
            Ig();
            if (d === e) {
              b = Zi(a, b, c);
              break a;
            }
            Xi(a, b, d, c);
          }
          b = b.child;
        }
        return b;
      case 5:
        return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f2 = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f2 && Ef(d, f2) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
      case 6:
        return null === a && Eg(b), null;
      case 13:
        return oj(a, b, c);
      case 4:
        return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
      case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
      case 7:
        return Xi(a, b, b.pendingProps, c), b.child;
      case 8:
        return Xi(a, b, b.pendingProps.children, c), b.child;
      case 12:
        return Xi(a, b, b.pendingProps.children, c), b.child;
      case 10:
        a: {
          d = b.type._context;
          e = b.pendingProps;
          f2 = b.memoizedProps;
          g = e.value;
          G(Wg, d._currentValue);
          d._currentValue = g;
          if (null !== f2) if (He(f2.value, g)) {
            if (f2.children === e.children && !Wf.current) {
              b = Zi(a, b, c);
              break a;
            }
          } else for (f2 = b.child, null !== f2 && (f2.return = b); null !== f2; ) {
            var h = f2.dependencies;
            if (null !== h) {
              g = f2.child;
              for (var k2 = h.firstContext; null !== k2; ) {
                if (k2.context === d) {
                  if (1 === f2.tag) {
                    k2 = mh(-1, c & -c);
                    k2.tag = 2;
                    var l2 = f2.updateQueue;
                    if (null !== l2) {
                      l2 = l2.shared;
                      var m2 = l2.pending;
                      null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                      l2.pending = k2;
                    }
                  }
                  f2.lanes |= c;
                  k2 = f2.alternate;
                  null !== k2 && (k2.lanes |= c);
                  bh(
                    f2.return,
                    c,
                    b
                  );
                  h.lanes |= c;
                  break;
                }
                k2 = k2.next;
              }
            } else if (10 === f2.tag) g = f2.type === b.type ? null : f2.child;
            else if (18 === f2.tag) {
              g = f2.return;
              if (null === g) throw Error(p(341));
              g.lanes |= c;
              h = g.alternate;
              null !== h && (h.lanes |= c);
              bh(g, c, b);
              g = f2.sibling;
            } else g = f2.child;
            if (null !== g) g.return = f2;
            else for (g = f2; null !== g; ) {
              if (g === b) {
                g = null;
                break;
              }
              f2 = g.sibling;
              if (null !== f2) {
                f2.return = g.return;
                g = f2;
                break;
              }
              g = g.return;
            }
            f2 = g;
          }
          Xi(a, b, e.children, c);
          b = b.child;
        }
        return b;
      case 9:
        return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
      case 14:
        return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
      case 15:
        return bj(a, b, b.type, b.pendingProps, c);
      case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = true, cg(b)) : a = false, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, true, a, c);
      case 19:
        return xj(a, b, c);
      case 22:
        return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
  };
  function Fk(a, b) {
    return ac(a, b);
  }
  function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
  }
  function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
  }
  function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
      a = a.$$typeof;
      if (a === Da) return 11;
      if (a === Ga) return 14;
    }
    return 2;
  }
  function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
  }
  function Rg(a, b, c, d, e, f2) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch (a) {
      case ya:
        return Tg(c.children, e, f2, b);
      case za:
        g = 8;
        e |= 8;
        break;
      case Aa:
        return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f2, a;
      case Ea:
        return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f2, a;
      case Fa:
        return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f2, a;
      case Ia:
        return pj(c, e, f2, b);
      default:
        if ("object" === typeof a && null !== a) switch (a.$$typeof) {
          case Ba:
            g = 10;
            break a;
          case Ca:
            g = 9;
            break a;
          case Da:
            g = 11;
            break a;
          case Ga:
            g = 14;
            break a;
          case Ha:
            g = 16;
            d = null;
            break a;
        }
        throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f2;
    return b;
  }
  function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
  }
  function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = { isHidden: false };
    return a;
  }
  function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
  }
  function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
    return b;
  }
  function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
  }
  function bl(a, b, c, d, e, f2, g, h, k2) {
    a = new al(a, b, c, h, k2);
    1 === b ? (b = 1, true === f2 && (b |= 8)) : b = 0;
    f2 = Bg(3, null, null, b);
    a.current = f2;
    f2.stateNode = a;
    f2.memoizedState = { element: d, isDehydrated: c, cache: null, transitions: null, pendingSuspenseBoundaries: null };
    kh(f2);
    return a;
  }
  function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return { $$typeof: wa, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
  }
  function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
      if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
      var b = a;
      do {
        switch (b.tag) {
          case 3:
            b = b.stateNode.context;
            break a;
          case 1:
            if (Zf(b.type)) {
              b = b.stateNode.__reactInternalMemoizedMergedChildContext;
              break a;
            }
        }
        b = b.return;
      } while (null !== b);
      throw Error(p(171));
    }
    if (1 === a.tag) {
      var c = a.type;
      if (Zf(c)) return bg(a, c, b);
    }
    return b;
  }
  function el(a, b, c, d, e, f2, g, h, k2) {
    a = bl(c, d, true, a, e, f2, g, h, k2);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f2 = mh(d, e);
    f2.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f2, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
  }
  function fl(a, b, c, d) {
    var e = b.current, f2 = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f2, g);
    b.payload = { element: a };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f2), oh(a, e, g));
    return g;
  }
  function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;
      default:
        return a.child.stateNode;
    }
  }
  function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
      var c = a.retryLane;
      a.retryLane = 0 !== c && c < b ? c : b;
    }
  }
  function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
  }
  function jl() {
    return null;
  }
  var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
  };
  function ll(a) {
    this._internalRoot = a;
  }
  ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
  };
  ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
      this._internalRoot = null;
      var b = a.containerInfo;
      Rk(function() {
        fl(null, a, null, null);
      });
      b[uf] = null;
    }
  };
  function ml(a) {
    this._internalRoot = a;
  }
  ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
      var b = Hc();
      a = { blockedOn: null, target: a, priority: b };
      for (var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++) ;
      Qc.splice(c, 0, a);
      0 === c && Vc(a);
    }
  };
  function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
  }
  function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
  }
  function pl() {
  }
  function ql(a, b, c, d, e) {
    if (e) {
      if ("function" === typeof d) {
        var f2 = d;
        d = function() {
          var a2 = gl(g);
          f2.call(a2);
        };
      }
      var g = el(b, d, a, 0, null, false, false, "", pl);
      a._reactRootContainer = g;
      a[uf] = g.current;
      sf(8 === a.nodeType ? a.parentNode : a);
      Rk();
      return g;
    }
    for (; e = a.lastChild; ) a.removeChild(e);
    if ("function" === typeof d) {
      var h = d;
      d = function() {
        var a2 = gl(k2);
        h.call(a2);
      };
    }
    var k2 = bl(a, 0, false, null, null, false, false, "", pl);
    a._reactRootContainer = k2;
    a[uf] = k2.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
      fl(b, k2, c, d);
    });
    return k2;
  }
  function rl(a, b, c, d, e) {
    var f2 = c._reactRootContainer;
    if (f2) {
      var g = f2;
      if ("function" === typeof e) {
        var h = e;
        e = function() {
          var a2 = gl(g);
          h.call(a2);
        };
      }
      fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
  }
  Ec = function(a) {
    switch (a.tag) {
      case 3:
        var b = a.stateNode;
        if (b.current.memoizedState.isDehydrated) {
          var c = tc(b.pendingLanes);
          0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
        }
        break;
      case 13:
        Rk(function() {
          var b2 = ih(a, 1);
          if (null !== b2) {
            var c2 = R();
            gi(b2, a, 1, c2);
          }
        }), il(a, 1);
    }
  };
  Fc = function(a) {
    if (13 === a.tag) {
      var b = ih(a, 134217728);
      if (null !== b) {
        var c = R();
        gi(b, a, 134217728, c);
      }
      il(a, 134217728);
    }
  };
  Gc = function(a) {
    if (13 === a.tag) {
      var b = yi(a), c = ih(a, b);
      if (null !== c) {
        var d = R();
        gi(c, a, b, d);
      }
      il(a, b);
    }
  };
  Hc = function() {
    return C;
  };
  Ic = function(a, b) {
    var c = C;
    try {
      return C = a, b();
    } finally {
      C = c;
    }
  };
  yb = function(a, b, c) {
    switch (b) {
      case "input":
        bb(a, c);
        b = c.name;
        if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode; ) c = c.parentNode;
          c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
          for (b = 0; b < c.length; b++) {
            var d = c[b];
            if (d !== a && d.form === a.form) {
              var e = Db(d);
              if (!e) throw Error(p(90));
              Wa(d);
              bb(d, e);
            }
          }
        }
        break;
      case "textarea":
        ib(a, c);
        break;
      case "select":
        b = c.value, null != b && fb(a, !!c.multiple, b, false);
    }
  };
  Gb = Qk;
  Hb = Rk;
  var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
  var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
    a = Zb(a);
    return null === a ? null : a.stateNode;
  }, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
      kc = vl.inject(ul), lc = vl;
    } catch (a) {
    }
  }
  reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
  reactDom_production_min.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
  };
  reactDom_production_min.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = false, d = "", e = kl;
    null !== b && void 0 !== b && (true === b.unstable_strictMode && (c = true), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, false, null, null, c, false, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
  };
  reactDom_production_min.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
      if ("function" === typeof a.render) throw Error(p(188));
      a = Object.keys(a).join(",");
      throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
  };
  reactDom_production_min.flushSync = function(a) {
    return Rk(a);
  };
  reactDom_production_min.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, true, c);
  };
  reactDom_production_min.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = false, f2 = "", g = kl;
    null !== c && void 0 !== c && (true === c.unstable_strictMode && (e = true), void 0 !== c.identifierPrefix && (f2 = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, false, f2, g);
    a[uf] = b.current;
    sf(a);
    if (d) for (a = 0; a < d.length; a++) c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(
      c,
      e
    );
    return new ml(b);
  };
  reactDom_production_min.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, false, c);
  };
  reactDom_production_min.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
      rl(null, null, a, false, function() {
        a._reactRootContainer = null;
        a[uf] = null;
      });
    }), true) : false;
  };
  reactDom_production_min.unstable_batchedUpdates = Qk;
  reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, false, d);
  };
  reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  {
    checkDCE();
    reactDom.exports = reactDom_production_min;
  }
  var reactDomExports = reactDom.exports;
  var m = reactDomExports;
  {
    client.createRoot = m.createRoot;
    client.hydrateRoot = m.hydrateRoot;
  }
  const EMPTY_FILTERS = {
    search: "",
    expansions: [],
    colors: [],
    multicolorOnly: false,
    rarities: [],
    types: [],
    creatureTypes: [],
    landMana: [],
    legendaryOnly: false,
    cmc: [],
    format: "all",
    keywords: [],
    searchInText: false,
    foil: "all",
    language: "all",
    priceMin: null,
    priceMax: null
  };
  function injected() {
    if (typeof window === "undefined") return {};
    const w2 = window;
    return w2.CARD_SHOP_CONFIG ?? w2.NEVERMINT_BUYBACK ?? {};
  }
  function getLocale() {
    const raw = injected().locale ?? (typeof navigator === "undefined" ? "fr" : navigator.language) ?? "fr";
    return raw.toLowerCase().startsWith("fr") ? "fr" : "en";
  }
  function getRootUrl() {
    const raw = injected().rootUrl ?? "/";
    return raw === "/" ? "" : raw.replace(/\/$/, "");
  }
  function shopPath(path) {
    return `${getRootUrl()}${path}`;
  }
  function interpolate(raw, vars) {
    if (!vars) return raw;
    return raw.replace(
      /\{(\w+)\}/g,
      (whole, name) => name in vars ? String(vars[name]) : whole
    );
  }
  const FR = {
    // ─── Chargement, erreurs ─────────────────────────────────────────────────
    "catalog.loading": "Chargement du catalogue…",
    "catalog.error.title": "Erreur de chargement",
    "catalog.error.body": "Impossible de charger le catalogue.",
    "catalog.empty": "Aucune carte ne correspond à ces critères.",
    "catalog.reset": "Réinitialiser les filtres",
    "cart.error.title": "Erreur panier",
    "cart.error.body": "Impossible de charger le panier.",
    // ─── En-tête ─────────────────────────────────────────────────────────────
    "header.title": "Cartes à l’unité",
    "header.freeShipping": "Livraison gratuite en France Métropolitaine en point relais à partir de 60 EUR.",
    // ─── Panier ──────────────────────────────────────────────────────────────
    "cart.title": "Panier",
    "cart.empty": "Votre panier est vide.",
    "cart.clear": "Vider le panier",
    "cart.otherItems": "Autres articles du panier",
    "cart.standaloneNotice": "Mode standalone : le paiement passe par Shopify une fois la page intégrée à la boutique.",
    "cart.add": "Ajouter au panier",
    "cart.addOne": "Ajouter un exemplaire",
    "cart.removeOne": "Enlever un exemplaire",
    "cart.removeAll": "Retirer du panier",
    "cart.maxReached": "Stock maximum au panier",
    "cart.added": "✓ Ajouté au panier",
    // ─── Filtres ─────────────────────────────────────────────────────────────
    "filter.search": "Rechercher une carte (FR ou EN)…",
    "filter.searchOracle": "Chercher aussi dans le texte des cartes (effets)",
    "filter.searchOracleOn": "La recherche couvre aussi le texte des cartes — cliquer pour désactiver",
    "filter.clearAll": "Tout effacer",
    "filter.name": "Filtrer (FR ou EN)…",
    "filter.expansions": "Filtrer les extensions…",
    "filter.keywords": "Filtrer les mots-clés (FR ou EN)…",
    "filter.noExpansion": "Aucune extension trouvée.",
    "filter.noType": "Aucun type trouvé.",
    "filter.noKeyword": "Aucun mot-clé trouvé.",
    "filter.creatureType": "Type de créature",
    "filter.manaCost": "Coût de mana",
    "filter.allFormats": "Tous les formats",
    "filter.allLanguages": "Toutes les langues",
    "filter.legendary": "⭐ Légendaire",
    "filter.legendaryOnly": "⭐ Légendaire uniquement",
    "filter.condition": "État : NM",
    "filter.conditionNote": "Tout le stock actuel est Near Mint",
    "filter.min": "Min",
    "filter.max": "Max",
    "filter.french": "🇫🇷 Français",
    "filter.english": "🇬🇧 Anglais",
    "sort.priceAsc": "Prix croissant",
    "sort.priceDesc": "Prix décroissant",
    "view.grid": "Vue grille",
    "view.list": "Vue liste compacte",
    "filter.manaValue": "Valeur de mana {value}",
    // ─── Fiche carte ─────────────────────────────────────────────────────────
    "card.prev": "Carte précédente",
    "card.next": "Carte suivante",
    "card.close": "Fermer",
    "card.previousShort": "‹ Précédente",
    "card.front": "Voir le recto",
    "card.back": "Voir le verso",
    "card.rarity": "Rareté",
    "card.condition": "État",
    "card.keywords": "Mots-clés",
    "card.oracle": "Texte de la carte",
    "card.synergies": "Fonctionne bien avec",
    "card.scryfall": "Voir sur Scryfall ↗",
    "card.allVersions": "Voir toutes les versions (extensions, langues, finitions)",
    "card.badge.new": "🆕 Nouveau",
    "card.badge.restock": "↺ Restock",
    "card.secondHand": "Occasion",
    "card.secondHandNote": "Carte d'occasion : elle a déjà eu un propriétaire, quel que soit son état de jeu. Elle bénéficie de la garantie légale de conformité de 2 ans ; pour un bien d'occasion, un défaut apparu dans les 12 mois suivant la livraison est présumé exister dès la vente (art. L217-7 du Code de la consommation).",
    // ─── Synergies du panier ─────────────────────────────────────────────────
    "synergies.intro": "Synergies EDHREC des cartes de votre panier, disponibles en boutique.",
    // ─── Import de decklist ──────────────────────────────────────────────────
    "deck.open": "Importer une liste",
    "deck.openLabel": "📋 Importer une liste",
    "deck.title": "Importer une decklist",
    "deck.help": "Collez votre liste (MTGA, Moxfield, texte…) — une carte par ligne, ex. « 4 Sol Ring ».",
    "deck.resultPlaceholder": "Le résultat de la correspondance avec le stock s’affichera ici.",
    "deck.copyMissing": "Copier les manquantes",
    "deck.addCards": "Ajouter {count} carte au panier",
    "deck.addCards_plural": "Ajouter {count} cartes au panier",
    // ─── Ajouts ────────────────────────────────────────────────────────────
    "card.type": "Type",
    "card.versions": "⧉ Voir les {count} versions",
    "card.inCart": "🛒 Déjà {count} dans votre panier",
    "cart.cards": "{count} carte",
    "cart.cards_plural": "{count} cartes",
    "deck.stockWarning": "⚠ Seulement {available} en stock sur {asked} demandées",
    "filter.all": "Toutes",
    "filter.conditionLabel": "État :",
    "filter.conditionFull": "Near Mint — tout le stock actuel",
    "filter.showResults": "Voir {count} carte",
    "filter.showResults_plural": "Voir {count} cartes",
    "filter.colors": "Couleurs",
    "card.synergiesSource": "(synergies EDHREC)",
    "card.unavailable": "Non disponible",
    "card.inStock": "{count} en stock",
    "card.noImage": "Pas d’image",
    "card.expansion": "Extension",
    "card.formats": "Formats",
    "card.language": "Langue",
    "card.finish": "Finition",
    "card.finishNormal": "Normale",
    "card.nextShort": "Suivante ›",
    "sealed.title": "Trouvable aussi dans",
    "sealed.inDeck": "Incluse dans le deck",
    "sealed.inDeckFoil": "Incluse dans le deck (foil)",
    "sealed.inBooster": "Peut sortir de ses boosters",
    "sealed.inCollector": "Peut sortir de ses boosters collector",
    "sealed.boosterNote": "Tirage aléatoire : un booster ne garantit pas d’obtenir cette carte.",
    "sealed.view": "Voir",
    "sealed.add": "Ajouter au panier",
    "sealed.added": "✓ Ajouté",
    "filter.format": "Format",
    "filter.expansion": "Extension",
    "filter.language": "Langue",
    "filter.finish": "Finition",
    "filter.price": "Prix",
    "filter.type": "Type",
    "filter.land": "Terrain :",
    "filter.creature": "Créature :",
    "lang.frCard": "Carte en français",
    "lang.enCard": "Carte en anglais"
  };
  const EN = {
    "catalog.loading": "Loading the catalogue…",
    "catalog.error.title": "Loading error",
    "catalog.error.body": "The catalogue could not be loaded.",
    "catalog.empty": "No card matches these filters.",
    "catalog.reset": "Reset filters",
    "cart.error.title": "Cart error",
    "cart.error.body": "The cart could not be loaded.",
    "header.title": "Single cards",
    "header.freeShipping": "Free pickup-point delivery in mainland France from €60.",
    "cart.title": "Cart",
    "cart.empty": "Your cart is empty.",
    "cart.clear": "Empty the cart",
    "cart.otherItems": "Other items in your cart",
    "cart.standaloneNotice": "Standalone mode: checkout goes through Shopify once the page is embedded in the shop.",
    "cart.add": "Add to cart",
    "cart.addOne": "Add one",
    "cart.removeOne": "Remove one",
    "cart.removeAll": "Remove from cart",
    "cart.maxReached": "All available stock is in your cart",
    "cart.added": "✓ Added to cart",
    "filter.search": "Search for a card (FR or EN)…",
    "filter.searchOracle": "Also search the card text (effects)",
    "filter.searchOracleOn": "Search also covers card text — click to turn off",
    "filter.clearAll": "Clear all",
    "filter.name": "Filter (FR or EN)…",
    "filter.expansions": "Filter sets…",
    "filter.keywords": "Filter keywords (FR or EN)…",
    "filter.noExpansion": "No set found.",
    "filter.noType": "No type found.",
    "filter.noKeyword": "No keyword found.",
    "filter.creatureType": "Creature type",
    "filter.manaCost": "Mana cost",
    "filter.allFormats": "All formats",
    "filter.allLanguages": "All languages",
    "filter.legendary": "⭐ Legendary",
    "filter.legendaryOnly": "⭐ Legendary only",
    "filter.condition": "Condition: NM",
    "filter.conditionNote": "All current stock is Near Mint",
    "filter.min": "Min",
    "filter.max": "Max",
    "filter.french": "🇫🇷 French",
    "filter.english": "🇬🇧 English",
    "sort.priceAsc": "Price, low to high",
    "sort.priceDesc": "Price, high to low",
    "view.grid": "Grid view",
    "view.list": "Compact list view",
    "filter.manaValue": "Mana value {value}",
    "card.prev": "Previous card",
    "card.next": "Next card",
    "card.close": "Close",
    "card.previousShort": "‹ Previous",
    "card.front": "Show front face",
    "card.back": "Show back face",
    "card.rarity": "Rarity",
    "card.condition": "Condition",
    "card.keywords": "Keywords",
    "card.oracle": "Card text",
    "card.synergies": "Works well with",
    "card.scryfall": "View on Scryfall ↗",
    "card.allVersions": "See every version (sets, languages, finishes)",
    "card.badge.new": "🆕 New",
    "card.badge.restock": "↺ Back in stock",
    "card.secondHand": "Pre-owned",
    "card.secondHandNote": "Pre-owned card: it has had a previous owner, whatever its playing condition. It is covered by the 2-year legal guarantee of conformity; for second-hand goods, a defect appearing within 12 months of delivery is presumed to have existed at the time of sale (French Consumer Code, art. L217-7).",
    "synergies.intro": "EDHREC synergies for the cards in your cart, in stock here.",
    "deck.open": "Import a list",
    "deck.openLabel": "📋 Import a list",
    "deck.title": "Import a decklist",
    "deck.help": "Paste your list (MTGA, Moxfield, plain text…) — one card per line, e.g. “4 Sol Ring”.",
    "deck.resultPlaceholder": "Matches against our stock will appear here.",
    "deck.copyMissing": "Copy the missing ones",
    "deck.addCards": "Add {count} card to cart",
    "deck.addCards_plural": "Add {count} cards to cart",
    "card.type": "Type",
    "card.versions": "⧉ See {count} versions",
    "card.inCart": "🛒 {count} already in your cart",
    "cart.cards": "{count} card",
    "cart.cards_plural": "{count} cards",
    "deck.stockWarning": "⚠ Only {available} in stock out of {asked} requested",
    "filter.all": "All",
    "filter.conditionLabel": "Condition:",
    "filter.conditionFull": "Near Mint — all current stock",
    "filter.showResults": "Show {count} card",
    "filter.showResults_plural": "Show {count} cards",
    "filter.colors": "Colours",
    "card.synergiesSource": "(EDHREC synergies)",
    "card.unavailable": "Unavailable",
    "card.inStock": "{count} in stock",
    "card.noImage": "No image",
    "card.expansion": "Set",
    "card.formats": "Formats",
    "card.language": "Language",
    "card.finish": "Finish",
    "card.finishNormal": "Non-foil",
    "card.nextShort": "Next ›",
    "sealed.title": "Also found in",
    "sealed.inDeck": "Included in the deck",
    "sealed.inDeckFoil": "Included in the deck (foil)",
    "sealed.inBooster": "Can be pulled from its boosters",
    "sealed.inCollector": "Can be pulled from its Collector Boosters",
    "sealed.boosterNote": "Random contents: a booster does not guarantee this card.",
    "sealed.view": "View",
    "sealed.add": "Add to cart",
    "sealed.added": "✓ Added",
    "filter.format": "Format",
    "filter.expansion": "Set",
    "filter.language": "Language",
    "filter.finish": "Finish",
    "filter.price": "Price",
    "filter.type": "Type",
    "filter.land": "Land:",
    "filter.creature": "Creature:",
    "lang.frCard": "French-language card",
    "lang.enCard": "English-language card"
  };
  const MESSAGES = { fr: FR, en: EN };
  function t(key, vars) {
    const raw = MESSAGES[getLocale()][key] ?? FR[key];
    return interpolate(raw, vars);
  }
  function tn(key, count) {
    const plural = `${key}_plural`;
    return t(count > 1 ? plural : key, { count });
  }
  function gameLabel(code, frenchLabel) {
    return getLocale() === "fr" ? frenchLabel : code;
  }
  function normalize(s) {
    return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[’‘ʼ]/g, "'").replace(/\s+/g, " ").trim();
  }
  function versionGroupKey(card) {
    return normalize(card.name).replace(/\s*\(v\.\s*\d+\)$/, "");
  }
  function displayName(card) {
    return card.language === "fr" ? card.nameFr || card.name : card.name;
  }
  function largeImage(url) {
    return url.replace("/normal/", "/large/");
  }
  function formatPrice(price) {
    return price.toFixed(2).replace(".", ",") + " €";
  }
  const COLOR_DEFS = [
    { code: "W", label: "Blanc", bg: "#f5f0da", text: "#5d5236" },
    { code: "U", label: "Bleu", bg: "#a8c4dd", text: "#0e4a78" },
    { code: "B", label: "Noir", bg: "#3d3a38", text: "#cfc7c2" },
    { code: "R", label: "Rouge", bg: "#e0a58e", text: "#8f2410" },
    { code: "G", label: "Vert", bg: "#a3c8a3", text: "#1a5b2f" },
    { code: "C", label: "Incolore", bg: "#c9c5c0", text: "#4c4a48" }
  ];
  function cardColors(card) {
    const raw = (card.colors || "").split(",").map((c) => c.trim()).filter(Boolean);
    return raw.length > 0 ? raw : ["C"];
  }
  function producedMana(card) {
    return (card.producedMana || "").split(",").map((c) => c.trim()).filter(Boolean);
  }
  const CMC_BUCKETS = [
    { code: "0-1", label: "0 – 1", match: (v2) => v2 <= 1 },
    { code: "2", label: "2", match: (v2) => v2 === 2 },
    { code: "3", label: "3", match: (v2) => v2 === 3 },
    { code: "4", label: "4", match: (v2) => v2 === 4 },
    { code: "5", label: "5", match: (v2) => v2 === 5 },
    { code: "6+", label: "6 et +", match: (v2) => v2 >= 6 }
  ];
  function cmcBucket(card) {
    var _a;
    if (card.cmc == null) return null;
    return ((_a = CMC_BUCKETS.find((b) => b.match(card.cmc))) == null ? void 0 : _a.code) ?? null;
  }
  function manaCostSymbols(manaCost) {
    const out = [];
    for (const part of manaCost.split("//")) {
      if (out.length > 0) out.push("//");
      for (const m2 of part.matchAll(/\{([^}]+)\}/g)) out.push(m2[1]);
    }
    return out;
  }
  const FORMAT_DEFS = [
    { code: "commander", label: "Commander" },
    { code: "standard", label: "Standard" },
    { code: "pioneer", label: "Pioneer" },
    { code: "modern", label: "Modern" },
    { code: "legacy", label: "Legacy" },
    { code: "vintage", label: "Vintage" },
    { code: "pauper", label: "Pauper" }
  ];
  function formatLabel(code) {
    var _a;
    return ((_a = FORMAT_DEFS.find((f2) => f2.code === code)) == null ? void 0 : _a.label) ?? code;
  }
  function isLegendary(card) {
    return /Legendary/i.test(card.typeLine ?? "");
  }
  const BADGE_WINDOW_MS = 14 * 24 * 3600 * 1e3;
  function arrivalBadge(card) {
    const now = Date.now();
    const created = card.productCreatedAt ? Date.parse(card.productCreatedAt) : NaN;
    const arrival = card.createdAt ? Date.parse(card.createdAt) : NaN;
    if (!Number.isNaN(created) && now - created < BADGE_WINDOW_MS) return "new";
    if (!Number.isNaN(arrival) && now - arrival < BADGE_WINDOW_MS) return "restock";
    return null;
  }
  const TYPE_DEFS = [
    { code: "Creature", label: "Créature" },
    { code: "Planeswalker", label: "Planeswalker" },
    { code: "Instant", label: "Éphémère" },
    { code: "Sorcery", label: "Rituel" },
    { code: "Enchantment", label: "Enchantement" },
    { code: "Artifact", label: "Artefact" },
    { code: "Battle", label: "Bataille" },
    { code: "Land", label: "Terrain" }
  ];
  function primaryTypes(card) {
    if (!card.typeLine) return [];
    const left = card.typeLine.split("—")[0];
    return TYPE_DEFS.filter((t2) => left.includes(t2.code)).map((t2) => t2.code);
  }
  function creatureSubtypes(card) {
    if (!card.typeLine) return [];
    const out = /* @__PURE__ */ new Set();
    for (const face of card.typeLine.split("//")) {
      const [left, right] = face.split("—");
      if ((left == null ? void 0 : left.includes("Creature")) && right) {
        for (const word of right.trim().split(/\s+/)) out.add(word);
      }
    }
    return [...out];
  }
  const CREATURE_TYPE_FR = {
    Human: "Humain",
    Soldier: "Soldat",
    Wizard: "Sorcier",
    Cleric: "Clerc",
    Warrior: "Guerrier",
    Knight: "Chevalier",
    Rogue: "Gredin",
    Shaman: "Shamane",
    Druid: "Druide",
    Monk: "Moine",
    Ranger: "Rôdeur",
    Scout: "Éclaireur",
    Archer: "Archer",
    Artificer: "Artificier",
    Assassin: "Assassin",
    Barbarian: "Barbare",
    Berserker: "Berserker",
    Mercenary: "Mercenaire",
    Rebel: "Rebelle",
    Noble: "Noble",
    Citizen: "Citoyen",
    Peasant: "Paysan",
    Advisor: "Conseiller",
    Pilot: "Pilote",
    Pirate: "Pirate",
    Ninja: "Ninja",
    Samurai: "Samouraï",
    Elf: "Elfe",
    Goblin: "Gobelin",
    Dwarf: "Nain",
    Giant: "Géant",
    Ogre: "Ogre",
    Orc: "Orque",
    Troll: "Troll",
    Merfolk: "Ondin",
    Vedalken: "Védalken",
    Kor: "Kor",
    Minotaur: "Minotaure",
    Centaur: "Centaure",
    Satyr: "Satyre",
    Cyclops: "Cyclope",
    Vampire: "Vampire",
    Zombie: "Zombie",
    Skeleton: "Squelette",
    Spirit: "Esprit",
    Ghost: "Fantôme",
    Specter: "Spectre",
    Demon: "Démon",
    Devil: "Diable",
    Imp: "Diablotin",
    Angel: "Ange",
    Avatar: "Avatar",
    God: "Dieu",
    Dragon: "Dragon",
    Drake: "Drakôn",
    Hydra: "Hydre",
    Phoenix: "Phénix",
    Sphinx: "Sphinx",
    Griffin: "Griffon",
    Unicorn: "Licorne",
    Pegasus: "Pégase",
    Werewolf: "Loup-garou",
    Wolf: "Loup",
    Bear: "Ours",
    Cat: "Chat",
    Dog: "Chien",
    Bird: "Oiseau",
    Snake: "Serpent",
    Spider: "Araignée",
    Insect: "Insecte",
    Rat: "Rat",
    Squirrel: "Écureuil",
    Rabbit: "Lapin",
    Mouse: "Souris",
    Otter: "Loutre",
    Raccoon: "Raton laveur",
    Bat: "Chauve-souris",
    Ape: "Grand singe",
    Boar: "Sanglier",
    Ox: "Bœuf",
    Elk: "Élan",
    Fish: "Poisson",
    Shark: "Requin",
    Whale: "Baleine",
    Octopus: "Pieuvre",
    Crab: "Crabe",
    Turtle: "Tortue",
    Frog: "Grenouille",
    Lizard: "Lézard",
    Dinosaur: "Dinosaure",
    Beast: "Bête",
    Elemental: "Élémental",
    Golem: "Golem",
    Construct: "Construction",
    Thopter: "Mécanoptère",
    Myr: "Myr",
    Wall: "Mur",
    Plant: "Plante",
    Fungus: "Fongus",
    Saproling: "Saprobionte",
    Treefolk: "Sylvin",
    Faerie: "Fée",
    Ooze: "Limon",
    Illusion: "Illusion",
    Nightmare: "Cauchemar",
    Horror: "Horreur",
    Eldrazi: "Eldrazi",
    Sliver: "Slivoïde",
    Shapeshifter: "Polymorphe",
    Mutant: "Mutant",
    Gargoyle: "Gargouille",
    Kraken: "Kraken",
    Leviathan: "Léviathan",
    Serpent: "Serpent de mer",
    Djinn: "Djinn",
    Ally: "Allié",
    // ─── Complétés le 2026-09-23 : 95 sous-types en vente s'affichaient en
    // anglais à un visiteur francophone, faute d'entrée ici.
    Aetherborn: "Éthérien",
    Alien: "Alien",
    Archon: "Archonte",
    Armadillo: "Tatou",
    "Assembly-Worker": "Ouvrier d’assemblage",
    Badger: "Blaireau",
    Bard: "Barde",
    Bison: "Bison",
    Book: "Livre",
    Chimera: "Chimère",
    Clue: "Indice",
    Coward: "Couard",
    Crocodile: "Crocodile",
    Demigod: "Demi-dieu",
    Detective: "Détective",
    Doctor: "Docteur",
    Drone: "Drone",
    Dryad: "Dryade",
    Efreet: "Éfrit",
    Egg: "Œuf",
    Elder: "Ancien",
    Elephant: "Éléphant",
    Eternal: "Éternel",
    Forest: "Forêt",
    Fox: "Renard",
    Food: "Nourriture",
    Fractal: "Fractale",
    Glimmer: "Miroitement",
    Goat: "Chèvre",
    Gorgon: "Gorgone",
    Gremlin: "Gremlin",
    Halfling: "Semi-homme",
    Harpy: "Harpie",
    Hellion: "Furie",
    Hero: "Héros",
    Hippo: "Hippopotame",
    Homunculus: "Homoncule",
    Horse: "Cheval",
    Incarnation: "Incarnation",
    Jackal: "Chacal",
    Jellyfish: "Méduse",
    Juggernaut: "Juggernaut",
    Kangaroo: "Kangourou",
    Kavu: "Kavu",
    Kirin: "Kirin",
    Kithkin: "Kithkin",
    Lamia: "Lamie",
    Lemur: "Lémurien",
    Lhurgoyf: "Lhurgoyf",
    Minion: "Sbire",
    Mole: "Taupe",
    Mongoose: "Mangouste",
    Monkey: "Singe",
    Nephilim: "Nephilim",
    Nomad: "Nomade",
    Nymph: "Nymphe",
    Ouphe: "Ouphe",
    Performer: "Artiste",
    Pest: "Vermine",
    Porcupine: "Porc-épic",
    Rhino: "Rhinocéros",
    Robot: "Robot",
    Saga: "Saga",
    Salamander: "Salamandre",
    Scarecrow: "Épouvantail",
    Scientist: "Scientifique",
    Seal: "Phoque",
    Siren: "Sirène",
    Sloth: "Paresseux",
    Sorcerer: "Ensorceleur",
    Spy: "Espion",
    Squid: "Calmar",
    Survivor: "Survivant",
    Tiefling: "Tieffelin",
    Trilobite: "Trilobite",
    Villain: "Méchant",
    Warlock: "Occultiste",
    Weird: "Bizarrerie",
    Wombat: "Wombat",
    Worm: "Ver",
    Wurm: "Guivre",
    Yeti: "Yéti"
  };
  function creatureTypeLabel(subtype) {
    return gameLabel(subtype, CREATURE_TYPE_FR[subtype] ?? subtype);
  }
  const KEYWORD_FR = {
    Flying: "Vol",
    Trample: "Piétinement",
    Haste: "Célérité",
    Deathtouch: "Contact mortel",
    Lifelink: "Lien de vie",
    Vigilance: "Vigilance",
    Reach: "Portée",
    Menace: "Menace",
    "First strike": "Initiative",
    "Double strike": "Double initiative",
    Hexproof: "Défense talismanique",
    Indestructible: "Indestructible",
    Flash: "Flash",
    Defender: "Défenseur",
    Ward: "Parade",
    Scry: "Regard",
    Prowess: "Prouesse",
    Landfall: "Toucheterre",
    Flashback: "Flashback",
    Kicker: "Kick",
    Cycling: "Recyclage",
    Equip: "Équiper",
    Crew: "Pilotage",
    Convoke: "Convocation",
    Delirium: "Délire",
    Mill: "Meule",
    Surveil: "Surveillance",
    Explore: "Explorer",
    Amass: "Amasser",
    Affinity: "Affinité",
    Annihilator: "Annihilateur",
    Cascade: "Cascade",
    Changeling: "Changeforme",
    Fear: "Peur",
    Shroud: "Linceul",
    Goad: "Provocation",
    Treasure: "Trésor",
    Food: "Nourriture",
    Investigate: "Enquêter",
    Partner: "Partenaire",
    Populate: "Peupler",
    Proliferate: "Prolifération",
    Rampage: "Sauvagerie",
    Regenerate: "Régénération",
    Storm: "Tempête",
    Suspend: "Suspension",
    Transform: "Transformation",
    Vanishing: "Évanescence",
    // ─── Complétés le 2026-09-23 ───────────────────────────────────────────
    Adapt: "Adaptation",
    Addendum: "Addendum",
    Afterlife: "Après-vie",
    Aftermath: "Séquelles",
    Alliance: "Alliance",
    Ascend: "Ascension",
    Awaken: "Éveil",
    Backup: "Renfort",
    "Basic landcycling": "Recyclage de terrain de base",
    Battalion: "Bataillon",
    Behold: "Contempler",
    Bestow: "Offrande",
    Blitz: "Blitz",
    Bloodrush: "Ruée de sang",
    Boast: "Vantardise",
    Casualty: "Perte",
    Channel: "Canalisation",
    Clash: "Choc",
    Cleave: "Fendre",
    Cloak: "Camoufler",
    "Collect evidence": "Collecter des preuves",
    Companion: "Compagnon",
    Compleated: "Complété",
    Connive: "Combine",
    Constellation: "Constellation",
    Converge: "Convergence",
    "Council's dilemma": "Dilemme du conseil",
    Coven: "Assemblée",
    Craft: "Façonner",
    "Cumulative upkeep": "Entretien cumulatif",
    Dash: "Ruée",
    Daybound: "Lié au jour",
    Delve: "Fouille",
    Demonstrate: "Démonstration",
    Descend: "Descente",
    Devoid: "Vide",
    Devour: "Dévorer",
    Discover: "Découverte",
    Disguise: "Déguisement",
    Domain: "Domaine",
    Echo: "Écho",
    Eerie: "Étrangeté",
    Emerge: "Émergence",
    Enchant: "Enchanter",
    Encore: "Rappel",
    Enrage: "Enrager",
    Entwine: "Enlacement",
    Escalate: "Escalade",
    Escape: "Évasion",
    Eternalize: "Éternaliser",
    Evoke: "Évocation",
    Evolve: "Évolution",
    Exalted: "Exaltation",
    Exert: "Effort",
    Exhaust: "Épuisement",
    Exploit: "Exploitation",
    Extort: "Extorsion",
    Fabricate: "Fabrication",
    "Fateful hour": "Heure fatidique",
    "Fathomless descent": "Descente sans fond",
    Ferocious: "Férocité",
    Fight: "Combattre",
    Forage: "Fourrager",
    Forestcycling: "Recyclage de forêt",
    Foretell: "Prédiction",
    Formidable: "Formidable",
    Fuse: "Fusion",
    Gift: "Cadeau",
    Grandeur: "Grandeur",
    Gravestorm: "Tempête sépulcrale",
    Halflingcycling: "Recyclage de semi-homme",
    Harmonize: "Harmoniser",
    Hellbent: "Acharnement",
    "Hexproof from": "Défense talismanique contre",
    Hideaway: "Cachette",
    Imprint: "Empreinte",
    Improvise: "Improvisation",
    Incubate: "Incubation",
    Intimidate: "Intimidation",
    Islandcycling: "Recyclage d’île",
    Islandwalk: "Traversée des îles",
    "Job select": "Sélection de job",
    Landcycling: "Recyclage de terrain",
    Landwalk: "Traversée",
    "Level Up": "Gain de niveau",
    Lieutenant: "Lieutenant",
    "Living weapon": "Arme vivante",
    Madness: "Démence",
    // ⚠️ L'officiel français de « Magecraft » est « Sorcellerie ».
    Magecraft: "Sorcellerie",
    Manifest: "Manifestation",
    "Max speed": "Vitesse maximale",
    Mayhem: "Grabuge",
    Melee: "Mêlée",
    Mentor: "Mentor",
    Metalcraft: "Métallurgie",
    Miracle: "Miracle",
    Modular: "Modularité",
    Monstrosity: "Monstruosité",
    Morbid: "Morbidité",
    Mountaincycling: "Recyclage de montagne",
    Multikicker: "Multikick",
    Nightbound: "Lié à la nuit",
    Ninjutsu: "Ninjutsu",
    Outlast: "Survivre",
    Overload: "Surcharge",
    Parley: "Parlementer",
    "Partner with": "Partenaire avec",
    Persist: "Persistance",
    Plainscycling: "Recyclage de plaine",
    Protection: "Protection",
    Prototype: "Prototype",
    Raid: "Raid",
    Ravenous: "Vorace",
    Rebound: "Rebond",
    Reinforce: "Renforcement",
    Replicate: "Réplication",
    Retrace: "Retracer",
    Revolt: "Révolte",
    Riot: "Émeute",
    "Role token": "Jeton de rôle",
    "Secret council": "Conseil secret",
    Shadow: "Ombre",
    Skulk: "Furtivité",
    Spectacle: "Spectacle",
    "Spell mastery": "Maîtrise des sorts",
    "Split second": "Fraction de seconde",
    Spree: "Virée",
    Squad: "Escouade",
    Station: "Station",
    Strive: "Ambition",
    Support: "Soutien",
    Survival: "Survie",
    Suspect: "Suspect",
    Swampcycling: "Recyclage de marais",
    Swampwalk: "Traversée des marais",
    Teamwork: "Travail d’équipe",
    Threshold: "Seuil",
    Training: "Entraînement",
    Typecycling: "Recyclage de type",
    "Umbra armor": "Armure d’ombre",
    Undaunted: "Intrépidité",
    Undergrowth: "Sous-bois",
    Undying: "Impérissable",
    Unearth: "Exhumation",
    Unleash: "Déchaînement",
    Valiant: "Vaillance",
    "Venture into the dungeon": "S’aventurer dans le donjon",
    Void: "Néant",
    Warp: "Distorsion",
    "Web-slinging": "Lance-toile",
    "Will of the council": "Volonté du conseil",
    Wither: "Flétrissure"
  };
  function keywordLabel(keyword) {
    return gameLabel(keyword, KEYWORD_FR[keyword] ?? keyword);
  }
  function isFilterableKeyword(keyword) {
    return keyword in KEYWORD_FR;
  }
  const RARITY_DEFS = [
    { code: "Common", label: "Commune", dot: "bg-neutral-400" },
    { code: "Uncommon", label: "Inhabituelle", dot: "bg-slate-300" },
    { code: "Rare", label: "Rare", dot: "bg-amber-400" },
    { code: "Mythic", label: "Mythique", dot: "bg-orange-500" }
  ];
  function searchHaystack(card, includeText = false) {
    const keywordTerms = (card.keywords ?? []).flatMap((k2) => [k2, KEYWORD_FR[k2]]);
    const textTerms = includeText ? [card.textEn, card.textFr] : [];
    return normalize(
      [card.name, card.nameFr, card.typeLine, card.expansion, card.expansionCode, card.collectorNumber, ...keywordTerms, ...textTerms].filter(Boolean).join(" ")
    );
  }
  function applyFilters(cards, f2, skipFacet) {
    const tokens = normalize(f2.search).split(/\s+/).filter(Boolean);
    return cards.filter((card) => {
      if (tokens.length > 0) {
        const hay = searchHaystack(card, f2.searchInText);
        if (!tokens.every((t2) => hay.includes(t2))) return false;
      }
      if (skipFacet !== "expansions" && f2.expansions.length > 0 && !f2.expansions.includes(card.expansionCode)) {
        return false;
      }
      if (skipFacet !== "colors") {
        const cc2 = cardColors(card);
        if (f2.colors.length > 0 && !f2.colors.some((c) => cc2.includes(c))) return false;
        if (f2.multicolorOnly && (cc2.length < 2 || cc2[0] === "C")) return false;
      }
      if (skipFacet !== "rarities" && f2.rarities.length > 0 && !f2.rarities.includes(card.rarity)) {
        return false;
      }
      if (skipFacet !== "types" && f2.types.length > 0) {
        const pt = primaryTypes(card);
        const matches = f2.types.some((t2) => {
          if (!pt.includes(t2)) return false;
          if (t2 === "Creature" && f2.creatureTypes.length > 0) {
            const st = creatureSubtypes(card);
            return f2.creatureTypes.some((c) => st.includes(c));
          }
          if (t2 === "Land" && f2.landMana.length > 0) {
            const pm = producedMana(card);
            return f2.landMana.some((m2) => pm.includes(m2));
          }
          return true;
        });
        if (!matches) return false;
      }
      if (skipFacet !== "types" && f2.legendaryOnly && !isLegendary(card)) return false;
      if (skipFacet !== "cmc" && f2.cmc.length > 0) {
        const bucket = cmcBucket(card);
        if (!bucket || !f2.cmc.includes(bucket)) return false;
      }
      if (skipFacet !== "format" && f2.format !== "all" && !(card.legalities ?? []).includes(f2.format)) {
        return false;
      }
      if (skipFacet !== "keywords" && f2.keywords.length > 0) {
        const kw = card.keywords ?? [];
        if (!f2.keywords.every((k2) => kw.includes(k2))) return false;
      }
      if (skipFacet !== "foil") {
        if (f2.foil === "foil" && !card.foil) return false;
        if (f2.foil === "nonfoil" && card.foil) return false;
      }
      if (skipFacet !== "language" && f2.language !== "all" && card.language !== f2.language) {
        return false;
      }
      if (f2.priceMin !== null && card.price < f2.priceMin) return false;
      if (f2.priceMax !== null && card.price > f2.priceMax) return false;
      return true;
    });
  }
  function sortCards(cards, sort) {
    const sorted = [...cards];
    switch (sort) {
      case "name":
        sorted.sort((a, b) => displayName(a).localeCompare(displayName(b), "fr"));
        break;
      case "price-asc":
        sorted.sort((a, b) => a.price - b.price);
        break;
      case "price-desc":
        sorted.sort((a, b) => b.price - a.price);
        break;
      case "expansion":
        sorted.sort(
          (a, b) => a.expansion.localeCompare(b.expansion) || (parseInt(a.collectorNumber) || 0) - (parseInt(b.collectorNumber) || 0)
        );
        break;
      case "newest":
        sorted.sort(
          (a, b) => (b.createdAt ?? "").localeCompare(a.createdAt ?? "") || displayName(a).localeCompare(displayName(b), "fr")
        );
        break;
      case "best-sellers":
        sorted.sort(
          (a, b) => (a.salesRank ?? Infinity) - (b.salesRank ?? Infinity) || displayName(a).localeCompare(displayName(b), "fr")
        );
        break;
    }
    return sorted;
  }
  function buildNameIndex$1(cards) {
    const byName = /* @__PURE__ */ new Map();
    for (const card of cards) {
      if (card.availableQuantity <= 0) continue;
      for (const name of [card.name, card.nameFr]) {
        if (!name) continue;
        const existing = byName.get(name);
        if (!existing || card.price < existing.price) byName.set(name, card);
      }
    }
    return byName;
  }
  function resolveSynergyCard(synergy, cardsById, nameIndex) {
    return synergy.stockIds.map((id2) => cardsById.get(id2)).find((c) => c !== void 0 && c.availableQuantity > 0) ?? nameIndex.get(synergy.name) ?? (synergy.nameFr ? nameIndex.get(synergy.nameFr) : void 0);
  }
  function countBy(cards, key) {
    const counts = /* @__PURE__ */ new Map();
    for (const card of cards) {
      for (const v2 of key(card)) {
        counts.set(v2, (counts.get(v2) ?? 0) + 1);
      }
    }
    return counts;
  }
  function colorLabel(code) {
    const def = COLOR_DEFS.find((c) => c.code === code);
    return def ? gameLabel(englishColor(code), def.label) : code;
  }
  const COLOR_EN = {
    W: "White",
    U: "Blue",
    B: "Black",
    R: "Red",
    G: "Green",
    C: "Colorless"
  };
  function englishColor(code) {
    return COLOR_EN[code] ?? code;
  }
  function typeLabel(code) {
    const def = TYPE_DEFS.find((t2) => t2.code === code);
    return def ? gameLabel(def.code, def.label) : code;
  }
  function rarityLabel(code) {
    const def = RARITY_DEFS.find((r2) => r2.code === code);
    return def ? gameLabel(def.code, def.label) : code;
  }
  const VALID_SORTS = ["name", "price-asc", "price-desc", "expansion", "newest", "best-sellers"];
  const LIST_PARAMS = [
    ["expansions", "exp"],
    ["colors", "couleur"],
    ["rarities", "rarete"],
    ["types", "type"],
    ["creatureTypes", "creature"],
    ["landMana", "mana"],
    ["cmc", "cmc"],
    ["keywords", "kw"]
  ];
  function stateToParams(filters, sort, view) {
    const p2 = new URLSearchParams();
    if (filters.search) p2.set("q", filters.search);
    if (filters.searchInText) p2.set("texte", "1");
    for (const [key, param] of LIST_PARAMS) {
      if (filters[key].length > 0) p2.set(param, filters[key].join(","));
    }
    if (filters.multicolorOnly) p2.set("multi", "1");
    if (filters.legendaryOnly) p2.set("legendaire", "1");
    if (filters.format !== "all") p2.set("fmt", filters.format);
    if (filters.foil !== "all") p2.set("foil", filters.foil);
    if (filters.language !== "all") p2.set("langue", filters.language);
    if (filters.priceMin !== null) p2.set("pmin", String(filters.priceMin));
    if (filters.priceMax !== null) p2.set("pmax", String(filters.priceMax));
    if (sort !== "name") p2.set("sort", sort);
    if (view !== "grid") p2.set("vue", view);
    return p2;
  }
  function paramsToState(params) {
    const filters = { ...EMPTY_FILTERS };
    filters.search = params.get("q") ?? "";
    filters.searchInText = params.get("texte") === "1";
    for (const [key, param] of LIST_PARAMS) {
      const raw = params.get(param);
      if (raw) filters[key] = raw.split(",").map((v2) => v2.trim()).filter(Boolean);
    }
    filters.multicolorOnly = params.get("multi") === "1";
    filters.legendaryOnly = params.get("legendaire") === "1";
    filters.format = params.get("fmt") ?? "all";
    const foil = params.get("foil");
    if (foil === "foil" || foil === "nonfoil") filters.foil = foil;
    const lang = params.get("langue");
    if (lang === "fr" || lang === "en") filters.language = lang;
    const pmin = Number(params.get("pmin"));
    const pmax = Number(params.get("pmax"));
    if (params.get("pmin") !== null && Number.isFinite(pmin)) filters.priceMin = pmin;
    if (params.get("pmax") !== null && Number.isFinite(pmax)) filters.priceMax = pmax;
    const sortParam = params.get("sort");
    const sort = sortParam && VALID_SORTS.includes(sortParam) ? sortParam : "name";
    const view = params.get("vue") === "list" ? "list" : "grid";
    return { filters, sort, view };
  }
  function syncUrl(filters, sort, view) {
    const managed = /* @__PURE__ */ new Set([
      "q",
      "texte",
      "multi",
      "legendaire",
      "fmt",
      "foil",
      "langue",
      "pmin",
      "pmax",
      "sort",
      "vue",
      ...LIST_PARAMS.map(([, param]) => param)
    ]);
    const current = new URLSearchParams(window.location.search);
    const next = stateToParams(filters, sort, view);
    for (const [k2, v2] of current) {
      if (!managed.has(k2)) next.append(k2, v2);
    }
    const qs = next.toString();
    const url = window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
    window.history.replaceState(null, "", url);
  }
  const CartContext = reactExports.createContext(null);
  function CartProvider({ adapter, children }) {
    const [items, setItems] = reactExports.useState({});
    const [error, setError] = reactExports.useState(null);
    const queue = reactExports.useRef(Promise.resolve());
    reactExports.useEffect(() => {
      let cancelled = false;
      adapter.load().then(
        (loaded) => {
          if (!cancelled) setItems(loaded);
        },
        () => {
          if (!cancelled) setError(t("cart.error.body"));
        }
      );
      return () => {
        cancelled = true;
      };
    }, [adapter]);
    const applyQty = reactExports.useCallback(
      (card, qty) => {
        const target = Math.max(0, Math.min(qty, card.availableQuantity));
        setError(null);
        setItems((prev) => {
          const next = { ...prev };
          if (target === 0) delete next[card.id];
          else next[card.id] = target;
          return next;
        });
        queue.current = queue.current.then(() => adapter.setQty(card, target)).then(
          (serverItems) => setItems(serverItems),
          (e) => {
            setError(e instanceof Error ? e.message : t("cart.error.title"));
            return adapter.load().then(setItems, () => void 0);
          }
        );
      },
      [adapter]
    );
    const value = reactExports.useMemo(
      () => ({
        items,
        add: (card, qty) => applyQty(card, (items[card.id] ?? 0) + qty),
        setQty: applyQty,
        remove: (card) => applyQty(card, 0),
        clear: () => {
          setError(null);
          setItems({});
          queue.current = queue.current.then(() => adapter.clear()).catch(() => setError(t("cart.error.title")));
        },
        totalCount: Object.values(items).reduce((s, q2) => s + q2, 0),
        checkoutUrl: adapter.checkoutUrl,
        error
      }),
      [items, applyQty, adapter, error]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CartContext.Provider, { value, children });
  }
  function useCart() {
    const ctx = reactExports.useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used within CartProvider");
    return ctx;
  }
  const STOCK_SKU_RE$1 = /^MTG-STOCK-(\d+)$/;
  const PAGE_SIZE$1 = 250;
  const PRODUCTS_QUERY = (
    /* GraphQL */
    `
  query CardShopCatalog($cursor: String) {
    # sortKey TITLE : le titre commence par le nom de la carte, donc la première
    # page reçue correspond au haut de la grille (tri par défaut Nom A→Z)
    products(first: ${PAGE_SIZE$1}, after: $cursor, sortKey: TITLE, query: "product_type:Singles AND available_for_sale:true") {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        title
        handle
        createdAt
        images(first: 2) {
          nodes {
            url
          }
        }
        metafields(
          identifiers: [
            { namespace: "mtg", key: "name_en" }
            { namespace: "mtg", key: "name_fr" }
            { namespace: "mtg", key: "rarity" }
            { namespace: "mtg", key: "colors" }
            { namespace: "mtg", key: "produced_mana" }
            { namespace: "mtg", key: "mana_cost" }
            { namespace: "mtg", key: "cmc" }
            { namespace: "mtg", key: "legalities" }
            { namespace: "mtg", key: "type_line" }
            { namespace: "mtg", key: "expansion" }
            { namespace: "mtg", key: "expansion_code" }
            { namespace: "mtg", key: "collector_number" }
            { namespace: "mtg", key: "language" }
            { namespace: "mtg", key: "condition" }
            { namespace: "mtg", key: "goods_condition" }
            { namespace: "mtg", key: "arrival_date" }
            { namespace: "mtg", key: "text_en" }
            { namespace: "mtg", key: "text_fr" }
            { namespace: "mtg", key: "keywords" }
            { namespace: "mtg", key: "synergies" }
          ]
        ) {
          key
          value
        }
        variants(first: 1) {
          nodes {
            id
            sku
            quantityAvailable
            price {
              amount
            }
          }
        }
      }
    }
  }
`
  );
  const BEST_SELLERS_QUERY = (
    /* GraphQL */
    `
  query CardShopBestSellers {
    products(first: 100, sortKey: BEST_SELLING, query: "product_type:Singles AND available_for_sale:true") {
      nodes {
        variants(first: 1) {
          nodes {
            sku
          }
        }
      }
    }
  }
`
  );
  function parseTitle(title) {
    const foil = /\[FOIL\]/i.test(title);
    const langMatch = title.match(/\[(FR|EN)\]/i);
    const name = title.replace(/\s*\[(FR|EN|FOIL)\]/gi, "").trim();
    return { name, foil, language: langMatch ? langMatch[1].toLowerCase() : null };
  }
  function normalizeLanguage(value) {
    const v2 = (value == null ? void 0 : value.trim().toLowerCase()) ?? "";
    if (/^(fr|french|fran[cç]ais)/.test(v2)) return "fr";
    if (/^(en|english|anglais)/.test(v2)) return "en";
    return null;
  }
  function mapProduct(product) {
    var _a, _b, _c;
    const variant = product.variants.nodes[0];
    if (!variant) return null;
    const skuMatch = (_a = variant.sku) == null ? void 0 : _a.match(STOCK_SKU_RE$1);
    if (!skuMatch) return null;
    const meta = new Map(
      product.metafields.filter((m2) => m2 !== null).map((m2) => [m2.key, m2.value])
    );
    const { name, foil, language } = parseTitle(product.title);
    const lang = normalizeLanguage(meta.get("language")) ?? language ?? "fr";
    const availableQuantity = Math.max(0, variant.quantityAvailable ?? 0);
    const expansion = meta.get("expansion") ?? "";
    return {
      id: Number(skuMatch[1]),
      language: lang,
      foil,
      condition: meta.get("condition") ?? "NM",
      secondHand: meta.get("goods_condition") === "used",
      availableQuantity,
      price: parseFloat(variant.price.amount),
      // Le titre du produit n'a que le nom dans la langue de la carte ; les
      // metafields name_en/name_fr donnent les deux (recherche/deck import bilingues)
      name: meta.get("name_en") || name,
      nameFr: meta.get("name_fr") || (lang === "fr" ? name : null),
      expansion,
      expansionCode: meta.get("expansion_code") || expansion,
      collectorNumber: meta.get("collector_number") ?? "",
      rarity: meta.get("rarity") ?? "Common",
      colors: meta.get("colors") ?? null,
      producedMana: meta.get("produced_mana") ?? null,
      manaCost: meta.get("mana_cost") ?? null,
      cmc: meta.get("cmc") != null ? parseFloat(meta.get("cmc")) : null,
      legalities: parseJsonArray(meta.get("legalities")),
      typeLine: meta.get("type_line") ?? null,
      imageUrl: ((_b = product.images.nodes[0]) == null ? void 0 : _b.url) ?? null,
      imageUrlBack: ((_c = product.images.nodes[1]) == null ? void 0 : _c.url) ?? null,
      scryfallId: null,
      textEn: meta.get("text_en") ?? null,
      textFr: meta.get("text_fr") ?? null,
      keywords: parseJsonArray(meta.get("keywords")),
      synergies: parseSynergies(meta.get("synergies")),
      variantId: Number(variant.id.split("/").pop()),
      handle: product.handle,
      // mtg.arrival_date (dernier restock, posé par ShopAlyse) prime sur la date de
      // création du produit — un réassort fait remonter la carte dans "Derniers arrivages"
      createdAt: meta.get("arrival_date") ?? product.createdAt ?? null,
      productCreatedAt: product.createdAt ?? null
    };
  }
  function parseJsonArray(raw) {
    if (!raw) return void 0;
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((v2) => typeof v2 === "string") : void 0;
    } catch {
      return void 0;
    }
  }
  function parseSynergies(raw) {
    if (!raw) return void 0;
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return void 0;
      return parsed.filter((s) => s && typeof s.name === "string").map((s) => ({
        name: s.name,
        nameFr: s.nameFr ?? null,
        imageUrl: s.imageUrl ?? null,
        score: Number(s.score ?? 0),
        stockIds: Array.isArray(s.stockIds) ? s.stockIds.map(Number) : []
      }));
    } catch {
      return void 0;
    }
  }
  const CACHE_KEY = "cardshop-catalog-v9";
  const CACHE_TTL_MS = 10 * 60 * 1e3;
  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed.cards) || typeof parsed.ts !== "number") return null;
      return parsed;
    } catch {
      return null;
    }
  }
  function writeCache(cards) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), cards }));
    } catch {
    }
  }
  async function storefrontQuery(query, variables) {
    var _a;
    const { storefrontToken, apiVersion, shopDomain, locale } = getShopifyConfig();
    const endpoint = `${shopDomain ? `https://${shopDomain}` : window.location.origin}/api/${apiVersion}/graphql.json`;
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontToken,
        // ⚠️ Sans cet en-tête, l'API rend le contenu produit dans la langue
        // PRIMAIRE de la boutique : un visiteur anglophone recevrait des titres
        // et des descriptions en français, quelle que soit la traduction publiée.
        ...locale ? { "Accept-Language": locale } : {}
      },
      body: JSON.stringify({ query, variables })
    });
    if (!res.ok) throw new Error(`Storefront API: HTTP ${res.status}`);
    const json = await res.json();
    if ((_a = json.errors) == null ? void 0 : _a.length) throw new Error(`Storefront API: ${json.errors[0].message}`);
    return json.data;
  }
  async function fetchSalesRanks() {
    var _a, _b;
    const data = await storefrontQuery(BEST_SELLERS_QUERY);
    const ranks = /* @__PURE__ */ new Map();
    for (const node of data.products.nodes) {
      const skuMatch = (_b = (_a = node.variants.nodes[0]) == null ? void 0 : _a.sku) == null ? void 0 : _b.match(STOCK_SKU_RE$1);
      if (skuMatch) ranks.set(Number(skuMatch[1]), ranks.size + 1);
    }
    return ranks;
  }
  async function fetchAll(onPartial) {
    const ranksRef = { current: null };
    const ranksPromise = fetchSalesRanks().catch(() => /* @__PURE__ */ new Map()).then((m2) => ranksRef.current = m2);
    const cards = [];
    let cursor = null;
    for (let page = 0; page < 40; page++) {
      const data = await storefrontQuery(PRODUCTS_QUERY, { cursor });
      const { nodes, pageInfo } = data.products;
      for (const product of nodes) {
        const card = mapProduct(product);
        if (card && card.availableQuantity > 0) {
          if (ranksRef.current) card.salesRank = ranksRef.current.get(card.id) ?? null;
          cards.push(card);
        }
      }
      if (!pageInfo.hasNextPage) break;
      cursor = pageInfo.endCursor;
      onPartial == null ? void 0 : onPartial([...cards]);
    }
    const finalRanks = await ranksPromise;
    for (const card of cards) {
      card.salesRank = finalRanks.get(card.id) ?? null;
    }
    return cards;
  }
  const shopifyCatalog = {
    async load(onPartial) {
      const cached = readCache();
      if (cached && Date.now() - cached.ts < CACHE_TTL_MS) {
        void fetchAll().then((fresh) => {
          writeCache(fresh);
          onPartial == null ? void 0 : onPartial(fresh);
        }).catch(() => void 0);
        return cached.cards;
      }
      const cards = await fetchAll(onPartial);
      writeCache(cards);
      return cards;
    }
  };
  const STOCK_SKU_RE = /^MTG-STOCK-(\d+)$/;
  function mapCart(items) {
    var _a;
    const out = {};
    for (const item of items) {
      const match = (_a = item.sku) == null ? void 0 : _a.match(STOCK_SKU_RE);
      if (match) out[Number(match[1])] = item.quantity;
    }
    return out;
  }
  async function fetchCart() {
    const res = await fetch(shopPath("/cart.js"), { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`Panier Shopify: HTTP ${res.status}`);
    return res.json();
  }
  async function refreshThemeCartBubble() {
    try {
      const sync = window.NMCartSync;
      if (typeof sync === "function") {
        sync();
        return;
      }
      const target = document.getElementById("cart-icon-bubble");
      if (!target) return;
      const res = await fetch(shopPath("/?sections=cart-icon-bubble"));
      if (!res.ok) return;
      const sections = await res.json();
      const html = sections["cart-icon-bubble"];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      const inner = doc.querySelector("#shopify-section-cart-icon-bubble") ?? doc.body;
      target.innerHTML = inner.innerHTML;
    } catch {
    }
  }
  const shopifyCart = {
    async load() {
      return mapCart((await fetchCart()).items);
    },
    async setQty(card, qty) {
      if (!card.variantId) throw new Error(`Carte ${card.id} sans variantId Shopify`);
      const target = Math.max(0, Math.min(qty, card.availableQuantity));
      const current = mapCart((await fetchCart()).items);
      const inCart = current[card.id] ?? 0;
      let res;
      if (inCart === 0 && target > 0) {
        res = await fetch(shopPath("/cart/add.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: card.variantId, quantity: target })
        });
      } else {
        res = await fetch(shopPath("/cart/change.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: String(card.variantId), quantity: target })
        });
      }
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.description || body.message || `Panier Shopify: HTTP ${res.status}`);
      }
      void refreshThemeCartBubble();
      return mapCart((await fetchCart()).items);
    },
    async clear() {
      const res = await fetch(shopPath("/cart/clear.js"), {
        method: "POST",
        headers: { Accept: "application/json" }
      });
      if (!res.ok) throw new Error(`Panier Shopify: HTTP ${res.status}`);
      void refreshThemeCartBubble();
    },
    // ⚠️ Prefixe de langue obligatoire : '/checkout' non prefixe renvoie le
    // client anglophone dans un tunnel francais.
    get checkoutUrl() {
      return shopPath("/checkout");
    }
  };
  const TARGET = "shopify";
  function getShopifyConfig() {
    const config = window.CARD_SHOP_CONFIG ?? {};
    if (!config.storefrontToken) {
      throw new Error(
        "CARD_SHOP_CONFIG.storefrontToken manquant — renseigner le token Storefront dans les réglages de la section."
      );
    }
    return {
      storefrontToken: config.storefrontToken,
      apiVersion: config.apiVersion ?? "2025-07",
      shopDomain: config.shopDomain,
      locale: config.locale,
      rootUrl: config.rootUrl,
      countryCode: config.countryCode
    };
  }
  function getCatalogAdapter() {
    return shopifyCatalog;
  }
  function getCartAdapter() {
    return shopifyCart;
  }
  const SORT_OPTIONS = [
    { value: "name", label: "Nom A→Z" },
    { value: "price-asc", label: t("sort.priceAsc") },
    { value: "price-desc", label: t("sort.priceDesc") },
    { value: "expansion", label: "Extension" },
    { value: "newest", label: "Derniers arrivages" },
    { value: "best-sellers", label: "Meilleures ventes" }
  ];
  const VIEW_CHIPS = [
    { value: "newest", label: "🆕 Derniers arrivages" },
    { value: "best-sellers", label: "🔥 Meilleures ventes" }
  ];
  function toggle(list, value) {
    return list.includes(value) ? list.filter((v2) => v2 !== value) : [...list, value];
  }
  function Dropdown({ id: id2, label, activeCount, openKey, setOpenKey, panelClass = "w-64", children }) {
    const open = openKey === id2;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: () => setOpenKey(open ? null : id2),
          className: `flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm transition ${activeCount > 0 ? "border-indigo-600 bg-indigo-50 text-indigo-800" : open ? "border-neutral-500 text-neutral-900" : "border-neutral-300 text-neutral-700 hover:border-neutral-500"}`,
          children: [
            label,
            activeCount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "flex min-w-[18px] items-center justify-center rounded-full bg-indigo-600 px-1 text-[11px] font-bold text-white", children: activeCount }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "svg",
              {
                width: "10",
                height: "10",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2.5",
                className: `transition ${open ? "rotate-180" : ""}`,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m6 9 6 6 6-6", strokeLinecap: "round", strokeLinejoin: "round" })
              }
            )
          ]
        }
      ),
      open && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: `absolute left-0 top-full z-40 mt-1.5 max-w-[calc(100vw-2rem)] rounded-xl border border-neutral-200 bg-white p-3 shadow-xl ${panelClass}`,
          children
        }
      )
    ] });
  }
  function SheetSection({ title, activeCount, children }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("details", { className: "group border-b border-neutral-200", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("summary", { className: "flex cursor-pointer list-none items-center gap-2 py-3 text-sm font-medium text-neutral-900 [&::-webkit-details-marker]:hidden", children: [
        title,
        activeCount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "flex min-w-[18px] items-center justify-center rounded-full bg-indigo-600 px-1 text-[11px] font-bold text-white", children: activeCount }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "svg",
          {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2.5",
            className: "ml-auto text-neutral-400 transition group-open:rotate-180",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m6 9 6 6 6-6", strokeLinecap: "round", strokeLinejoin: "round" })
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pb-3", children })
    ] });
  }
  function FilterBar({ cards, filters, onChange, sort, onSort, view, onView, resultCount, onOpenCart, onOpenDeckImport }) {
    var _a;
    const { totalCount } = useCart();
    const [openKey, setOpenKey] = reactExports.useState(null);
    const [sheetOpen, setSheetOpen] = reactExports.useState(false);
    const [localSearch, setLocalSearch] = reactExports.useState(filters.search);
    const [expansionQuery, setExpansionQuery] = reactExports.useState("");
    const [keywordQuery, setKeywordQuery] = reactExports.useState("");
    const [creatureQuery, setCreatureQuery] = reactExports.useState("");
    const containerRef = reactExports.useRef(null);
    const searchTimer = reactExports.useRef();
    reactExports.useEffect(() => setLocalSearch(filters.search), [filters.search]);
    reactExports.useEffect(() => {
      if (sheetOpen) return;
      if (openKey !== "expansions") setExpansionQuery("");
      if (openKey !== "keywords") setKeywordQuery("");
      if (openKey !== "types") setCreatureQuery("");
    }, [openKey, sheetOpen]);
    reactExports.useEffect(() => {
      const onClick = (e) => {
        if (containerRef.current && !containerRef.current.contains(e.target)) setOpenKey(null);
      };
      const onKey = (e) => {
        if (e.key === "Escape") {
          setOpenKey(null);
          setSheetOpen(false);
        }
      };
      document.addEventListener("mousedown", onClick);
      document.addEventListener("keydown", onKey);
      return () => {
        document.removeEventListener("mousedown", onClick);
        document.removeEventListener("keydown", onKey);
      };
    }, []);
    reactExports.useEffect(() => {
      document.body.style.overflow = sheetOpen ? "hidden" : "";
      return () => {
        document.body.style.overflow = "";
      };
    }, [sheetOpen]);
    const handleSearch = (value) => {
      setLocalSearch(value);
      if (searchTimer.current) clearTimeout(searchTimer.current);
      searchTimer.current = setTimeout(() => onChange({ ...filters, search: value }), 200);
    };
    const expansionCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "expansions"), (c) => [c.expansionCode]),
      [cards, filters]
    );
    const rarityCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "rarities"), (c) => [c.rarity]),
      [cards, filters]
    );
    const typeCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "types"), (c) => primaryTypes(c)),
      [cards, filters]
    );
    const colorCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "colors"), (c) => cardColors(c)),
      [cards, filters]
    );
    const keywordCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "keywords"), (c) => c.keywords ?? []),
      [cards, filters]
    );
    const creatureTypeCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "types"), (c) => creatureSubtypes(c)),
      [cards, filters]
    );
    const landManaCounts = reactExports.useMemo(
      () => countBy(
        applyFilters(cards, filters, "types"),
        (c) => primaryTypes(c).includes("Land") ? producedMana(c) : []
      ),
      [cards, filters]
    );
    const cmcCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "cmc"), (c) => cmcBucket(c) ? [cmcBucket(c)] : []),
      [cards, filters]
    );
    const formatCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "format"), (c) => c.legalities ?? []),
      [cards, filters]
    );
    const legendaryCount = reactExports.useMemo(
      () => applyFilters(cards, filters, "types").filter(isLegendary).length,
      [cards, filters]
    );
    const foilCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "foil"), (c) => [c.foil ? "foil" : "nonfoil"]),
      [cards, filters]
    );
    const langCounts = reactExports.useMemo(
      () => countBy(applyFilters(cards, filters, "language"), (c) => [c.language]),
      [cards, filters]
    );
    const expansions = reactExports.useMemo(() => {
      const seen = /* @__PURE__ */ new Map();
      for (const c of cards) {
        if (!seen.has(c.expansionCode)) seen.set(c.expansionCode, c.expansion);
      }
      return [...seen.entries()].sort((a, b) => a[1].localeCompare(b[1]));
    }, [cards]);
    const checkboxClass = "flex cursor-pointer items-center gap-2 rounded px-1 py-0.5 text-sm text-neutral-800 hover:bg-neutral-100";
    const colorsPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-wrap gap-1.5", children: COLOR_DEFS.map((color) => {
        const active = filters.colors.includes(color.code);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => onChange({ ...filters, colors: toggle(filters.colors, color.code) }),
            title: `${colorLabel(color.code)} (${colorCounts.get(color.code) ?? 0})`,
            className: `flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-bold transition ${active ? "scale-110 border-indigo-600" : "border-neutral-300 opacity-90 hover:opacity-100"}`,
            style: { backgroundColor: color.bg, color: color.text },
            children: color.code
          },
          color.code
        );
      }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "mt-2.5 flex cursor-pointer items-center gap-2 text-sm text-neutral-800", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "checkbox",
            checked: filters.multicolorOnly,
            onChange: (e) => onChange({ ...filters, multicolorOnly: e.target.checked }),
            className: "accent-indigo-600"
          }
        ),
        "Multicolore uniquement"
      ] })
    ] });
    const rarityPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "space-y-0.5", children: RARITY_DEFS.map((r2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "checkbox",
          checked: filters.rarities.includes(r2.code),
          onChange: () => onChange({ ...filters, rarities: toggle(filters.rarities, r2.code) }),
          className: "accent-indigo-600"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `h-2.5 w-2.5 rounded-full ${r2.dot}` }),
      r2.label,
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-xs text-neutral-400", children: rarityCounts.get(r2.code) ?? 0 })
    ] }, r2.code)) });
    const creatureTypesPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "search",
          value: creatureQuery,
          onChange: (e) => setCreatureQuery(e.target.value),
          placeholder: t("filter.name"),
          className: "mb-2 w-full rounded-lg border border-neutral-300 px-2.5 py-1.5 text-sm outline-none placeholder:text-neutral-400 focus:border-indigo-500"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "max-h-72 space-y-0.5 overflow-y-auto pr-1", children: (() => {
        const q2 = normalize(creatureQuery);
        const all = [...creatureTypeCounts.keys()].filter((s) => (creatureTypeCounts.get(s) ?? 0) > 0 || filters.creatureTypes.includes(s)).sort(
          (a, b) => (creatureTypeCounts.get(b) ?? 0) - (creatureTypeCounts.get(a) ?? 0) || creatureTypeLabel(a).localeCompare(creatureTypeLabel(b), "fr")
        );
        const visible = all.filter(
          (s) => !q2 || normalize(creatureTypeLabel(s)).includes(q2) || normalize(s).includes(q2)
        );
        if (visible.length === 0) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 text-sm text-neutral-400", children: t("filter.noType") });
        }
        return visible.map((subtype) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: filters.creatureTypes.includes(subtype),
              onChange: () => onChange({ ...filters, creatureTypes: toggle(filters.creatureTypes, subtype) }),
              className: "shrink-0 accent-indigo-600"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate", title: subtype, children: [
            creatureTypeLabel(subtype),
            creatureTypeLabel(subtype) !== subtype && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "ml-1 text-xs text-neutral-400", children: [
              "(",
              subtype,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto shrink-0 text-xs text-neutral-400", children: creatureTypeCounts.get(subtype) })
        ] }, subtype));
      })() })
    ] });
    const landManaPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-wrap gap-1.5", children: COLOR_DEFS.map((color) => {
      const active = filters.landMana.includes(color.code);
      const count = landManaCounts.get(color.code) ?? 0;
      if (count === 0 && !active) return null;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: () => onChange({ ...filters, landMana: toggle(filters.landMana, color.code) }),
          title: `${colorLabel(color.code)} (${count})`,
          className: `flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-bold transition ${active ? "scale-110 border-indigo-600" : "border-neutral-300 opacity-90 hover:opacity-100"}`,
          style: { backgroundColor: color.bg, color: color.text },
          children: color.code
        },
        color.code
      );
    }) });
    const cmcPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-wrap gap-1.5", children: CMC_BUCKETS.map((b) => {
      const active = filters.cmc.includes(b.code);
      const count = cmcCounts.get(b.code) ?? 0;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: () => onChange({ ...filters, cmc: toggle(filters.cmc, b.code) }),
          title: `${t("filter.manaValue", { value: b.label })} (${count})`,
          className: `rounded-full border px-3 py-1.5 text-sm transition ${active ? "border-indigo-600 bg-indigo-50 font-semibold text-indigo-800" : "border-neutral-300 text-neutral-700 hover:border-neutral-500"}`,
          children: [
            b.label,
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs text-neutral-400", children: count })
          ]
        },
        b.code
      );
    }) });
    const formatPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "radio",
            name: "format",
            checked: filters.format === "all",
            onChange: () => onChange({ ...filters, format: "all" }),
            className: "accent-indigo-600"
          }
        ),
        t("filter.allFormats")
      ] }),
      FORMAT_DEFS.map((f2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "radio",
            name: "format",
            checked: filters.format === f2.code,
            onChange: () => onChange({ ...filters, format: f2.code }),
            className: "accent-indigo-600"
          }
        ),
        f2.label,
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-xs text-neutral-400", children: formatCounts.get(f2.code) ?? 0 })
      ] }, f2.code))
    ] });
    const legendaryCheckbox = /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: `${checkboxClass} mt-1.5 border-t border-dashed border-neutral-200 pt-2`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "checkbox",
          checked: filters.legendaryOnly,
          onChange: (e) => onChange({ ...filters, legendaryOnly: e.target.checked }),
          className: "accent-indigo-600"
        }
      ),
      t("filter.legendaryOnly"),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-xs text-neutral-400", children: legendaryCount })
    ] });
    const typeCheckboxes = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-48 space-y-0.5", children: [
      TYPE_DEFS.map((t2) => {
        const count = typeCounts.get(t2.code) ?? 0;
        if (count === 0 && !filters.types.includes(t2.code)) return null;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: filters.types.includes(t2.code),
              onChange: () => onChange({
                ...filters,
                types: toggle(filters.types, t2.code),
                // Décocher "Créature" retire aussi ses sous-types, idem "Terrain" / mana produit
                creatureTypes: t2.code === "Creature" && filters.types.includes("Creature") ? [] : filters.creatureTypes,
                landMana: t2.code === "Land" && filters.types.includes("Land") ? [] : filters.landMana
              }),
              className: "accent-indigo-600"
            }
          ),
          t2.label,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-xs text-neutral-400", children: count })
        ] }, t2.code);
      }),
      legendaryCheckbox
    ] });
    const expansionsPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "search",
          value: expansionQuery,
          onChange: (e) => setExpansionQuery(e.target.value),
          placeholder: t("filter.expansions"),
          className: "mb-2 w-full rounded-lg border border-neutral-300 px-2.5 py-1.5 text-sm outline-none placeholder:text-neutral-400 focus:border-indigo-500"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid max-h-[50vh] grid-cols-1 gap-x-5 gap-y-0.5 overflow-y-auto sm:grid-cols-2", children: (() => {
        const q2 = normalize(expansionQuery);
        const visible = expansions.filter(([code, name]) => {
          const count = expansionCounts.get(code) ?? 0;
          if (count === 0 && !filters.expansions.includes(code)) return false;
          return !q2 || normalize(name).includes(q2) || normalize(code).includes(q2);
        });
        if (visible.length === 0) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "col-span-full py-2 text-sm text-neutral-400", children: t("filter.noExpansion") });
        }
        return visible.map(([code, name]) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: filters.expansions.includes(code),
              onChange: () => onChange({ ...filters, expansions: toggle(filters.expansions, code) }),
              className: "shrink-0 accent-indigo-600"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "truncate", title: name, children: name }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto shrink-0 text-xs text-neutral-400", children: expansionCounts.get(code) ?? 0 })
        ] }, code));
      })() })
    ] });
    const keywordsPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "search",
          value: keywordQuery,
          onChange: (e) => setKeywordQuery(e.target.value),
          placeholder: t("filter.keywords"),
          className: "mb-2 w-full rounded-lg border border-neutral-300 px-2.5 py-1.5 text-sm outline-none placeholder:text-neutral-400 focus:border-indigo-500"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid max-h-[50vh] grid-cols-1 gap-x-5 gap-y-0.5 overflow-y-auto sm:grid-cols-2", children: (() => {
        const q2 = normalize(keywordQuery);
        const allKeywords = [...keywordCounts.keys()].filter((k2) => isFilterableKeyword(k2) || filters.keywords.includes(k2)).filter((k2) => (keywordCounts.get(k2) ?? 0) > 0 || filters.keywords.includes(k2)).sort(
          (a, b) => (keywordCounts.get(b) ?? 0) - (keywordCounts.get(a) ?? 0) || keywordLabel(a).localeCompare(keywordLabel(b), "fr")
        );
        const visible = allKeywords.filter(
          (k2) => !q2 || normalize(keywordLabel(k2)).includes(q2) || normalize(k2).includes(q2)
        );
        if (visible.length === 0) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "col-span-full py-2 text-sm text-neutral-400", children: t("filter.noKeyword") });
        }
        return visible.map((keyword) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: filters.keywords.includes(keyword),
              onChange: () => onChange({ ...filters, keywords: toggle(filters.keywords, keyword) }),
              className: "shrink-0 accent-indigo-600"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate", title: keyword, children: [
            keywordLabel(keyword),
            keywordLabel(keyword) !== keyword && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "ml-1 text-xs text-neutral-400", children: [
              "(",
              keyword,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto shrink-0 text-xs text-neutral-400", children: keywordCounts.get(keyword) })
        ] }, keyword));
      })() })
    ] });
    const languagePanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "space-y-1", children: [
      ["all", t("filter.allLanguages")],
      ["fr", `${t("filter.french")} (${langCounts.get("fr") ?? 0})`],
      ["en", `${t("filter.english")} (${langCounts.get("en") ?? 0})`]
    ].map(([value, label]) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "radio",
          name: "language",
          checked: filters.language === value,
          onChange: () => onChange({ ...filters, language: value }),
          className: "accent-indigo-600"
        }
      ),
      label
    ] }, value)) });
    const foilPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "space-y-1", children: [
      ["all", t("filter.all")],
      ["nonfoil", `Normale (${foilCounts.get("nonfoil") ?? 0})`],
      ["foil", `✦ Foil (${foilCounts.get("foil") ?? 0})`]
    ].map(([value, label]) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: checkboxClass, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "radio",
          name: "foil",
          checked: filters.foil === value,
          onChange: () => onChange({ ...filters, foil: value }),
          className: "accent-indigo-600"
        }
      ),
      label
    ] }, value)) });
    const pricePanel = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "number",
          min: "0",
          step: "0.5",
          placeholder: t("filter.min"),
          value: filters.priceMin ?? "",
          onChange: (e) => onChange({ ...filters, priceMin: e.target.value === "" ? null : Number(e.target.value) }),
          className: "w-full rounded-lg border border-neutral-300 px-2 py-1.5 text-sm outline-none focus:border-indigo-500"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-neutral-400", children: "–" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "number",
          min: "0",
          step: "0.5",
          placeholder: t("filter.max"),
          value: filters.priceMax ?? "",
          onChange: (e) => onChange({ ...filters, priceMax: e.target.value === "" ? null : Number(e.target.value) }),
          className: "w-full rounded-lg border border-neutral-300 px-2 py-1.5 text-sm outline-none focus:border-indigo-500"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-500", children: "€" })
    ] });
    const chips = [];
    for (const code of filters.expansions) {
      chips.push({
        label: code,
        remove: () => onChange({ ...filters, expansions: filters.expansions.filter((e) => e !== code) })
      });
    }
    for (const color of filters.colors) {
      chips.push({
        label: colorLabel(color),
        remove: () => onChange({ ...filters, colors: filters.colors.filter((c) => c !== color) })
      });
    }
    if (filters.multicolorOnly)
      chips.push({ label: "Multicolore", remove: () => onChange({ ...filters, multicolorOnly: false }) });
    for (const rarity of filters.rarities) {
      chips.push({
        label: rarityLabel(rarity),
        remove: () => onChange({ ...filters, rarities: filters.rarities.filter((r2) => r2 !== rarity) })
      });
    }
    for (const type of filters.types) {
      chips.push({
        label: typeLabel(type),
        remove: () => onChange({ ...filters, types: filters.types.filter((t2) => t2 !== type) })
      });
    }
    for (const subtype of filters.creatureTypes) {
      chips.push({
        label: `${t("filter.creature")} ${creatureTypeLabel(subtype)}`,
        remove: () => onChange({ ...filters, creatureTypes: filters.creatureTypes.filter((c) => c !== subtype) })
      });
    }
    for (const mana of filters.landMana) {
      chips.push({
        label: `${t("filter.land")} ${colorLabel(mana)}`,
        remove: () => onChange({ ...filters, landMana: filters.landMana.filter((m2) => m2 !== mana) })
      });
    }
    if (filters.legendaryOnly) {
      chips.push({ label: t("filter.legendary"), remove: () => onChange({ ...filters, legendaryOnly: false }) });
    }
    for (const bucket of filters.cmc) {
      chips.push({
        label: `Mana : ${((_a = CMC_BUCKETS.find((b) => b.code === bucket)) == null ? void 0 : _a.label) ?? bucket}`,
        remove: () => onChange({ ...filters, cmc: filters.cmc.filter((b) => b !== bucket) })
      });
    }
    if (filters.format !== "all") {
      chips.push({ label: formatLabel(filters.format), remove: () => onChange({ ...filters, format: "all" }) });
    }
    for (const keyword of filters.keywords) {
      chips.push({
        label: keywordLabel(keyword),
        remove: () => onChange({ ...filters, keywords: filters.keywords.filter((k2) => k2 !== keyword) })
      });
    }
    if (filters.foil !== "all") {
      chips.push({ label: filters.foil === "foil" ? "✦ Foil" : "Normale", remove: () => onChange({ ...filters, foil: "all" }) });
    }
    if (filters.language !== "all") {
      chips.push({
        label: filters.language === "fr" ? "🇫🇷 FR" : "🇬🇧 EN",
        remove: () => onChange({ ...filters, language: "all" })
      });
    }
    if (filters.priceMin !== null || filters.priceMax !== null) {
      chips.push({
        label: `${filters.priceMin ?? 0} – ${filters.priceMax ?? "∞"} €`,
        remove: () => onChange({ ...filters, priceMin: null, priceMax: null })
      });
    }
    const chipButtons = chips.map((chip, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        onClick: chip.remove,
        className: "flex items-center gap-1 rounded-full bg-indigo-600 px-2.5 py-1 text-xs font-medium text-white hover:bg-indigo-500",
        children: [
          chip.label,
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "opacity-70", children: "✕" })
        ]
      },
      i
    ));
    const clearAllButton = /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: () => onChange({ ...EMPTY_FILTERS, search: filters.search }),
        className: "text-xs text-neutral-500 underline-offset-2 hover:text-neutral-900 hover:underline",
        children: t("filter.clearAll")
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: containerRef, className: "sticky top-0 z-[2] border-b border-neutral-200 bg-white/95 backdrop-blur", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto max-w-screen-2xl space-y-2 px-4 py-2.5", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative min-w-0 flex-1 sm:max-w-md", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "svg",
              {
                className: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "11", cy: "11", r: "7" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m20 20-3.5-3.5", strokeLinecap: "round" })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "search",
                value: localSearch,
                onChange: (e) => handleSearch(e.target.value),
                placeholder: t("filter.search"),
                className: "w-full rounded-full border border-neutral-300 py-1.5 pl-9 pr-12 text-sm outline-none placeholder:text-neutral-400 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-300"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: () => onChange({ ...filters, searchInText: !filters.searchInText }),
                title: filters.searchInText ? t("filter.searchOracleOn") : t("filter.searchOracle"),
                className: `absolute right-2 top-1/2 -translate-y-1/2 rounded-full px-1.5 py-0.5 text-[10px] font-bold transition ${filters.searchInText ? "bg-indigo-600 text-white" : "bg-neutral-100 text-neutral-400 hover:bg-neutral-200 hover:text-neutral-600"}`,
                children: "+texte"
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "hidden whitespace-nowrap text-sm text-neutral-500 md:block", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "font-semibold text-neutral-900", children: resultCount }),
            " carte",
            resultCount > 1 ? "s" : ""
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-auto hidden items-center gap-1.5 md:flex", children: [
            VIEW_CHIPS.map((v2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: () => onSort(sort === v2.value ? "name" : v2.value),
                className: `whitespace-nowrap rounded-full border px-3 py-1.5 text-sm transition ${sort === v2.value ? "border-indigo-600 bg-indigo-50 text-indigo-800" : "border-neutral-300 text-neutral-700 hover:border-neutral-500"}`,
                children: v2.label
              },
              v2.value
            )),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "select",
              {
                value: sort,
                onChange: (e) => onSort(e.target.value),
                className: "rounded-full border border-neutral-300 px-3 py-1.5 text-sm text-neutral-700 outline-none focus:border-indigo-500",
                children: SORT_OPTIONS.map((o) => /* @__PURE__ */ jsxRuntimeExports.jsxs("option", { value: o.value, children: [
                  "Tri : ",
                  o.label
                ] }, o.value))
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex overflow-hidden rounded-full border border-neutral-300", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => onView("grid"),
                  title: t("view.grid"),
                  className: `px-2.5 py-1.5 ${view === "grid" ? "bg-neutral-900 text-white" : "text-neutral-500 hover:text-neutral-900"}`,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "14", y: "3", width: "7", height: "7", rx: "1" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" })
                  ] })
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => onView("list"),
                  title: t("view.list"),
                  className: `px-2.5 py-1.5 ${view === "list" ? "bg-neutral-900 text-white" : "text-neutral-500 hover:text-neutral-900"}`,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 6h16M4 12h16M4 18h16", strokeLinecap: "round" }) })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              onClick: onOpenCart,
              className: "relative flex items-center gap-2 rounded-full bg-neutral-900 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-neutral-700 sm:px-4",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "9", cy: "20", r: "1.5" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "17", cy: "20", r: "1.5" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3 4h2l2.5 12h11L21 8H6.1", strokeLinecap: "round", strokeLinejoin: "round" })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hidden sm:inline", children: "Panier" }),
                totalCount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-xs font-bold text-white", children: totalCount })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2 md:hidden", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              onClick: () => setSheetOpen(true),
              className: `flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm ${chips.length > 0 ? "border-indigo-600 bg-indigo-50 text-indigo-800" : "border-neutral-300 text-neutral-700"}`,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3 6h18M6 12h12M10 18h4", strokeLinecap: "round" }) }),
                "Filtres",
                chips.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "flex min-w-[18px] items-center justify-center rounded-full bg-indigo-600 px-1 text-[11px] font-bold text-white", children: chips.length })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-500", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "font-semibold text-neutral-900", children: resultCount }),
            " carte",
            resultCount > 1 ? "s" : ""
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: onOpenDeckImport,
              className: "rounded-full bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm",
              "aria-label": t("deck.open"),
              children: "📋"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "select",
            {
              value: sort,
              onChange: (e) => onSort(e.target.value),
              className: "ml-auto min-w-0 rounded-full border border-neutral-300 px-2.5 py-1.5 text-sm text-neutral-700 outline-none focus:border-indigo-500",
              children: SORT_OPTIONS.map((o) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: o.value, children: o.label }, o.value))
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => onView(view === "grid" ? "list" : "grid"),
              title: view === "grid" ? "Vue liste compacte" : "Vue grille",
              className: "rounded-full border border-neutral-300 px-2.5 py-1.5 text-neutral-600",
              children: view === "grid" ? /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 6h16M4 12h16M4 18h16", strokeLinecap: "round" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "14", y: "3", width: "7", height: "7", rx: "1" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "hidden flex-wrap items-center gap-1.5 md:flex", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mr-1 text-sm text-neutral-500", children: "Filtres :" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Dropdown,
            {
              id: "colors",
              label: t("filter.colors"),
              activeCount: filters.colors.length + (filters.multicolorOnly ? 1 : 0),
              openKey,
              setOpenKey,
              panelClass: "w-64",
              children: colorsPanel
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "rarities", label: t("card.rarity"), activeCount: filters.rarities.length, openKey, setOpenKey, panelClass: "w-56", children: rarityPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Dropdown,
            {
              id: "types",
              label: t("filter.type"),
              activeCount: filters.types.length + filters.creatureTypes.length + filters.landMana.length + (filters.legendaryOnly ? 1 : 0),
              openKey,
              setOpenKey,
              panelClass: filters.types.includes("Creature") ? "w-[34rem]" : filters.types.includes("Land") ? "w-[27rem]" : "w-56",
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: filters.types.includes("Creature") || filters.types.includes("Land") ? "flex gap-4" : "", children: [
                typeCheckboxes,
                (filters.types.includes("Creature") || filters.types.includes("Land")) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0 flex-1 space-y-4 border-l border-neutral-200 pl-4", children: [
                  filters.types.includes("Creature") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mb-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: [
                      t("filter.creatureType"),
                      " ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-normal normal-case", children: "(optionnel)" })
                    ] }),
                    creatureTypesPanel
                  ] }),
                  filters.types.includes("Land") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mb-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: [
                      "Mana produit ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-normal normal-case", children: "(optionnel)" })
                    ] }),
                    landManaPanel
                  ] })
                ] })
              ] })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "cmc", label: t("filter.manaCost"), activeCount: filters.cmc.length, openKey, setOpenKey, panelClass: "w-80", children: cmcPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "format", label: t("filter.format"), activeCount: filters.format !== "all" ? 1 : 0, openKey, setOpenKey, panelClass: "w-52", children: formatPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "expansions", label: t("filter.expansion"), activeCount: filters.expansions.length, openKey, setOpenKey, panelClass: "w-[38rem]", children: expansionsPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "keywords", label: t("card.keywords"), activeCount: filters.keywords.length, openKey, setOpenKey, panelClass: "w-[34rem]", children: keywordsPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "language", label: t("filter.language"), activeCount: filters.language !== "all" ? 1 : 0, openKey, setOpenKey, panelClass: "w-48", children: languagePanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { id: "foil", label: t("filter.finish"), activeCount: filters.foil !== "all" ? 1 : 0, openKey, setOpenKey, panelClass: "w-48", children: foilPanel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Dropdown,
            {
              id: "price",
              label: t("filter.price"),
              activeCount: filters.priceMin !== null || filters.priceMax !== null ? 1 : 0,
              openKey,
              setOpenKey,
              panelClass: "w-64",
              children: pricePanel
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              className: "rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1.5 text-sm text-emerald-800",
              title: t("filter.conditionNote"),
              children: t("filter.condition")
            }
          ),
          chips.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-1 h-5 w-px bg-neutral-200" }),
            chipButtons,
            clearAllButton
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: onOpenDeckImport,
              className: "ml-auto flex items-center gap-1.5 whitespace-nowrap rounded-full bg-indigo-600 px-3.5 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700",
              children: t("deck.openLabel")
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center gap-1.5 md:hidden", children: VIEW_CHIPS.map((v2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => onSort(sort === v2.value ? "name" : v2.value),
            className: `rounded-full border px-3 py-1 text-sm transition ${sort === v2.value ? "border-indigo-600 bg-indigo-50 text-indigo-800" : "border-neutral-300 text-neutral-700"}`,
            children: v2.label
          },
          v2.value
        )) }),
        chips.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-wrap items-center gap-1.5 md:hidden", children: [
          chipButtons,
          clearAllButton
        ] })
      ] }) }),
      sheetOpen && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fixed inset-0 z-50 md:hidden", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/50", onClick: () => setSheetOpen(false) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "absolute inset-x-0 bottom-0 flex max-h-[88vh] flex-col rounded-t-2xl bg-white shadow-2xl", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b border-neutral-200 px-4 py-3", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-semibold text-neutral-900", children: "Filtres" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3", children: [
              chips.length > 0 && clearAllButton,
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => setSheetOpen(false),
                  className: "rounded p-1 text-neutral-400 hover:bg-neutral-100",
                  "aria-label": t("card.close"),
                  children: "✕"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-h-0 flex-1 overflow-y-auto px-4", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.colors"), activeCount: filters.colors.length + (filters.multicolorOnly ? 1 : 0), children: colorsPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("card.rarity"), activeCount: filters.rarities.length, children: rarityPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              SheetSection,
              {
                title: t("filter.type"),
                activeCount: filters.types.length + filters.creatureTypes.length + filters.landMana.length + (filters.legendaryOnly ? 1 : 0),
                children: [
                  typeCheckboxes,
                  filters.types.includes("Creature") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 border-t border-dashed border-neutral-200 pt-3", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mb-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: [
                      t("filter.creatureType"),
                      " ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-normal normal-case", children: "(optionnel)" })
                    ] }),
                    creatureTypesPanel
                  ] }),
                  filters.types.includes("Land") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 border-t border-dashed border-neutral-200 pt-3", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mb-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: [
                      "Mana produit ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-normal normal-case", children: "(optionnel)" })
                    ] }),
                    landManaPanel
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.manaCost"), activeCount: filters.cmc.length, children: cmcPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.format"), activeCount: filters.format !== "all" ? 1 : 0, children: formatPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.expansion"), activeCount: filters.expansions.length, children: expansionsPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("card.keywords"), activeCount: filters.keywords.length, children: keywordsPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.language"), activeCount: filters.language !== "all" ? 1 : 0, children: languagePanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.finish"), activeCount: filters.foil !== "all" ? 1 : 0, children: foilPanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SheetSection, { title: t("filter.price"), activeCount: filters.priceMin !== null || filters.priceMax !== null ? 1 : 0, children: pricePanel }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "py-3 text-sm text-neutral-500", children: [
              t("filter.conditionLabel"),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded bg-emerald-100 px-1.5 py-0.5 text-xs font-semibold text-emerald-800", children: "NM" }),
              " ",
              t("filter.conditionFull")
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-t border-neutral-200 p-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => setSheetOpen(false),
              className: "w-full rounded-full bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600",
              children: tn("filter.showResults", resultCount)
            }
          ) })
        ] })
      ] })
    ] });
  }
  const LANG_STYLES = {
    fr: { label: "FR", classes: "bg-blue-700 text-white" },
    en: { label: "EN", classes: "bg-red-700 text-white" }
  };
  function FlagIcon({ language, className = "" }) {
    if (language === "fr") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 3 2", className: `${className} rounded-[2px] ring-1 ring-white/70`, "aria-hidden": true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "1", height: "2", fill: "#002395" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", width: "1", height: "2", fill: "#fff" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "2", width: "1", height: "2", fill: "#ED2939" })
      ] });
    }
    if (language === "en") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 60 30", className: `${className} rounded-[2px] ring-1 ring-white/70`, "aria-hidden": true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "60", height: "30", fill: "#012169" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0,0 L60,30 M60,0 L0,30", stroke: "#fff", strokeWidth: "6" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0,0 L60,30 M60,0 L0,30", stroke: "#C8102E", strokeWidth: "2.5" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30,0 v30 M0,15 h60", stroke: "#fff", strokeWidth: "10" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30,0 v30 M0,15 h60", stroke: "#C8102E", strokeWidth: "6" })
      ] });
    }
    return null;
  }
  function LangBadge({ language, size = "sm" }) {
    const style = LANG_STYLES[language] ?? { label: language.toUpperCase(), classes: "bg-neutral-700 text-white" };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "span",
      {
        translate: "no",
        className: `notranslate inline-flex items-center gap-1 rounded-md font-bold shadow-sm ${style.classes} ${size === "md" ? "px-2.5 py-1 text-sm" : "px-1.5 py-0.5 text-xs"}`,
        title: style.label === "FR" ? t("lang.frCard") : style.label === "EN" ? t("lang.enCard") : style.label,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FlagIcon, { language, className: size === "md" ? "h-3 w-[18px]" : "h-2.5 w-[15px]" }),
          style.label
        ]
      }
    );
  }
  const SIZES = {
    sm: "h-3.5 w-3.5 text-[9px]",
    md: "h-[18px] w-[18px] text-[11px]"
  };
  function ManaSymbol({ symbol, size }) {
    if (symbol === "//") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-0.5 text-[10px] text-neutral-400", children: "//" });
    }
    const color = COLOR_DEFS.find((c) => c.code === symbol);
    const style = color ? { backgroundColor: color.bg, color: color.text } : { backgroundColor: "#c9c5c0", color: "#4c4a48" };
    const label = symbol.length > 2 ? symbol.replace(/\//g, "") : symbol;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        title: `{${symbol}}`,
        style,
        className: `inline-flex shrink-0 items-center justify-center rounded-full font-bold shadow-[inset_0_-1px_1px_rgba(0,0,0,0.15)] ${SIZES[size]} ${symbol.includes("/") ? "tracking-tighter" : ""}`,
        children: label
      }
    );
  }
  function ManaCost({ manaCost, size = "sm" }) {
    if (!manaCost) return null;
    const symbols = manaCostSymbols(manaCost);
    if (symbols.length === 0) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "inline-flex items-center gap-0.5 align-middle", children: symbols.map((s, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(ManaSymbol, { symbol: s, size }, i)) });
  }
  function CardTile({ card, onOpen, versionCount, onOpenVersions }) {
    var _a;
    const { items, add, setQty } = useCart();
    const inCart = items[card.id] ?? 0;
    const maxReached = inCart >= card.availableQuantity;
    const rarityDot = ((_a = RARITY_DEFS.find((r2) => r2.code === card.rarity)) == null ? void 0 : _a.dot) ?? "bg-neutral-400";
    const badge = arrivalBadge(card);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group relative flex flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white transition hover:border-neutral-400 hover:shadow-lg", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative aspect-card w-full overflow-hidden bg-neutral-100", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onOpen, className: "block h-full w-full", children: card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: card.imageUrl,
            alt: displayName(card),
            loading: "lazy",
            className: "h-full w-full object-cover transition duration-200 group-hover:scale-[1.03]"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-full items-center justify-center p-4 text-center text-sm text-neutral-400", children: displayName(card) }) }),
        card.foil && card.imageUrl && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-overlay", "aria-hidden": true }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pointer-events-none absolute left-1.5 top-1.5 flex flex-col items-start gap-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language }),
          card.foil && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-badge rounded-md px-1.5 py-0.5 text-[10px] font-bold text-neutral-900 shadow-sm", children: "✦ FOIL" }),
          card.secondHand && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded-md bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-amber-900 shadow-sm", children: t("card.secondHand") }),
          badge === "new" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded-md bg-indigo-600 px-1.5 py-0.5 text-[10px] font-bold text-white shadow-sm", children: t("card.badge.new") }),
          badge === "restock" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded-md bg-emerald-600 px-1.5 py-0.5 text-[10px] font-bold text-white shadow-sm", children: t("card.badge.restock") })
        ] }),
        inCart > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "pointer-events-none absolute right-1.5 top-1.5 flex h-6 min-w-6 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-bold text-white shadow", children: inCart }),
        (versionCount ?? 0) > 1 && onOpenVersions && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            onClick: onOpenVersions,
            title: t("card.allVersions"),
            className: "absolute bottom-1.5 left-1.5 rounded-md border border-neutral-200 bg-white/90 px-1.5 py-0.5 text-[10px] font-semibold text-neutral-700 shadow-sm backdrop-blur-sm transition hover:border-indigo-400 hover:text-indigo-700",
            children: [
              "⧉ ",
              versionCount,
              " versions"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-1 flex-col gap-1 p-2.5", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: onOpen, className: "text-left", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "truncate text-sm font-medium text-neutral-900", title: displayName(card), children: displayName(card) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5 text-xs text-neutral-500", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `h-2 w-2 shrink-0 rounded-full ${rarityDot}`, title: rarityLabel(card.rarity) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate", children: [
              card.expansionCode,
              " · #",
              card.collectorNumber
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto shrink-0", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ManaCost, { manaCost: card.manaCost }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex items-center justify-between pt-1.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-sm font-bold text-neutral-900", children: formatPrice(card.price) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-[11px] text-neutral-500", children: t("card.inStock", { count: card.availableQuantity }) })
          ] }),
          inCart > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-9 items-center rounded-lg border border-neutral-300 bg-white", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: () => setQty(card, inCart - 1),
                title: inCart === 1 ? t("cart.removeAll") : t("cart.removeOne"),
                className: "px-2 text-neutral-600 hover:text-red-600",
                children: "−"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-5 text-center text-sm font-semibold", children: inCart }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: () => add(card, 1),
                disabled: maxReached,
                title: maxReached ? t("cart.maxReached") : t("cart.addOne"),
                className: "px-2 text-neutral-600 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-30",
                children: "+"
              }
            )
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => add(card, 1),
              title: t("cart.add"),
              className: "flex h-9 w-9 items-center justify-center rounded-lg bg-neutral-900 text-white transition hover:bg-indigo-600",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 5v14M5 12h14", strokeLinecap: "round" }) })
            }
          )
        ] })
      ] })
    ] });
  }
  function CardRow({ card, onOpen, versionCount, onOpenVersions }) {
    var _a;
    const { items, add, setQty } = useCart();
    const inCart = items[card.id] ?? 0;
    const maxReached = inCart >= card.availableQuantity;
    const rarityDot = ((_a = RARITY_DEFS.find((r2) => r2.code === card.rarity)) == null ? void 0 : _a.dot) ?? "bg-neutral-400";
    const badge = arrivalBadge(card);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3 border-b border-neutral-200 bg-white px-2 py-1.5 transition hover:bg-neutral-50", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onOpen, className: "relative block h-14 w-10 shrink-0 overflow-hidden rounded bg-neutral-100", children: card.imageUrl && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: card.imageUrl, alt: displayName(card), loading: "lazy", className: "h-full w-full object-cover" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: onOpen, className: "min-w-0 flex-1 text-left", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "truncate text-sm font-medium text-neutral-900", title: displayName(card), children: displayName(card) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language }),
          card.foil && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-badge shrink-0 rounded px-1 py-px text-[9px] font-bold text-neutral-900", children: "✦" }),
          badge === "new" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 rounded bg-indigo-600 px-1 py-px text-[9px] font-bold text-white", children: "🆕" }),
          badge === "restock" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 rounded bg-emerald-600 px-1 py-px text-[9px] font-bold text-white", children: "↺" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5 text-xs text-neutral-500", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `h-2 w-2 shrink-0 rounded-full ${rarityDot}`, title: rarityLabel(card.rarity) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate", children: [
            card.expansionCode,
            " · #",
            card.collectorNumber
          ] })
        ] })
      ] }),
      (versionCount ?? 0) > 1 && onOpenVersions && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: onOpenVersions,
          title: t("card.allVersions"),
          className: "shrink-0 rounded-md border border-neutral-200 bg-white px-1.5 py-0.5 text-[10px] font-semibold text-neutral-600 transition hover:border-indigo-400 hover:text-indigo-700",
          children: [
            "⧉ ",
            versionCount,
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hidden sm:inline", children: " versions" })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hidden shrink-0 sm:block", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ManaCost, { manaCost: card.manaCost }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hidden w-16 shrink-0 text-right text-xs text-neutral-500 md:block", children: t("card.inStock", { count: card.availableQuantity }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-16 shrink-0 text-right text-sm font-bold text-neutral-900", children: formatPrice(card.price) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-20 shrink-0 text-right", children: inCart > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "inline-flex h-8 items-center rounded-lg border border-neutral-300 bg-white", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => setQty(card, inCart - 1),
            title: inCart === 1 ? t("cart.removeAll") : t("cart.removeOne"),
            className: "px-1.5 text-neutral-600 hover:text-red-600",
            children: "−"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-5 text-center text-sm font-semibold", children: inCart }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => add(card, 1),
            disabled: maxReached,
            title: maxReached ? t("cart.maxReached") : t("cart.addOne"),
            className: "px-1.5 text-neutral-600 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-30",
            children: "+"
          }
        )
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: () => add(card, 1),
          title: t("cart.add"),
          className: "inline-flex h-8 w-8 items-center justify-center rounded-lg bg-neutral-900 text-white transition hover:bg-indigo-600",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 5v14M5 12h14", strokeLinecap: "round" }) })
        }
      ) })
    ] });
  }
  const PROXY_BASE = "/apps/nevermint";
  const NODES_QUERY = (
    /* GraphQL */
    `
  query SealedOffers($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        handle
        featuredImage {
          url(transform: { maxWidth: 320 })
        }
        variants(first: 1) {
          nodes {
            id
            availableForSale
            price {
              amount
            }
          }
        }
      }
    }
  }
`
  );
  const numericId = (gid) => String(gid.split("/").pop());
  const cache = /* @__PURE__ */ new Map();
  function fetchSealedOffers(stockId) {
    const key = String(stockId);
    let pending = cache.get(key);
    if (!pending) {
      pending = load(stockId).catch(() => []);
      cache.set(key, pending);
    }
    return pending;
  }
  async function load(stockId) {
    var _a, _b, _c, _d;
    const params = new URLSearchParams({ stock: String(stockId) });
    const res = await fetch(`${PROXY_BASE}/deck/sealed?${params}`, { headers: { Accept: "application/json" } });
    if (!res.ok) return [];
    const data = await res.json();
    const wanted = /* @__PURE__ */ new Map();
    for (const d of data.decks) wanted.set(d.productId, { kind: "deck", foil: d.foil });
    for (const b of data.boosters) if (!wanted.has(b.productId)) wanted.set(b.productId, { kind: b.kind, foil: false });
    if (!wanted.size) return [];
    const ids = [...wanted.keys()].slice(0, 250).map((id2) => `gid://shopify/Product/${id2}`);
    const live = await storefrontQuery(NODES_QUERY, { ids });
    const offers = [];
    for (const node of (live == null ? void 0 : live.nodes) ?? []) {
      const variant = (_b = (_a = node == null ? void 0 : node.variants) == null ? void 0 : _a.nodes) == null ? void 0 : _b[0];
      if (!node || !(variant == null ? void 0 : variant.availableForSale)) continue;
      const meta = wanted.get(numericId(node.id));
      if (!meta) continue;
      offers.push({
        productId: numericId(node.id),
        kind: meta.kind,
        foil: meta.foil,
        title: node.title,
        url: shopPath(`/products/${node.handle}`),
        imageUrl: ((_c = node.featuredImage) == null ? void 0 : _c.url) ?? null,
        variantId: Number(numericId(variant.id)),
        price: Number(((_d = variant.price) == null ? void 0 : _d.amount) ?? 0)
      });
    }
    const rank = { deck: 0, play: 1, collector: 2 };
    return offers.sort((a, b) => rank[a.kind] - rank[b.kind] || a.price - b.price);
  }
  async function addSealedToCart(variantId) {
    const res = await fetch(shopPath("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error(`Panier Shopify : HTTP ${res.status}`);
  }
  function SynergyRow({
    card,
    cardsById,
    onOpenCard
  }) {
    var _a;
    const { items, add, setQty } = useCart();
    const nameIndex = reactExports.useMemo(() => buildNameIndex$1(cardsById.values()), [cardsById]);
    if (!((_a = card.synergies) == null ? void 0 : _a.length)) return null;
    const sorted = [...card.synergies].sort((a, b) => {
      const aStock = resolveSynergyCard(a, cardsById, nameIndex) !== void 0;
      const bStock = resolveSynergyCard(b, cardsById, nameIndex) !== void 0;
      return Number(bStock) - Number(aStock) || b.score - a.score;
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-t border-neutral-200 bg-neutral-50 px-4 py-2.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: [
        t("card.synergies"),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-1.5 font-normal normal-case", children: t("card.synergiesSource") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "-mx-1 flex snap-x gap-2.5 overflow-x-auto px-1 pb-1", children: sorted.map((synergy) => {
        const stockCard = resolveSynergyCard(synergy, cardsById, nameIndex);
        const label = synergy.nameFr || synergy.name;
        if (!stockCard) {
          return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-[5.5rem] shrink-0 snap-start", children: [
            synergy.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: synergy.imageUrl,
                alt: label,
                loading: "lazy",
                className: "w-full rounded-lg opacity-40 grayscale"
              }
            ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex aspect-card w-full items-center justify-center rounded-lg bg-neutral-200 p-1 text-center text-[10px] text-neutral-400", children: label }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1.5 truncate text-[11px] font-medium text-neutral-400", title: label, children: label }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-[10px] text-neutral-400", children: t("card.unavailable") })
          ] }, synergy.name);
        }
        const inCart = items[stockCard.id] ?? 0;
        const maxReached = inCart >= stockCard.availableQuantity;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "w-[6.5rem] shrink-0 snap-start rounded-lg border border-neutral-200 bg-white p-1.5 shadow-sm transition hover:border-indigo-400",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: () => onOpenCard(stockCard.id), className: "relative block w-full", children: [
                synergy.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: synergy.imageUrl, alt: label, loading: "lazy", className: "w-full rounded-md" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex aspect-card w-full items-center justify-center rounded-md bg-neutral-200 p-1 text-center text-[10px] text-neutral-500", children: label }),
                inCart > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-[11px] font-bold text-white shadow", children: inCart })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => onOpenCard(stockCard.id),
                  className: "mt-1.5 block w-full truncate text-left text-[11px] font-medium text-neutral-800 hover:text-indigo-700",
                  title: label,
                  children: label
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-0.5 flex items-center justify-between gap-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "whitespace-nowrap text-xs font-bold text-neutral-900", children: formatPrice(stockCard.price) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "truncate text-[10px] text-emerald-700", children: t("card.inStock", { count: stockCard.availableQuantity }) })
                ] }),
                inCart > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-7 shrink-0 items-center rounded-md border border-neutral-300 bg-white", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      onClick: () => setQty(stockCard, inCart - 1),
                      title: inCart === 1 ? t("cart.removeAll") : t("cart.removeOne"),
                      className: "px-1 text-neutral-600 hover:text-red-600",
                      children: "−"
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-3.5 text-center text-[11px] font-semibold", children: inCart }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      onClick: () => add(stockCard, 1),
                      disabled: maxReached,
                      title: maxReached ? t("cart.maxReached") : t("cart.addOne"),
                      className: "px-1 text-neutral-600 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-30",
                      children: "+"
                    }
                  )
                ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: () => add(stockCard, 1),
                    title: t("cart.add"),
                    className: "flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-neutral-900 text-white transition hover:bg-indigo-600",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 5v14M5 12h14", strokeLinecap: "round" }) })
                  }
                )
              ] })
            ]
          },
          synergy.name
        );
      }) })
    ] });
  }
  function SealedRow({ card }) {
    const [offers, setOffers] = reactExports.useState([]);
    const [added, setAdded] = reactExports.useState({});
    reactExports.useEffect(() => {
      let cancelled = false;
      setOffers([]);
      fetchSealedOffers(card.id).then((list) => {
        if (!cancelled) setOffers(list);
      });
      return () => {
        cancelled = true;
      };
    }, [card.id]);
    if (!offers.length) return null;
    const hasBooster = offers.some((o) => o.kind !== "deck");
    const add = (offer) => {
      setAdded((prev) => ({ ...prev, [offer.productId]: "pending" }));
      addSealedToCart(offer.variantId).then(
        () => {
          setAdded((prev) => ({ ...prev, [offer.productId]: "done" }));
          void refreshThemeCartBubble();
        },
        () => setAdded((prev) => ({ ...prev, [offer.productId]: "error" }))
      );
    };
    const kindLabel = (o) => o.kind === "deck" ? t(o.foil ? "sealed.inDeckFoil" : "sealed.inDeck") : t(o.kind === "collector" ? "sealed.inCollector" : "sealed.inBooster");
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-t border-neutral-200 px-4 py-2.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: t("sealed.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "-mx-1 flex snap-x gap-2.5 overflow-x-auto px-1 pb-1", children: offers.map((offer) => {
        const state = added[offer.productId];
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "flex w-[9rem] shrink-0 snap-start flex-col rounded-lg border border-neutral-200 bg-white p-1.5 shadow-sm transition hover:border-indigo-400",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: offer.url, className: "block", children: offer.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: offer.imageUrl, alt: offer.title, loading: "lazy", className: "aspect-square w-full rounded-md object-contain" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex aspect-square w-full items-center justify-center rounded-md bg-neutral-100 p-1 text-center text-[10px] text-neutral-500", children: offer.title }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "p",
                {
                  className: `mt-1.5 text-[10px] font-semibold ${offer.kind === "deck" ? "text-emerald-700" : "text-indigo-700"}`,
                  children: kindLabel(offer)
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  href: offer.url,
                  className: "line-clamp-2 text-[11px] font-medium leading-snug text-neutral-800 hover:text-indigo-700",
                  title: offer.title,
                  children: offer.title
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex items-center justify-between gap-1 pt-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "whitespace-nowrap text-xs font-bold text-neutral-900", children: formatPrice(offer.price) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: () => add(offer),
                    disabled: state === "pending" || state === "done",
                    title: t("sealed.add"),
                    className: `flex h-7 shrink-0 items-center justify-center rounded-md px-2 text-[11px] font-semibold text-white transition ${state === "done" ? "bg-emerald-600" : "bg-neutral-900 hover:bg-indigo-600"} disabled:cursor-default`,
                    children: state === "done" ? t("sealed.added") : /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 5v14M5 12h14", strokeLinecap: "round" }) })
                  }
                )
              ] }),
              state === "error" && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-[10px] text-red-600", children: t("cart.error.title") })
            ]
          },
          offer.productId
        );
      }) }),
      hasBooster && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-[10px] text-neutral-400", children: t("sealed.boosterNote") })
    ] });
  }
  function CardText({ card }) {
    const [lang, setLang] = reactExports.useState(card.textFr ? "fr" : "en");
    const text = lang === "fr" ? card.textFr : card.textEn;
    if (!card.textFr && !card.textEn) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-lg bg-neutral-50 p-2.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-1 flex items-center gap-1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mr-1 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: t("card.oracle") }),
        card.textFr && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => setLang("fr"),
            className: `rounded px-1.5 py-0.5 text-xs font-bold ${lang === "fr" ? "bg-blue-700 text-white" : "text-neutral-400 hover:text-neutral-700"}`,
            children: "FR"
          }
        ),
        card.textEn && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => setLang("en"),
            className: `rounded px-1.5 py-0.5 text-xs font-bold ${lang === "en" ? "bg-red-700 text-white" : "text-neutral-400 hover:text-neutral-700"}`,
            children: "EN"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "max-h-32 overflow-y-auto whitespace-pre-line text-sm leading-snug text-neutral-800", children: text })
    ] });
  }
  function CardModal({
    card,
    cardsById,
    onClose,
    onPrev,
    onNext,
    onOpenCard,
    versionCount,
    onOpenVersions
  }) {
    var _a, _b;
    const { items, add } = useCart();
    const [qty, setQty] = reactExports.useState(1);
    const [showBack, setShowBack] = reactExports.useState(false);
    const inCart = items[card.id] ?? 0;
    const remaining = Math.max(0, card.availableQuantity - inCart);
    reactExports.useEffect(() => {
      setQty(1);
      setShowBack(false);
    }, [card.id]);
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape") onClose();
        if (e.key === "ArrowLeft" && onPrev) onPrev();
        if (e.key === "ArrowRight" && onNext) onNext();
      };
      window.addEventListener("keydown", handler);
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
      return () => {
        window.removeEventListener("keydown", handler);
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      };
    }, [onClose, onPrev, onNext]);
    const wrapperRef = reactExports.useRef(null);
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) onClose();
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, [onClose]);
    const imgSrc = showBack && card.imageUrlBack ? card.imageUrlBack : card.imageUrl;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: wrapperRef,
        className: "fixed inset-0 z-50 flex items-center justify-center p-0 sm:p-4",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60 backdrop-blur-sm", onClick: onClose }),
          onPrev && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: onPrev,
              className: "absolute left-2 z-10 hidden h-12 w-12 items-center justify-center rounded-full bg-white/90 text-2xl text-neutral-700 shadow hover:bg-white sm:flex",
              "aria-label": t("card.prev"),
              children: "‹"
            }
          ),
          onNext && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: onNext,
              className: "absolute right-2 z-10 hidden h-12 w-12 items-center justify-center rounded-full bg-white/90 text-2xl text-neutral-700 shadow hover:bg-white sm:flex",
              "aria-label": t("card.next"),
              children: "›"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative z-10 flex h-full max-h-full w-full max-w-5xl flex-col overflow-y-auto rounded-none bg-white shadow-2xl sm:h-auto sm:rounded-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: onClose,
                className: "absolute right-3 top-3 z-20 flex h-8 w-8 items-center justify-center rounded-full bg-neutral-100 text-neutral-500 hover:bg-neutral-200",
                "aria-label": t("card.close"),
                children: "✕"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col sm:min-h-[37rem] sm:flex-row", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex shrink-0 items-start justify-center bg-neutral-100 p-4 sm:w-1/2 sm:p-6", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative w-full max-w-[13rem] sm:max-w-[19rem]", children: [
                imgSrc ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "relative block", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "img",
                    {
                      src: largeImage(imgSrc),
                      alt: displayName(card),
                      className: "w-full rounded-[4.5%] shadow-xl"
                    }
                  ),
                  card.foil && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-overlay rounded-[4.5%]", "aria-hidden": true })
                ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex aspect-card items-center justify-center rounded-xl bg-neutral-200 text-neutral-400", children: t("card.noImage") }),
                card.imageUrlBack && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "button",
                  {
                    onClick: () => setShowBack((v2) => !v2),
                    className: "absolute bottom-2 left-1/2 -translate-x-1/2 rounded-full bg-neutral-900/85 px-3 py-1.5 text-xs font-medium text-white hover:bg-neutral-700",
                    children: [
                      "⟳ ",
                      showBack ? t("card.front") : t("card.back")
                    ]
                  }
                )
              ] }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-1 flex-col gap-2.5 p-4 sm:gap-3.5 sm:px-6 sm:py-5", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2 pr-8", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-lg font-bold text-neutral-900", children: displayName(card) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ManaCost, { manaCost: card.manaCost, size: "md" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language, size: "md" })
                  ] }),
                  card.nameFr && card.nameFr !== card.name && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-neutral-500", children: card.name })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("dl", { className: "grid grid-cols-2 gap-x-3 gap-y-1 text-sm sm:gap-y-1.5", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.expansion") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("dd", { className: "text-neutral-900", children: [
                    card.expansion,
                    card.expansionCode !== card.expansion && ` (${card.expansionCode})`,
                    " · #",
                    card.collectorNumber
                  ] }),
                  card.typeLine && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.type") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { className: "text-neutral-900", children: card.typeLine })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.rarity") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { className: "text-neutral-900", children: rarityLabel(card.rarity) }),
                  (((_a = card.keywords) == null ? void 0 : _a.length) ?? 0) > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.keywords") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { className: "flex flex-wrap gap-1", children: card.keywords.map((keyword) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "span",
                      {
                        title: keyword,
                        className: "rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-800",
                        children: keywordLabel(keyword)
                      },
                      keyword
                    )) })
                  ] }),
                  (((_b = card.legalities) == null ? void 0 : _b.length) ?? 0) > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.formats") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { className: "flex flex-wrap gap-1", children: FORMAT_DEFS.filter((f2) => card.legalities.includes(f2.code)).map((f2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "span",
                      {
                        className: "rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800",
                        children: f2.label
                      },
                      f2.code
                    )) })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.language") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.finish") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { className: "text-neutral-900", children: card.foil ? "✦ Foil" : t("card.finishNormal") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { className: "text-neutral-500", children: t("card.condition") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("dd", { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded bg-emerald-100 px-1.5 py-0.5 text-xs font-semibold text-emerald-800", children: card.condition }),
                    card.secondHand && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-1.5 rounded bg-amber-100 px-1.5 py-0.5 text-xs font-semibold text-amber-900", children: t("card.secondHand") })
                  ] })
                ] }),
                card.secondHand && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs leading-snug text-neutral-500", children: t("card.secondHandNote") }),
                (versionCount ?? 0) > 1 && onOpenVersions && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: onOpenVersions,
                    className: "self-start rounded-lg border border-neutral-300 px-3 py-1.5 text-sm font-medium text-neutral-700 transition hover:border-indigo-400 hover:text-indigo-700",
                    children: t("card.versions", { count: versionCount ?? 0 })
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(CardText, { card }, card.id),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sticky bottom-0 z-10 -mx-4 mt-auto space-y-2.5 border-t border-neutral-200 bg-white px-4 pb-3 pt-3 sm:-mx-6 sm:px-6", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-baseline justify-between", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-bold text-neutral-900", children: formatPrice(card.price) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-500", children: t("card.inStock", { count: card.availableQuantity }) })
                  ] }),
                  inCart > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg bg-indigo-50 px-3 py-2 text-sm text-indigo-800", children: t("card.inCart", { count: inCart }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center rounded-lg border border-neutral-300", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => setQty((q2) => Math.max(1, q2 - 1)),
                          disabled: qty <= 1,
                          className: "px-3 py-1.5 text-neutral-600 hover:bg-neutral-100 disabled:opacity-40",
                          children: "−"
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-10 text-center text-sm font-semibold", children: qty }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => setQty((q2) => Math.min(remaining, q2 + 1)),
                          disabled: qty >= remaining,
                          className: "px-3 py-1.5 text-neutral-600 hover:bg-neutral-100 disabled:opacity-40",
                          children: "+"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        onClick: () => {
                          add(card, qty);
                          setQty(1);
                        },
                        disabled: remaining === 0,
                        className: "flex-1 rounded-lg bg-neutral-900 py-2 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-400",
                        children: remaining === 0 ? t("cart.maxReached") : t("cart.add")
                      }
                    )
                  ] }),
                  card.scryfallId && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      href: `https://scryfall.com/card/${card.scryfallId}`,
                      target: "_blank",
                      rel: "noreferrer",
                      className: "block text-xs text-neutral-400 underline-offset-2 hover:text-neutral-700 hover:underline",
                      children: t("card.scryfall")
                    }
                  )
                ] })
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SealedRow, { card }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SynergyRow, { card, cardsById, onOpenCard }),
            (onPrev || onNext) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex gap-2 border-t border-neutral-200 p-3 sm:hidden", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: onPrev ?? void 0,
                  disabled: !onPrev,
                  className: "flex-1 rounded-full border border-neutral-300 py-2 text-sm text-neutral-700 disabled:opacity-30",
                  children: t("card.previousShort")
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: onNext ?? void 0,
                  disabled: !onNext,
                  className: "flex-1 rounded-full border border-neutral-300 py-2 text-sm text-neutral-700 disabled:opacity-30",
                  children: t("card.nextShort")
                }
              )
            ] })
          ] })
        ]
      }
    );
  }
  function VersionsModal({ reference, versions, onClose, onOpenCard }) {
    const sorted = reactExports.useMemo(
      () => [...versions].sort((a, b) => a.price - b.price || b.language.localeCompare(a.language)),
      [versions]
    );
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape") onClose();
      };
      window.addEventListener("keydown", handler);
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
      return () => {
        window.removeEventListener("keydown", handler);
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      };
    }, [onClose]);
    const wrapperRef = reactExports.useRef(null);
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) onClose();
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, [onClose]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: wrapperRef,
        className: "fixed inset-0 z-50 flex items-center justify-center p-0 sm:p-3",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60 backdrop-blur-sm", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative z-10 flex h-full max-h-full w-full max-w-5xl flex-col overflow-hidden rounded-none bg-white shadow-2xl sm:h-auto sm:max-h-[94vh] sm:rounded-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start justify-between gap-3 border-b border-neutral-200 px-4 py-2.5 sm:px-5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "text-lg font-bold text-neutral-900", children: [
                  "Versions de « ",
                  displayName(reference),
                  " »"
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm text-neutral-500", children: [
                  sorted.length,
                  " versions en boutique — extensions, langues, finitions"
                ] })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: onClose,
                  className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutral-100 text-neutral-500 hover:bg-neutral-200",
                  "aria-label": t("card.close"),
                  children: "✕"
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-y-auto p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5", children: sorted.map((card) => /* @__PURE__ */ jsxRuntimeExports.jsx(CardTile, { card, onOpen: () => onOpenCard(card.id) }, card.id)) }) })
          ] })
        ]
      }
    );
  }
  const MAX_SUGGESTIONS = 18;
  function CartSynergies({ cartCards, cardsById, onOpenCard }) {
    const { items, add } = useCart();
    const [open, setOpen] = reactExports.useState(true);
    const nameIndex = reactExports.useMemo(() => buildNameIndex$1(cardsById.values()), [cardsById]);
    const suggestions = reactExports.useMemo(() => {
      var _a, _b;
      const cartNames = /* @__PURE__ */ new Set();
      for (const card of cartCards) {
        cartNames.add(card.name);
        if (card.nameFr) cartNames.add(card.nameFr);
      }
      const synergiesByCardName = /* @__PURE__ */ new Map();
      for (const c of cardsById.values()) {
        if (((_a = c.synergies) == null ? void 0 : _a.length) && !synergiesByCardName.has(c.name)) synergiesByCardName.set(c.name, c.synergies);
      }
      const byName = /* @__PURE__ */ new Map();
      for (const card of cartCards) {
        const synergies = ((_b = card.synergies) == null ? void 0 : _b.length) ? card.synergies : synergiesByCardName.get(card.name) ?? [];
        for (const synergy of synergies) {
          if (cartNames.has(synergy.name) || synergy.nameFr && cartNames.has(synergy.nameFr)) continue;
          if (synergy.stockIds.some((id2) => (items[id2] ?? 0) > 0)) continue;
          const resolved = resolveSynergyCard(synergy, cardsById, nameIndex);
          const stockCard = resolved && resolved.availableQuantity > (items[resolved.id] ?? 0) ? resolved : void 0;
          if (!stockCard) continue;
          const existing = byName.get(synergy.name);
          if (existing) {
            existing.score = Math.max(existing.score, synergy.score);
            existing.withNames.push(displayName(card));
          } else {
            byName.set(synergy.name, {
              name: synergy.name,
              label: synergy.nameFr || synergy.name,
              imageUrl: synergy.imageUrl ?? stockCard.imageUrl,
              stockCard,
              score: synergy.score,
              withNames: [displayName(card)]
            });
          }
        }
      }
      return [...byName.values()].sort((a, b) => b.withNames.length - a.withNames.length || b.score - a.score).slice(0, MAX_SUGGESTIONS);
    }, [cartCards, cardsById, nameIndex, items]);
    if (suggestions.length === 0) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 border-t border-neutral-200 pt-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: () => setOpen((o) => !o),
          className: "flex w-full items-center justify-between rounded-lg bg-neutral-50 px-3 py-2.5 text-left text-sm font-medium text-neutral-800 transition hover:bg-indigo-50 hover:text-indigo-700",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              "✨ En synergie avec votre panier",
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "font-normal text-neutral-500", children: [
                "(",
                suggestions.length,
                ")"
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `text-neutral-400 transition-transform ${open ? "rotate-180" : ""}`, children: "▾" })
          ]
        }
      ),
      open && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 px-1 text-[11px] text-neutral-400", children: "Synergies EDHREC des cartes de votre panier, disponibles en boutique." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-2 grid grid-cols-3 gap-2 pb-2", children: suggestions.map((s) => {
          const withLabel = s.withNames.length > 1 ? `Avec ${s.withNames.length} cartes du panier` : `Avec ${s.withNames[0]}`;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: "flex flex-col rounded-lg border border-neutral-200 bg-white p-1.5 shadow-sm transition hover:border-indigo-400",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: () => onOpenCard(s.stockCard), className: "block w-full", children: s.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: s.imageUrl, alt: s.label, loading: "lazy", className: "w-full rounded-md" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex aspect-card w-full items-center justify-center rounded-md bg-neutral-200 p-1 text-center text-[10px] text-neutral-500", children: s.label }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: () => onOpenCard(s.stockCard),
                    className: "mt-1 block w-full truncate text-left text-[11px] font-medium text-neutral-800 hover:text-indigo-700",
                    title: s.label,
                    children: s.label
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "p",
                  {
                    className: "truncate text-[10px] text-neutral-400",
                    title: s.withNames.length > 1 ? `Avec : ${s.withNames.join(", ")}` : withLabel,
                    children: withLabel
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex items-center justify-between gap-1 pt-1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs font-bold text-neutral-900", children: formatPrice(s.stockCard.price) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      onClick: () => add(s.stockCard, 1),
                      title: t("cart.add"),
                      className: "rounded-md bg-neutral-900 px-2 py-0.5 text-xs font-semibold text-white transition hover:bg-indigo-600",
                      children: "+"
                    }
                  )
                ] })
              ]
            },
            s.name
          );
        }) })
      ] })
    ] });
  }
  function CartDrawer({ cardsById, open, onClose, onOpenCard }) {
    const { items, setQty, remove, clear, totalCount, checkoutUrl, error } = useCart();
    const lines = reactExports.useMemo(
      () => Object.entries(items).map(([id2, qty]) => ({ card: cardsById.get(Number(id2)), qty })).filter((l2) => l2.card !== void 0).sort((a, b) => displayName(a.card).localeCompare(displayName(b.card), "fr")),
      [items, cardsById]
    );
    const cartCards = reactExports.useMemo(() => lines.map((l2) => l2.card), [lines]);
    const total = lines.reduce((s, l2) => s + l2.card.price * l2.qty, 0);
    const [externals, setExternals] = reactExports.useState([]);
    const loadExternals = () => {
      const knownVariants = new Set(
        [...cardsById.values()].map((c) => c.variantId).filter((v2) => v2 != null)
      );
      fetch(shopPath("/cart.js"), { cache: "no-store" }).then((r2) => r2.json()).then((cart) => {
        setExternals(
          cart.items.filter((i) => !knownVariants.has(i.variant_id)).map((i) => ({
            key: i.key,
            title: i.product_title,
            image: i.image,
            url: i.url,
            qty: i.quantity,
            unitCents: i.final_price,
            lineCents: i.final_line_price
          }))
        );
      }).catch(() => {
      });
    };
    reactExports.useEffect(() => {
      if (!open) return;
      loadExternals();
    }, [open, items, cardsById]);
    const setExternalQty = (key, qty) => {
      fetch(shopPath("/cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(() => {
        var _a;
        loadExternals();
        (_a = window.NMCartSync) == null ? void 0 : _a.call(window);
      }).catch(() => {
      });
    };
    const externalCount = externals.reduce((s, l2) => s + l2.qty, 0);
    const externalCents = externals.reduce((s, l2) => s + l2.lineCents, 0);
    const grandTotal = total + externalCents / 100;
    reactExports.useEffect(() => {
      if (!open) return;
      const handler = (e) => {
        if (e.key === "Escape") onClose();
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    }, [open, onClose]);
    if (!open) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "fixed inset-0 z-50",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/50", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("aside", { className: "absolute inset-y-0 right-0 flex w-96 max-w-[92vw] flex-col bg-white shadow-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b border-neutral-200 px-4 py-3", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "font-semibold text-neutral-900", children: [
                t("cart.title"),
                " ",
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm font-normal text-neutral-500", children: [
                  "(",
                  totalCount,
                  " carte",
                  totalCount > 1 ? "s" : "",
                  externalCount > 0 ? ` + ${externalCount} article${externalCount > 1 ? "s" : ""}` : "",
                  ")"
                ] })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onClose, className: "rounded p-1 text-neutral-400 hover:bg-neutral-100", children: "✕" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex-1 overflow-y-auto px-4 py-2", children: [
              lines.length === 0 && externalCount === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-12 text-center text-sm text-neutral-500", children: t("cart.empty") }) : lines.length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "divide-y divide-neutral-200", children: lines.map(({ card, qty }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "flex gap-3 py-3", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: () => onOpenCard(card), className: "shrink-0", children: card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    src: card.imageUrl,
                    alt: "",
                    className: "w-14 rounded-md transition hover:brightness-105"
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "aspect-card w-14 rounded-md bg-neutral-200" }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex min-w-0 flex-1 flex-col", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        onClick: () => onOpenCard(card),
                        className: "truncate text-left text-sm font-medium text-neutral-900 hover:text-indigo-700",
                        title: displayName(card),
                        children: displayName(card)
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: card.language })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-xs text-neutral-500", children: [
                    card.expansionCode,
                    " · ",
                    card.foil ? "✦ Foil · " : "",
                    card.secondHand ? `${t("card.secondHand")} · ` : "",
                    formatPrice(card.price),
                    "/u"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex items-center justify-between pt-1.5", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center rounded-md border border-neutral-300 text-sm", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => setQty(card, qty - 1),
                          className: "px-2 py-0.5 text-neutral-600 hover:bg-neutral-100",
                          children: "−"
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-8 text-center font-medium", children: qty }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => setQty(card, qty + 1),
                          disabled: qty >= card.availableQuantity,
                          className: "px-2 py-0.5 text-neutral-600 hover:bg-neutral-100 disabled:opacity-40",
                          children: "+"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm font-semibold text-neutral-900", children: formatPrice(card.price * qty) }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => remove(card),
                          title: t("cart.removeAll"),
                          className: "rounded p-1 text-neutral-400 hover:bg-neutral-100 hover:text-red-600",
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13", strokeLinecap: "round", strokeLinejoin: "round" }) })
                        }
                      )
                    ] })
                  ] })
                ] })
              ] }, card.id)) }),
              externals.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1 border-t border-neutral-200 pt-2", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "mb-1 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: "Autres articles du panier" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "divide-y divide-neutral-200", children: externals.map((line) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "flex gap-3 py-3", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: line.url, className: "shrink-0", children: line.image ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: line.image, alt: "", className: "h-14 w-14 rounded-md object-contain" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-14 w-14 rounded-md bg-neutral-200" }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0 flex-1", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: line.url, className: "block truncate text-sm font-medium text-neutral-900 hover:text-indigo-700", title: line.title, children: line.title }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-xs text-neutral-500", children: formatPrice(line.unitCents / 100) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1 flex items-center justify-between", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-7 items-center rounded-md border border-neutral-300 bg-white", children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "button",
                          {
                            onClick: () => setExternalQty(line.key, line.qty - 1),
                            title: line.qty === 1 ? t("cart.removeAll") : t("cart.removeOne"),
                            className: "px-2 text-neutral-600 hover:text-red-600",
                            children: "−"
                          }
                        ),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-6 text-center text-sm font-semibold", children: line.qty }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "button",
                          {
                            onClick: () => setExternalQty(line.key, line.qty + 1),
                            title: t("cart.addOne"),
                            className: "px-2 text-neutral-600 hover:text-indigo-600",
                            children: "+"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm font-bold text-neutral-900", children: formatPrice(line.lineCents / 100) })
                    ] })
                  ] })
                ] }, line.key)) })
              ] }),
              lines.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                CartSynergies,
                {
                  cartCards,
                  cardsById,
                  onOpenCard
                }
              )
            ] }),
            (lines.length > 0 || externalCount > 0) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-3 border-t border-neutral-200 p-4", children: [
              error && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700", children: error }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-500", children: "Total TTC" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-bold text-neutral-900", children: formatPrice(grandTotal) })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  className: "w-full rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600",
                  onClick: () => {
                    if (checkoutUrl) {
                      window.location.href = checkoutUrl;
                    } else {
                      alert(t("cart.standaloneNotice"));
                    }
                  },
                  children: "Commander"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: clear,
                  className: "w-full text-center text-xs text-neutral-400 hover:text-red-600",
                  children: t("cart.clear")
                }
              )
            ] })
          ] })
        ]
      }
    );
  }
  const IGNORED_LINES = /^(deck|sideboard|réserve|commander|commandant|companion|compagnon|maybeboard|considering|about|name .*)$/i;
  function parseDecklist(text) {
    const byName = /* @__PURE__ */ new Map();
    for (const rawLine of text.split("\n")) {
      const raw = rawLine.trim();
      if (!raw || raw.startsWith("#") || raw.startsWith("//") || IGNORED_LINES.test(raw)) continue;
      const match = raw.match(/^(\d+)\s*[xX]?\s+(.+)$/);
      if (!match) continue;
      const qty = Number(match[1]);
      if (qty <= 0 || qty > 999) continue;
      const name = match[2].replace(/\s*\([A-Za-z0-9]{2,6}\)\s*[\w-]*\s*$/, "").replace(/\s*\*[A-Za-z]+\*\s*$/, "").replace(/\s*\[[^\]]*\]\s*$/, "").trim();
      if (!name) continue;
      const key = normalize(name);
      const existing = byName.get(key);
      if (existing) existing.qty += qty;
      else byName.set(key, { qty, name, raw });
    }
    return [...byName.values()];
  }
  function buildNameIndex(cards) {
    const index = /* @__PURE__ */ new Map();
    const push = (key, card) => {
      const arr = index.get(key);
      if (arr) {
        if (!arr.includes(card)) arr.push(card);
      } else {
        index.set(key, [card]);
      }
    };
    for (const card of cards) {
      for (const name of [card.name, card.nameFr]) {
        if (!name) continue;
        push(normalize(name), card);
        if (name.includes(" // ")) push(normalize(name.split(" // ")[0]), card);
      }
    }
    return index;
  }
  function matchDecklist(lines, index) {
    return lines.map((line) => {
      const candidates = (index.get(normalize(line.name)) ?? []).filter((c) => c.availableQuantity > 0).sort((a, b) => a.price - b.price);
      return { line, candidates, selected: candidates[0] ?? null };
    });
  }
  function variantLabel(card) {
    return `${card.language.toUpperCase()}${card.foil ? " ✦" : ""} — ${formatPrice(card.price)} (${card.availableQuantity} dispo)`;
  }
  function DeckImport({ cards, open, onClose }) {
    const { add, items } = useCart();
    const [text, setText] = reactExports.useState("");
    const [matches, setMatches] = reactExports.useState([]);
    const [added, setAdded] = reactExports.useState(false);
    const index = reactExports.useMemo(() => buildNameIndex(cards), [cards]);
    reactExports.useEffect(() => {
      setMatches(matchDecklist(parseDecklist(text), index));
      setAdded(false);
    }, [text, index]);
    reactExports.useEffect(() => {
      if (!open) return;
      const handler = (e) => {
        if (e.key === "Escape") onClose();
      };
      window.addEventListener("keydown", handler);
      document.body.style.overflow = "hidden";
      return () => {
        window.removeEventListener("keydown", handler);
        document.body.style.overflow = "";
      };
    }, [open, onClose]);
    if (!open) return null;
    const found = matches.filter((m2) => m2.selected);
    const missing = matches.filter((m2) => !m2.selected);
    const totalCards = found.reduce((s, m2) => s + Math.min(m2.line.qty, m2.selected.availableQuantity), 0);
    const totalPrice = found.reduce(
      (s, m2) => s + m2.selected.price * Math.min(m2.line.qty, m2.selected.availableQuantity),
      0
    );
    const partial = found.filter((m2) => m2.selected.availableQuantity < m2.line.qty);
    const addAll = () => {
      for (const m2 of found) {
        const already = items[m2.selected.id] ?? 0;
        const target = Math.min(already + m2.line.qty, m2.selected.availableQuantity);
        if (target > already) add(m2.selected, target - already);
      }
      setAdded(true);
    };
    const copyMissing = () => {
      var _a;
      void ((_a = navigator.clipboard) == null ? void 0 : _a.writeText(missing.map((m2) => `${m2.line.qty} ${m2.line.name}`).join("\n")));
    };
    const selectVariant = (matchIndex, cardId) => {
      setMatches(
        (prev) => prev.map(
          (m2, i) => i === matchIndex ? { ...m2, selected: m2.candidates.find((c) => c.id === cardId) ?? m2.selected } : m2
        )
      );
      setAdded(false);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "fixed inset-0 z-50 flex items-center justify-center p-0 sm:p-4",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60 backdrop-blur-sm", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative z-10 flex h-full max-h-full w-full max-w-4xl flex-col overflow-hidden rounded-none bg-white shadow-2xl sm:h-auto sm:max-h-[88vh] sm:rounded-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b border-neutral-200 px-5 py-3.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-lg font-bold text-neutral-900", children: t("deck.title") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs text-neutral-500", children: "Collez votre liste (MTGA, Moxfield, texte…) — une carte par ligne, ex. « 4 Sol Ring »" })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: onClose,
                  className: "flex h-8 w-8 items-center justify-center rounded-full bg-neutral-100 text-neutral-500 hover:bg-neutral-200",
                  "aria-label": t("card.close"),
                  children: "✕"
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid min-h-0 flex-1 grid-cols-1 gap-0 sm:grid-cols-2", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "textarea",
                {
                  value: text,
                  onChange: (e) => setText(e.target.value),
                  placeholder: "1 Sol Ring\n1 Arcane Signet\n4 Contresort\n1 Atsushi, le ciel flamboyant (NEO) 134",
                  className: "h-48 w-full resize-none border-b border-neutral-200 p-4 font-mono text-sm outline-none placeholder:text-neutral-300 focus:bg-neutral-50 sm:h-auto sm:border-b-0 sm:border-r"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-0 overflow-y-auto p-4", children: matches.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-10 text-center text-sm text-neutral-400", children: t("deck.resultPlaceholder") }) : /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "space-y-2", children: matches.map(
                (m2, i) => m2.selected ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "rounded-lg border border-neutral-200 p-2.5", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm font-semibold text-neutral-900", children: [
                      m2.line.qty,
                      "× ",
                      displayName(m2.selected)
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: m2.selected.language }),
                    m2.selected.foil && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-badge rounded px-1 py-0.5 text-[9px] font-bold", children: "✦" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto whitespace-nowrap text-sm font-bold", children: formatPrice(m2.selected.price * Math.min(m2.line.qty, m2.selected.availableQuantity)) })
                  ] }),
                  m2.selected.availableQuantity < m2.line.qty && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-xs font-medium text-amber-700", children: t("deck.stockWarning", { available: m2.selected.availableQuantity, asked: m2.line.qty }) }),
                  m2.candidates.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "select",
                    {
                      value: m2.selected.id,
                      onChange: (e) => selectVariant(i, Number(e.target.value)),
                      className: "mt-1.5 w-full rounded-md border border-neutral-200 px-2 py-1 text-xs text-neutral-700 outline-none focus:border-indigo-500",
                      children: m2.candidates.map((c) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: c.id, children: variantLabel(c) }, c.id))
                    }
                  )
                ] }, m2.line.name) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "li",
                  {
                    className: "rounded-lg border border-dashed border-neutral-300 bg-neutral-50 p-2.5 text-sm text-neutral-500",
                    children: [
                      m2.line.qty,
                      "× ",
                      m2.line.name,
                      " ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-red-500", children: "— indisponible" })
                    ]
                  },
                  m2.line.name
                )
              ) }) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-2 border-t border-neutral-200 bg-neutral-50 px-5 py-3.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-sm", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "text-neutral-900", children: totalCards }),
                  " carte",
                  totalCards > 1 ? "s" : "",
                  " disponible",
                  totalCards > 1 ? "s" : "",
                  missing.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-neutral-500", children: [
                    " ",
                    "· ",
                    /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "text-red-500", children: missing.length }),
                    " ligne",
                    missing.length > 1 ? "s" : "",
                    " introuvable",
                    missing.length > 1 ? "s" : ""
                  ] }),
                  partial.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-amber-700", children: [
                    " · ",
                    partial.length,
                    " stock partiel"
                  ] })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-lg font-bold text-neutral-900", children: formatPrice(totalPrice) })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: addAll,
                    disabled: totalCards === 0 || added,
                    className: "flex-1 rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-400",
                    children: added ? t("cart.added") : tn("deck.addCards", totalCards)
                  }
                ),
                missing.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: copyMissing,
                    className: "rounded-lg border border-neutral-300 px-4 py-2.5 text-sm text-neutral-700 hover:border-neutral-500",
                    children: t("deck.copyMissing")
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    );
  }
  const PAGE_SIZE = 60;
  function Shop({ cards }) {
    const initial = reactExports.useMemo(() => paramsToState(new URLSearchParams(window.location.search)), []);
    const [filters, setFilters] = reactExports.useState(initial.filters);
    const [sort, setSort] = reactExports.useState(initial.sort);
    const [view, setView] = reactExports.useState(initial.view);
    const [visibleCount, setVisibleCount] = reactExports.useState(PAGE_SIZE);
    const [modalCardId, setModalCardId] = reactExports.useState(null);
    const [versionsCardId, setVersionsCardId] = reactExports.useState(null);
    const [cartOpen, setCartOpen] = reactExports.useState(false);
    const [deckOpen, setDeckOpen] = reactExports.useState(false);
    const sentinelRef = reactExports.useRef(null);
    const cardsById = reactExports.useMemo(() => new Map(cards.map((c) => [c.id, c])), [cards]);
    const filtered = reactExports.useMemo(() => sortCards(applyFilters(cards, filters), sort), [cards, filters, sort]);
    const versionsByName = reactExports.useMemo(() => {
      const m2 = /* @__PURE__ */ new Map();
      for (const card of cards) {
        const key = versionGroupKey(card);
        const group = m2.get(key);
        if (group) group.push(card);
        else m2.set(key, [card]);
      }
      return m2;
    }, [cards]);
    const versionsOf = (card) => versionsByName.get(versionGroupKey(card)) ?? [card];
    reactExports.useEffect(() => {
      setVisibleCount(PAGE_SIZE);
    }, [filters, sort]);
    reactExports.useEffect(() => {
      syncUrl(filters, sort, view);
    }, [filters, sort, view]);
    reactExports.useEffect(() => {
      window.NMOpenSinglesCart = () => setCartOpen(true);
      const bubble = document.getElementById("cart-icon-bubble");
      if (bubble) {
        const clone = bubble.cloneNode(true);
        bubble.replaceWith(clone);
        clone.addEventListener("click", (e) => {
          e.preventDefault();
          setCartOpen(true);
        });
      }
      return () => {
        delete window.NMOpenSinglesCart;
      };
    }, []);
    reactExports.useEffect(() => {
      const el2 = sentinelRef.current;
      if (!el2) return;
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setVisibleCount((n2) => Math.min(n2 + PAGE_SIZE, filtered.length));
          }
        },
        { rootMargin: "600px" }
      );
      observer.observe(el2);
      return () => observer.disconnect();
    }, [filtered.length]);
    const modalIndex = modalCardId === null ? -1 : filtered.findIndex((c) => c.id === modalCardId);
    const modalCard = modalIndex >= 0 ? filtered[modalIndex] : modalCardId !== null ? cardsById.get(modalCardId) ?? null : null;
    const versionsCard = versionsCardId !== null ? cardsById.get(versionsCardId) ?? null : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "", children: [
      TARGET === "standalone",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FilterBar,
        {
          cards,
          filters,
          onChange: setFilters,
          sort,
          onSort: setSort,
          view,
          onView: setView,
          resultCount: filtered.length,
          onOpenCart: () => setCartOpen(true),
          onOpenDeckImport: () => setDeckOpen(true)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("main", { className: "mx-auto max-w-screen-2xl px-4 py-4", children: [
        filtered.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "py-24 text-center text-neutral-500", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-lg", children: t("catalog.empty") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => setFilters(EMPTY_FILTERS),
              className: "mt-3 text-sm text-indigo-700 hover:underline",
              children: t("catalog.reset")
            }
          )
        ] }) : view === "list" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-hidden rounded-xl border border-neutral-200", children: filtered.slice(0, visibleCount).map((card) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          CardRow,
          {
            card,
            onOpen: () => setModalCardId(card.id),
            versionCount: versionsOf(card).length,
            onOpenVersions: () => setVersionsCardId(card.id)
          },
          card.id
        )) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6", children: filtered.slice(0, visibleCount).map((card) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          CardTile,
          {
            card,
            onOpen: () => setModalCardId(card.id),
            versionCount: versionsOf(card).length,
            onOpenVersions: () => setVersionsCardId(card.id)
          },
          card.id
        )) }),
        visibleCount < filtered.length && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: sentinelRef, className: "py-8 text-center text-sm text-neutral-400", children: "Chargement…" })
      ] }),
      modalCard && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CardModal,
        {
          card: modalCard,
          cardsById,
          onOpenCard: setModalCardId,
          onClose: () => setModalCardId(null),
          onPrev: modalIndex > 0 ? () => setModalCardId(filtered[modalIndex - 1].id) : null,
          onNext: modalIndex >= 0 && modalIndex < filtered.length - 1 ? () => setModalCardId(filtered[modalIndex + 1].id) : null,
          versionCount: versionsOf(modalCard).length,
          onOpenVersions: () => {
            setModalCardId(null);
            setVersionsCardId(modalCard.id);
          }
        }
      ),
      versionsCard && /* @__PURE__ */ jsxRuntimeExports.jsx(
        VersionsModal,
        {
          reference: versionsCard,
          versions: versionsOf(versionsCard),
          onClose: () => setVersionsCardId(null),
          onOpenCard: (cardId) => {
            setVersionsCardId(null);
            setModalCardId(cardId);
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DeckImport, { cards, open: deckOpen, onClose: () => setDeckOpen(false) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CartDrawer,
        {
          cardsById,
          open: cartOpen,
          onClose: () => setCartOpen(false),
          onOpenCard: (card) => {
            setCartOpen(false);
            setModalCardId(card.id);
          }
        }
      )
    ] });
  }
  function App() {
    const [cards, setCards] = reactExports.useState(null);
    const [loadError, setLoadError] = reactExports.useState(null);
    reactExports.useEffect(() => {
      getCatalogAdapter().load((partial) => setCards(partial)).then(setCards, (e) => setLoadError(e instanceof Error ? e.message : t("catalog.error.title")));
    }, []);
    if (loadError) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 py-16 text-center text-neutral-600", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t("catalog.error.body") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-xs text-neutral-400", children: loadError })
      ] });
    }
    if (!cards) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-center gap-3 px-4 py-24 text-neutral-500", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "h-5 w-5 animate-spin rounded-full border-2 border-neutral-300 border-t-indigo-600" }),
        t("catalog.loading")
      ] });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CartProvider, { adapter: getCartAdapter(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Shop, { cards }) });
  }
  const container = document.getElementById("card-shop-root") ?? document.getElementById("root");
  if (container) {
    client.createRoot(container).render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(React.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, {}) })
    );
  }
})();
